const data = {
  "pages": [
    {
      "property": {
        "detectedLanguages": [
          {
            "languageCode": "ne",
            "confidence": 0.45
          },
          {
            "languageCode": "mr",
            "confidence": 0.25
          },
          {
            "languageCode": "hi",
            "confidence": 0.24
          }
        ]
      },
      "width": 1166,
      "height": 1654,
      "blocks": [
        {
          "boundingBox": {
            "vertices": [
              {
                "x": 173,
                "y": 106
              },
              {
                "x": 984,
                "y": 106
              },
              {
                "x": 984,
                "y": 188
              },
              {
                "x": 173,
                "y": 188
              }
            ]
          },
          "paragraphs": [
            {
              "boundingBox": {
                "vertices": [
                  {
                    "x": 173,
                    "y": 106
                  },
                  {
                    "x": 984,
                    "y": 106
                  },
                  {
                    "x": 984,
                    "y": 144
                  },
                  {
                    "x": 173,
                    "y": 144
                  }
                ]
              },
              "words": [
                {
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 173,
                        "y": 106
                      },
                      {
                        "x": 183,
                        "y": 106
                      },
                      {
                        "x": 183,
                        "y": 144
                      },
                      {
                        "x": 173,
                        "y": 144
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 173,
                            "y": 106
                          },
                          {
                            "x": 183,
                            "y": 106
                          },
                          {
                            "x": 183,
                            "y": 144
                          },
                          {
                            "x": 173,
                            "y": 144
                          }
                        ]
                      },
                      "text": ".",
                      "confidence": 0.91
                    }
                  ],
                  "confidence": 0.91
                },
                {
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 183,
                        "y": 106
                      },
                      {
                        "x": 193,
                        "y": 106
                      },
                      {
                        "x": 193,
                        "y": 144
                      },
                      {
                        "x": 183,
                        "y": 144
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 183,
                            "y": 106
                          },
                          {
                            "x": 193,
                            "y": 106
                          },
                          {
                            "x": 193,
                            "y": 144
                          },
                          {
                            "x": 183,
                            "y": 144
                          }
                        ]
                      },
                      "text": ".",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 217,
                        "y": 106
                      },
                      {
                        "x": 244,
                        "y": 106
                      },
                      {
                        "x": 244,
                        "y": 144
                      },
                      {
                        "x": 217,
                        "y": 144
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 217,
                            "y": 106
                          },
                          {
                            "x": 229,
                            "y": 106
                          },
                          {
                            "x": 229,
                            "y": 144
                          },
                          {
                            "x": 217,
                            "y": 144
                          }
                        ]
                      },
                      "text": "O",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 232,
                            "y": 106
                          },
                          {
                            "x": 244,
                            "y": 106
                          },
                          {
                            "x": 244,
                            "y": 144
                          },
                          {
                            "x": 232,
                            "y": 144
                          }
                        ]
                      },
                      "text": "M",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 275,
                        "y": 106
                      },
                      {
                        "x": 351,
                        "y": 106
                      },
                      {
                        "x": 351,
                        "y": 144
                      },
                      {
                        "x": 275,
                        "y": 144
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 275,
                            "y": 106
                          },
                          {
                            "x": 288,
                            "y": 106
                          },
                          {
                            "x": 288,
                            "y": 144
                          },
                          {
                            "x": 275,
                            "y": 144
                          }
                        ]
                      },
                      "text": "n",
                      "confidence": 0.98
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 289,
                            "y": 106
                          },
                          {
                            "x": 306,
                            "y": 106
                          },
                          {
                            "x": 306,
                            "y": 144
                          },
                          {
                            "x": 289,
                            "y": 144
                          }
                        ]
                      },
                      "text": "a",
                      "confidence": 0.99
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 315,
                            "y": 106
                          },
                          {
                            "x": 334,
                            "y": 106
                          },
                          {
                            "x": 334,
                            "y": 144
                          },
                          {
                            "x": 315,
                            "y": 144
                          }
                        ]
                      },
                      "text": "m",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 336,
                            "y": 106
                          },
                          {
                            "x": 351,
                            "y": 106
                          },
                          {
                            "x": 351,
                            "y": 144
                          },
                          {
                            "x": 336,
                            "y": 144
                          }
                        ]
                      },
                      "text": "o",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 360,
                        "y": 106
                      },
                      {
                        "x": 552,
                        "y": 106
                      },
                      {
                        "x": 552,
                        "y": 144
                      },
                      {
                        "x": 360,
                        "y": 144
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 360,
                            "y": 106
                          },
                          {
                            "x": 375,
                            "y": 106
                          },
                          {
                            "x": 375,
                            "y": 144
                          },
                          {
                            "x": 360,
                            "y": 144
                          }
                        ]
                      },
                      "text": "n",
                      "confidence": 0.99
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 379,
                            "y": 106
                          },
                          {
                            "x": 394,
                            "y": 106
                          },
                          {
                            "x": 394,
                            "y": 144
                          },
                          {
                            "x": 379,
                            "y": 144
                          }
                        ]
                      },
                      "text": "A",
                      "confidence": 0.98
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 399,
                            "y": 106
                          },
                          {
                            "x": 414,
                            "y": 106
                          },
                          {
                            "x": 414,
                            "y": 144
                          },
                          {
                            "x": 399,
                            "y": 144
                          }
                        ]
                      },
                      "text": "r",
                      "confidence": 0.99
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 417,
                            "y": 106
                          },
                          {
                            "x": 434,
                            "y": 106
                          },
                          {
                            "x": 434,
                            "y": 144
                          },
                          {
                            "x": 417,
                            "y": 144
                          }
                        ]
                      },
                      "text": "A",
                      "confidence": 0.99
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 441,
                            "y": 106
                          },
                          {
                            "x": 457,
                            "y": 106
                          },
                          {
                            "x": 457,
                            "y": 144
                          },
                          {
                            "x": 441,
                            "y": 144
                          }
                        ]
                      },
                      "text": "y",
                      "confidence": 0.98
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 459,
                            "y": 106
                          },
                          {
                            "x": 471,
                            "y": 106
                          },
                          {
                            "x": 471,
                            "y": 144
                          },
                          {
                            "x": 459,
                            "y": 144
                          }
                        ]
                      },
                      "text": "a",
                      "confidence": 0.99
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 472,
                            "y": 106
                          },
                          {
                            "x": 489,
                            "y": 106
                          },
                          {
                            "x": 489,
                            "y": 144
                          },
                          {
                            "x": 472,
                            "y": 144
                          }
                        ]
                      },
                      "text": "N",
                      "confidence": 1
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 497,
                            "y": 106
                          },
                          {
                            "x": 517,
                            "y": 106
                          },
                          {
                            "x": 517,
                            "y": 144
                          },
                          {
                            "x": 497,
                            "y": 144
                          }
                        ]
                      },
                      "text": "A",
                      "confidence": 0.99
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 524,
                            "y": 106
                          },
                          {
                            "x": 539,
                            "y": 106
                          },
                          {
                            "x": 539,
                            "y": 144
                          },
                          {
                            "x": 524,
                            "y": 144
                          }
                        ]
                      },
                      "text": "y",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 540,
                            "y": 106
                          },
                          {
                            "x": 552,
                            "y": 106
                          },
                          {
                            "x": 552,
                            "y": 144
                          },
                          {
                            "x": 540,
                            "y": 144
                          }
                        ]
                      },
                      "text": "a",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 563,
                        "y": 106
                      },
                      {
                        "x": 943,
                        "y": 106
                      },
                      {
                        "x": 943,
                        "y": 144
                      },
                      {
                        "x": 563,
                        "y": 144
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 563,
                            "y": 106
                          },
                          {
                            "x": 578,
                            "y": 106
                          },
                          {
                            "x": 578,
                            "y": 144
                          },
                          {
                            "x": 563,
                            "y": 144
                          }
                        ]
                      },
                      "text": "a",
                      "confidence": 0.98
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 582,
                            "y": 106
                          },
                          {
                            "x": 597,
                            "y": 106
                          },
                          {
                            "x": 597,
                            "y": 144
                          },
                          {
                            "x": 582,
                            "y": 144
                          }
                        ]
                      },
                      "text": "S",
                      "confidence": 0.99
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 602,
                            "y": 106
                          },
                          {
                            "x": 616,
                            "y": 106
                          },
                          {
                            "x": 616,
                            "y": 144
                          },
                          {
                            "x": 602,
                            "y": 144
                          }
                        ]
                      },
                      "text": "h",
                      "confidence": 0.99
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 617,
                            "y": 106
                          },
                          {
                            "x": 632,
                            "y": 106
                          },
                          {
                            "x": 632,
                            "y": 144
                          },
                          {
                            "x": 617,
                            "y": 144
                          }
                        ]
                      },
                      "text": "T",
                      "confidence": 0.99
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 639,
                            "y": 106
                          },
                          {
                            "x": 658,
                            "y": 106
                          },
                          {
                            "x": 658,
                            "y": 144
                          },
                          {
                            "x": 639,
                            "y": 144
                          }
                        ]
                      },
                      "text": "A",
                      "confidence": 0.99
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 663,
                            "y": 106
                          },
                          {
                            "x": 680,
                            "y": 106
                          },
                          {
                            "x": 680,
                            "y": 144
                          },
                          {
                            "x": 663,
                            "y": 144
                          }
                        ]
                      },
                      "text": "k",
                      "confidence": 0.96
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 684,
                            "y": 106
                          },
                          {
                            "x": 699,
                            "y": 106
                          },
                          {
                            "x": 699,
                            "y": 144
                          },
                          {
                            "x": 684,
                            "y": 144
                          }
                        ]
                      },
                      "text": "S",
                      "confidence": 0.98
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 703,
                            "y": 106
                          },
                          {
                            "x": 717,
                            "y": 106
                          },
                          {
                            "x": 717,
                            "y": 144
                          },
                          {
                            "x": 703,
                            "y": 144
                          }
                        ]
                      },
                      "text": "h",
                      "confidence": 0.99
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 721,
                            "y": 106
                          },
                          {
                            "x": 732,
                            "y": 106
                          },
                          {
                            "x": 732,
                            "y": 144
                          },
                          {
                            "x": 721,
                            "y": 144
                          }
                        ]
                      },
                      "text": "a",
                      "confidence": 0.99
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 733,
                            "y": 106
                          },
                          {
                            "x": 743,
                            "y": 106
                          },
                          {
                            "x": 743,
                            "y": 144
                          },
                          {
                            "x": 733,
                            "y": 144
                          }
                        ]
                      },
                      "text": "r",
                      "confidence": 0.99
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 745,
                            "y": 106
                          },
                          {
                            "x": 762,
                            "y": 106
                          },
                          {
                            "x": 762,
                            "y": 144
                          },
                          {
                            "x": 745,
                            "y": 144
                          }
                        ]
                      },
                      "text": "a",
                      "confidence": 0.99
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 771,
                            "y": 106
                          },
                          {
                            "x": 790,
                            "y": 106
                          },
                          {
                            "x": 790,
                            "y": 144
                          },
                          {
                            "x": 771,
                            "y": 144
                          }
                        ]
                      },
                      "text": "m",
                      "confidence": 0.99
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 792,
                            "y": 106
                          },
                          {
                            "x": 809,
                            "y": 106
                          },
                          {
                            "x": 809,
                            "y": 144
                          },
                          {
                            "x": 792,
                            "y": 144
                          }
                        ]
                      },
                      "text": "A",
                      "confidence": 0.98
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 815,
                            "y": 106
                          },
                          {
                            "x": 832,
                            "y": 106
                          },
                          {
                            "x": 832,
                            "y": 144
                          },
                          {
                            "x": 815,
                            "y": 144
                          }
                        ]
                      },
                      "text": "h",
                      "confidence": 0.99
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 836,
                            "y": 106
                          },
                          {
                            "x": 851,
                            "y": 106
                          },
                          {
                            "x": 851,
                            "y": 144
                          },
                          {
                            "x": 836,
                            "y": 144
                          }
                        ]
                      },
                      "text": "A",
                      "confidence": 0.99
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 854,
                            "y": 106
                          },
                          {
                            "x": 871,
                            "y": 106
                          },
                          {
                            "x": 871,
                            "y": 144
                          },
                          {
                            "x": 854,
                            "y": 144
                          }
                        ]
                      },
                      "text": "t",
                      "confidence": 0.99
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 879,
                            "y": 106
                          },
                          {
                            "x": 894,
                            "y": 106
                          },
                          {
                            "x": 894,
                            "y": 144
                          },
                          {
                            "x": 879,
                            "y": 144
                          }
                        ]
                      },
                      "text": "m",
                      "confidence": 0.99
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 895,
                            "y": 106
                          },
                          {
                            "x": 907,
                            "y": 106
                          },
                          {
                            "x": 907,
                            "y": 144
                          },
                          {
                            "x": 895,
                            "y": 144
                          }
                        ]
                      },
                      "text": "y",
                      "confidence": 0.98
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 911,
                            "y": 106
                          },
                          {
                            "x": 924,
                            "y": 106
                          },
                          {
                            "x": 924,
                            "y": 144
                          },
                          {
                            "x": 911,
                            "y": 144
                          }
                        ]
                      },
                      "text": "a",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 927,
                            "y": 106
                          },
                          {
                            "x": 943,
                            "y": 106
                          },
                          {
                            "x": 943,
                            "y": 144
                          },
                          {
                            "x": 927,
                            "y": 144
                          }
                        ]
                      },
                      "text": "M",
                      "confidence": 0.95
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 967,
                        "y": 106
                      },
                      {
                        "x": 977,
                        "y": 106
                      },
                      {
                        "x": 977,
                        "y": 144
                      },
                      {
                        "x": 967,
                        "y": 144
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 967,
                            "y": 106
                          },
                          {
                            "x": 977,
                            "y": 106
                          },
                          {
                            "x": 977,
                            "y": 144
                          },
                          {
                            "x": 967,
                            "y": 144
                          }
                        ]
                      },
                      "text": ".",
                      "confidence": 0.97
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 974,
                        "y": 106
                      },
                      {
                        "x": 984,
                        "y": 106
                      },
                      {
                        "x": 984,
                        "y": 144
                      },
                      {
                        "x": 974,
                        "y": 144
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedBreak": {
                          "type": "LINE_BREAK"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 974,
                            "y": 106
                          },
                          {
                            "x": 984,
                            "y": 106
                          },
                          {
                            "x": 984,
                            "y": 144
                          },
                          {
                            "x": 974,
                            "y": 144
                          }
                        ]
                      },
                      "text": ".",
                      "confidence": 0.96
                    }
                  ],
                  "confidence": 0.96
                }
              ],
              "confidence": 0.98
            },
            {
              "boundingBox": {
                "vertices": [
                  {
                    "x": 545,
                    "y": 161
                  },
                  {
                    "x": 639,
                    "y": 161
                  },
                  {
                    "x": 639,
                    "y": 188
                  },
                  {
                    "x": 545,
                    "y": 188
                  }
                ]
              },
              "words": [
                {
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 545,
                        "y": 161
                      },
                      {
                        "x": 552,
                        "y": 161
                      },
                      {
                        "x": 552,
                        "y": 188
                      },
                      {
                        "x": 545,
                        "y": 188
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 545,
                            "y": 161
                          },
                          {
                            "x": 552,
                            "y": 161
                          },
                          {
                            "x": 552,
                            "y": 188
                          },
                          {
                            "x": 545,
                            "y": 188
                          }
                        ]
                      },
                      "text": "०",
                      "confidence": 0.34
                    }
                  ],
                  "confidence": 0.34
                },
                {
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 585,
                        "y": 161
                      },
                      {
                        "x": 592,
                        "y": 161
                      },
                      {
                        "x": 592,
                        "y": 188
                      },
                      {
                        "x": 585,
                        "y": 188
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 585,
                            "y": 161
                          },
                          {
                            "x": 592,
                            "y": 161
                          },
                          {
                            "x": 592,
                            "y": 188
                          },
                          {
                            "x": 585,
                            "y": 188
                          }
                        ]
                      },
                      "text": "%",
                      "confidence": 0.73
                    }
                  ],
                  "confidence": 0.73
                },
                {
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 596,
                        "y": 161
                      },
                      {
                        "x": 615,
                        "y": 161
                      },
                      {
                        "x": 615,
                        "y": 188
                      },
                      {
                        "x": 596,
                        "y": 188
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 596,
                            "y": 161
                          },
                          {
                            "x": 604,
                            "y": 161
                          },
                          {
                            "x": 604,
                            "y": 188
                          },
                          {
                            "x": 596,
                            "y": 188
                          }
                        ]
                      },
                      "text": "2",
                      "confidence": 0.17
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 607,
                            "y": 161
                          },
                          {
                            "x": 615,
                            "y": 161
                          },
                          {
                            "x": 615,
                            "y": 188
                          },
                          {
                            "x": 607,
                            "y": 188
                          }
                        ]
                      },
                      "text": "0",
                      "confidence": 0.29
                    }
                  ],
                  "confidence": 0.23
                },
                {
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 615,
                        "y": 161
                      },
                      {
                        "x": 622,
                        "y": 161
                      },
                      {
                        "x": 622,
                        "y": 188
                      },
                      {
                        "x": 615,
                        "y": 188
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 615,
                            "y": 161
                          },
                          {
                            "x": 622,
                            "y": 161
                          },
                          {
                            "x": 622,
                            "y": 188
                          },
                          {
                            "x": 615,
                            "y": 188
                          }
                        ]
                      },
                      "text": "&lt;",
                      "confidence": 0.09
                    }
                  ],
                  "confidence": 0.09
                },
                {
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 632,
                        "y": 161
                      },
                      {
                        "x": 639,
                        "y": 161
                      },
                      {
                        "x": 639,
                        "y": 188
                      },
                      {
                        "x": 632,
                        "y": 188
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedBreak": {
                          "type": "LINE_BREAK"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 632,
                            "y": 161
                          },
                          {
                            "x": 639,
                            "y": 161
                          },
                          {
                            "x": 639,
                            "y": 188
                          },
                          {
                            "x": 632,
                            "y": 188
                          }
                        ]
                      },
                      "text": "&gt;",
                      "confidence": 0.83
                    }
                  ],
                  "confidence": 0.83
                }
              ],
              "confidence": 0.4
            }
          ],
          "blockType": "TEXT",
          "confidence": 0.9
        },
        {
          "boundingBox": {
            "vertices": [
              {
                "x": 235,
                "y": 194
              },
              {
                "x": 926,
                "y": 194
              },
              {
                "x": 926,
                "y": 256
              },
              {
                "x": 235,
                "y": 256
              }
            ]
          },
          "paragraphs": [
            {
              "boundingBox": {
                "vertices": [
                  {
                    "x": 235,
                    "y": 194
                  },
                  {
                    "x": 926,
                    "y": 194
                  },
                  {
                    "x": 926,
                    "y": 256
                  },
                  {
                    "x": 235,
                    "y": 256
                  }
                ]
              },
              "words": [
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 235,
                        "y": 194
                      },
                      {
                        "x": 252,
                        "y": 194
                      },
                      {
                        "x": 252,
                        "y": 256
                      },
                      {
                        "x": 235,
                        "y": 256
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 235,
                            "y": 194
                          },
                          {
                            "x": 252,
                            "y": 194
                          },
                          {
                            "x": 252,
                            "y": 256
                          },
                          {
                            "x": 235,
                            "y": 256
                          }
                        ]
                      },
                      "text": "॥",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 298,
                        "y": 194
                      },
                      {
                        "x": 315,
                        "y": 194
                      },
                      {
                        "x": 315,
                        "y": 256
                      },
                      {
                        "x": 298,
                        "y": 256
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 298,
                            "y": 194
                          },
                          {
                            "x": 315,
                            "y": 194
                          },
                          {
                            "x": 315,
                            "y": 256
                          },
                          {
                            "x": 298,
                            "y": 256
                          }
                        ]
                      },
                      "text": "ॐ",
                      "confidence": 0.94
                    }
                  ],
                  "confidence": 0.94
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 338,
                        "y": 194
                      },
                      {
                        "x": 408,
                        "y": 194
                      },
                      {
                        "x": 408,
                        "y": 256
                      },
                      {
                        "x": 338,
                        "y": 256
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 338,
                            "y": 194
                          },
                          {
                            "x": 364,
                            "y": 194
                          },
                          {
                            "x": 364,
                            "y": 256
                          },
                          {
                            "x": 338,
                            "y": 256
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 370,
                            "y": 194
                          },
                          {
                            "x": 408,
                            "y": 194
                          },
                          {
                            "x": 408,
                            "y": 256
                          },
                          {
                            "x": 370,
                            "y": 256
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 370,
                            "y": 194
                          },
                          {
                            "x": 408,
                            "y": 194
                          },
                          {
                            "x": 408,
                            "y": 256
                          },
                          {
                            "x": 370,
                            "y": 256
                          }
                        ]
                      },
                      "text": "ो",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 420,
                        "y": 194
                      },
                      {
                        "x": 597,
                        "y": 194
                      },
                      {
                        "x": 597,
                        "y": 256
                      },
                      {
                        "x": 420,
                        "y": 256
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 420,
                            "y": 194
                          },
                          {
                            "x": 458,
                            "y": 194
                          },
                          {
                            "x": 458,
                            "y": 256
                          },
                          {
                            "x": 420,
                            "y": 256
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 420,
                            "y": 194
                          },
                          {
                            "x": 458,
                            "y": 194
                          },
                          {
                            "x": 458,
                            "y": 256
                          },
                          {
                            "x": 420,
                            "y": 256
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 464,
                            "y": 194
                          },
                          {
                            "x": 490,
                            "y": 194
                          },
                          {
                            "x": 490,
                            "y": 256
                          },
                          {
                            "x": 464,
                            "y": 256
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 464,
                            "y": 194
                          },
                          {
                            "x": 490,
                            "y": 194
                          },
                          {
                            "x": 490,
                            "y": 256
                          },
                          {
                            "x": 464,
                            "y": 256
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 496,
                            "y": 194
                          },
                          {
                            "x": 521,
                            "y": 194
                          },
                          {
                            "x": 521,
                            "y": 256
                          },
                          {
                            "x": 496,
                            "y": 256
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 527,
                            "y": 194
                          },
                          {
                            "x": 565,
                            "y": 194
                          },
                          {
                            "x": 565,
                            "y": 256
                          },
                          {
                            "x": 527,
                            "y": 256
                          }
                        ]
                      },
                      "text": "ण",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 527,
                            "y": 194
                          },
                          {
                            "x": 565,
                            "y": 194
                          },
                          {
                            "x": 565,
                            "y": 256
                          },
                          {
                            "x": 527,
                            "y": 256
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 571,
                            "y": 194
                          },
                          {
                            "x": 597,
                            "y": 194
                          },
                          {
                            "x": 597,
                            "y": 256
                          },
                          {
                            "x": 571,
                            "y": 256
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 624,
                        "y": 194
                      },
                      {
                        "x": 886,
                        "y": 194
                      },
                      {
                        "x": 886,
                        "y": 256
                      },
                      {
                        "x": 624,
                        "y": 256
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 624,
                            "y": 194
                          },
                          {
                            "x": 644,
                            "y": 194
                          },
                          {
                            "x": 644,
                            "y": 256
                          },
                          {
                            "x": 624,
                            "y": 256
                          }
                        ]
                      },
                      "text": "अ",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 648,
                            "y": 194
                          },
                          {
                            "x": 684,
                            "y": 194
                          },
                          {
                            "x": 684,
                            "y": 256
                          },
                          {
                            "x": 648,
                            "y": 256
                          }
                        ]
                      },
                      "text": "ष",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 648,
                            "y": 194
                          },
                          {
                            "x": 684,
                            "y": 194
                          },
                          {
                            "x": 684,
                            "y": 256
                          },
                          {
                            "x": 648,
                            "y": 256
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 648,
                            "y": 194
                          },
                          {
                            "x": 684,
                            "y": 194
                          },
                          {
                            "x": 684,
                            "y": 256
                          },
                          {
                            "x": 648,
                            "y": 256
                          }
                        ]
                      },
                      "text": "ट",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 648,
                            "y": 194
                          },
                          {
                            "x": 684,
                            "y": 194
                          },
                          {
                            "x": 684,
                            "y": 256
                          },
                          {
                            "x": 648,
                            "y": 256
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 693,
                            "y": 194
                          },
                          {
                            "x": 713,
                            "y": 194
                          },
                          {
                            "x": 713,
                            "y": 256
                          },
                          {
                            "x": 693,
                            "y": 256
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 693,
                            "y": 194
                          },
                          {
                            "x": 713,
                            "y": 194
                          },
                          {
                            "x": 713,
                            "y": 256
                          },
                          {
                            "x": 693,
                            "y": 256
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 693,
                            "y": 194
                          },
                          {
                            "x": 713,
                            "y": 194
                          },
                          {
                            "x": 713,
                            "y": 256
                          },
                          {
                            "x": 693,
                            "y": 256
                          }
                        ]
                      },
                      "text": "ष",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 712,
                            "y": 194
                          },
                          {
                            "x": 733,
                            "y": 194
                          },
                          {
                            "x": 733,
                            "y": 256
                          },
                          {
                            "x": 712,
                            "y": 256
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 743,
                            "y": 194
                          },
                          {
                            "x": 778,
                            "y": 194
                          },
                          {
                            "x": 778,
                            "y": 256
                          },
                          {
                            "x": 743,
                            "y": 256
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 743,
                            "y": 194
                          },
                          {
                            "x": 778,
                            "y": 194
                          },
                          {
                            "x": 778,
                            "y": 256
                          },
                          {
                            "x": 743,
                            "y": 256
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 780,
                            "y": 194
                          },
                          {
                            "x": 816,
                            "y": 194
                          },
                          {
                            "x": 816,
                            "y": 256
                          },
                          {
                            "x": 780,
                            "y": 256
                          }
                        ]
                      },
                      "text": "ह",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 780,
                            "y": 194
                          },
                          {
                            "x": 816,
                            "y": 194
                          },
                          {
                            "x": 816,
                            "y": 256
                          },
                          {
                            "x": 780,
                            "y": 256
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 823,
                            "y": 194
                          },
                          {
                            "x": 886,
                            "y": 194
                          },
                          {
                            "x": 886,
                            "y": 256
                          },
                          {
                            "x": 823,
                            "y": 256
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 823,
                            "y": 194
                          },
                          {
                            "x": 886,
                            "y": 194
                          },
                          {
                            "x": 886,
                            "y": 256
                          },
                          {
                            "x": 823,
                            "y": 256
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 823,
                            "y": 194
                          },
                          {
                            "x": 886,
                            "y": 194
                          },
                          {
                            "x": 886,
                            "y": 256
                          },
                          {
                            "x": 823,
                            "y": 256
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 823,
                            "y": 194
                          },
                          {
                            "x": 886,
                            "y": 194
                          },
                          {
                            "x": 886,
                            "y": 256
                          },
                          {
                            "x": 823,
                            "y": 256
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 823,
                            "y": 194
                          },
                          {
                            "x": 886,
                            "y": 194
                          },
                          {
                            "x": 886,
                            "y": 256
                          },
                          {
                            "x": 823,
                            "y": 256
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 823,
                            "y": 194
                          },
                          {
                            "x": 886,
                            "y": 194
                          },
                          {
                            "x": 886,
                            "y": 256
                          },
                          {
                            "x": 823,
                            "y": 256
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 909,
                        "y": 194
                      },
                      {
                        "x": 926,
                        "y": 194
                      },
                      {
                        "x": 926,
                        "y": 256
                      },
                      {
                        "x": 909,
                        "y": 256
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "LINE_BREAK"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 909,
                            "y": 194
                          },
                          {
                            "x": 926,
                            "y": 194
                          },
                          {
                            "x": 926,
                            "y": 256
                          },
                          {
                            "x": 909,
                            "y": 256
                          }
                        ]
                      },
                      "text": "॥",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                }
              ],
              "confidence": 0.98
            }
          ],
          "blockType": "TEXT",
          "confidence": 0.98
        },
        {
          "boundingBox": {
            "vertices": [
              {
                "x": 547,
                "y": 294
              },
              {
                "x": 630,
                "y": 294
              },
              {
                "x": 630,
                "y": 308
              },
              {
                "x": 547,
                "y": 308
              }
            ]
          },
          "paragraphs": [
            {
              "boundingBox": {
                "vertices": [
                  {
                    "x": 547,
                    "y": 294
                  },
                  {
                    "x": 630,
                    "y": 294
                  },
                  {
                    "x": 630,
                    "y": 308
                  },
                  {
                    "x": 547,
                    "y": 308
                  }
                ]
              },
              "words": [
                {
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 547,
                        "y": 294
                      },
                      {
                        "x": 630,
                        "y": 294
                      },
                      {
                        "x": 630,
                        "y": 308
                      },
                      {
                        "x": 547,
                        "y": 308
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 547,
                            "y": 294
                          },
                          {
                            "x": 554,
                            "y": 294
                          },
                          {
                            "x": 554,
                            "y": 308
                          },
                          {
                            "x": 547,
                            "y": 308
                          }
                        ]
                      },
                      "text": "2",
                      "confidence": 0.05
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 550,
                            "y": 294
                          },
                          {
                            "x": 568,
                            "y": 294
                          },
                          {
                            "x": 568,
                            "y": 308
                          },
                          {
                            "x": 550,
                            "y": 308
                          }
                        ]
                      },
                      "text": "0",
                      "confidence": 0.51
                    },
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 588,
                            "y": 294
                          },
                          {
                            "x": 606,
                            "y": 294
                          },
                          {
                            "x": 606,
                            "y": 308
                          },
                          {
                            "x": 588,
                            "y": 308
                          }
                        ]
                      },
                      "text": "2",
                      "confidence": 0.9
                    },
                    {
                      "property": {
                        "detectedBreak": {
                          "type": "HYPHEN"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 603,
                            "y": 294
                          },
                          {
                            "x": 630,
                            "y": 294
                          },
                          {
                            "x": 630,
                            "y": 308
                          },
                          {
                            "x": 603,
                            "y": 308
                          }
                        ]
                      },
                      "text": "0",
                      "confidence": 0.9
                    }
                  ],
                  "confidence": 0.59
                }
              ],
              "confidence": 0.59
            }
          ],
          "blockType": "TEXT",
          "confidence": 0.59
        },
        {
          "boundingBox": {
            "vertices": [
              {
                "x": 545,
                "y": 314
              },
              {
                "x": 620,
                "y": 314
              },
              {
                "x": 620,
                "y": 368
              },
              {
                "x": 545,
                "y": 368
              }
            ]
          },
          "paragraphs": [
            {
              "boundingBox": {
                "vertices": [
                  {
                    "x": 545,
                    "y": 314
                  },
                  {
                    "x": 620,
                    "y": 314
                  },
                  {
                    "x": 620,
                    "y": 368
                  },
                  {
                    "x": 545,
                    "y": 368
                  }
                ]
              },
              "words": [
                {
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 545,
                        "y": 314
                      },
                      {
                        "x": 560,
                        "y": 314
                      },
                      {
                        "x": 560,
                        "y": 368
                      },
                      {
                        "x": 545,
                        "y": 368
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 545,
                            "y": 314
                          },
                          {
                            "x": 560,
                            "y": 314
                          },
                          {
                            "x": 560,
                            "y": 368
                          },
                          {
                            "x": 545,
                            "y": 368
                          }
                        ]
                      },
                      "text": "०",
                      "confidence": 0.71
                    }
                  ],
                  "confidence": 0.71
                },
                {
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 605,
                        "y": 314
                      },
                      {
                        "x": 620,
                        "y": 314
                      },
                      {
                        "x": 620,
                        "y": 368
                      },
                      {
                        "x": 605,
                        "y": 368
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedBreak": {
                          "type": "LINE_BREAK"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 605,
                            "y": 314
                          },
                          {
                            "x": 620,
                            "y": 314
                          },
                          {
                            "x": 620,
                            "y": 368
                          },
                          {
                            "x": 605,
                            "y": 368
                          }
                        ]
                      },
                      "text": "%",
                      "confidence": 0.32
                    }
                  ],
                  "confidence": 0.32
                }
              ],
              "confidence": 0.51
            }
          ],
          "blockType": "TEXT",
          "confidence": 0.51
        },
        {
          "boundingBox": {
            "vertices": [
              {
                "x": 233,
                "y": 430
              },
              {
                "x": 750,
                "y": 430
              },
              {
                "x": 750,
                "y": 1520
              },
              {
                "x": 233,
                "y": 1520
              }
            ]
          },
          "paragraphs": [
            {
              "boundingBox": {
                "vertices": [
                  {
                    "x": 233,
                    "y": 430
                  },
                  {
                    "x": 750,
                    "y": 430
                  },
                  {
                    "x": 750,
                    "y": 1520
                  },
                  {
                    "x": 233,
                    "y": 1520
                  }
                ]
              },
              "words": [
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 239,
                        "y": 430
                      },
                      {
                        "x": 304,
                        "y": 430
                      },
                      {
                        "x": 304,
                        "y": 464
                      },
                      {
                        "x": 239,
                        "y": 464
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 239,
                            "y": 430
                          },
                          {
                            "x": 265,
                            "y": 430
                          },
                          {
                            "x": 265,
                            "y": 464
                          },
                          {
                            "x": 239,
                            "y": 464
                          }
                        ]
                      },
                      "text": "श",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 239,
                            "y": 430
                          },
                          {
                            "x": 265,
                            "y": 430
                          },
                          {
                            "x": 265,
                            "y": 464
                          },
                          {
                            "x": 239,
                            "y": 464
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 239,
                            "y": 430
                          },
                          {
                            "x": 265,
                            "y": 430
                          },
                          {
                            "x": 265,
                            "y": 464
                          },
                          {
                            "x": 239,
                            "y": 464
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 239,
                            "y": 430
                          },
                          {
                            "x": 265,
                            "y": 430
                          },
                          {
                            "x": 265,
                            "y": 464
                          },
                          {
                            "x": 239,
                            "y": 464
                          }
                        ]
                      },
                      "text": "ी",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 272,
                            "y": 430
                          },
                          {
                            "x": 289,
                            "y": 430
                          },
                          {
                            "x": 289,
                            "y": 464
                          },
                          {
                            "x": 272,
                            "y": 464
                          }
                        ]
                      },
                      "text": "श",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 272,
                            "y": 430
                          },
                          {
                            "x": 289,
                            "y": 430
                          },
                          {
                            "x": 289,
                            "y": 464
                          },
                          {
                            "x": 272,
                            "y": 464
                          }
                        ]
                      },
                      "text": "ु",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 291,
                            "y": 430
                          },
                          {
                            "x": 304,
                            "y": 430
                          },
                          {
                            "x": 304,
                            "y": 464
                          },
                          {
                            "x": 291,
                            "y": 464
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 319,
                        "y": 430
                      },
                      {
                        "x": 384,
                        "y": 430
                      },
                      {
                        "x": 384,
                        "y": 464
                      },
                      {
                        "x": 319,
                        "y": 464
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 319,
                            "y": 430
                          },
                          {
                            "x": 332,
                            "y": 430
                          },
                          {
                            "x": 332,
                            "y": 464
                          },
                          {
                            "x": 319,
                            "y": 464
                          }
                        ]
                      },
                      "text": "उ",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 335,
                            "y": 430
                          },
                          {
                            "x": 359,
                            "y": 430
                          },
                          {
                            "x": 359,
                            "y": 464
                          },
                          {
                            "x": 335,
                            "y": 464
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 335,
                            "y": 430
                          },
                          {
                            "x": 359,
                            "y": 430
                          },
                          {
                            "x": 359,
                            "y": 464
                          },
                          {
                            "x": 335,
                            "y": 464
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 365,
                            "y": 430
                          },
                          {
                            "x": 384,
                            "y": 430
                          },
                          {
                            "x": 384,
                            "y": 464
                          },
                          {
                            "x": 365,
                            "y": 464
                          }
                        ]
                      },
                      "text": "च",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 391,
                        "y": 430
                      },
                      {
                        "x": 400,
                        "y": 430
                      },
                      {
                        "x": 400,
                        "y": 464
                      },
                      {
                        "x": 391,
                        "y": 464
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "EOL_SURE_SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 391,
                            "y": 430
                          },
                          {
                            "x": 400,
                            "y": 430
                          },
                          {
                            "x": 400,
                            "y": 464
                          },
                          {
                            "x": 391,
                            "y": 464
                          }
                        ]
                      },
                      "text": "-",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 237,
                        "y": 470
                      },
                      {
                        "x": 257,
                        "y": 470
                      },
                      {
                        "x": 257,
                        "y": 512
                      },
                      {
                        "x": 237,
                        "y": 512
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 237,
                            "y": 470
                          },
                          {
                            "x": 257,
                            "y": 470
                          },
                          {
                            "x": 257,
                            "y": 512
                          },
                          {
                            "x": 237,
                            "y": 512
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 237,
                            "y": 470
                          },
                          {
                            "x": 257,
                            "y": 470
                          },
                          {
                            "x": 257,
                            "y": 512
                          },
                          {
                            "x": 237,
                            "y": 512
                          }
                        ]
                      },
                      "text": "ि",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 237,
                            "y": 470
                          },
                          {
                            "x": 257,
                            "y": 470
                          },
                          {
                            "x": 257,
                            "y": 512
                          },
                          {
                            "x": 237,
                            "y": 512
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.97
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 279,
                        "y": 470
                      },
                      {
                        "x": 327,
                        "y": 470
                      },
                      {
                        "x": 327,
                        "y": 512
                      },
                      {
                        "x": 279,
                        "y": 512
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 279,
                            "y": 470
                          },
                          {
                            "x": 292,
                            "y": 470
                          },
                          {
                            "x": 292,
                            "y": 512
                          },
                          {
                            "x": 279,
                            "y": 512
                          }
                        ]
                      },
                      "text": "ज",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 296,
                            "y": 470
                          },
                          {
                            "x": 309,
                            "y": 470
                          },
                          {
                            "x": 309,
                            "y": 512
                          },
                          {
                            "x": 296,
                            "y": 512
                          }
                        ]
                      },
                      "text": "प",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 313,
                            "y": 470
                          },
                          {
                            "x": 327,
                            "y": 470
                          },
                          {
                            "x": 327,
                            "y": 512
                          },
                          {
                            "x": 313,
                            "y": 512
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.89
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 313,
                            "y": 470
                          },
                          {
                            "x": 327,
                            "y": 470
                          },
                          {
                            "x": 327,
                            "y": 512
                          },
                          {
                            "x": 313,
                            "y": 512
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.89
                    }
                  ],
                  "confidence": 0.93
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 337,
                        "y": 470
                      },
                      {
                        "x": 404,
                        "y": 470
                      },
                      {
                        "x": 404,
                        "y": 512
                      },
                      {
                        "x": 337,
                        "y": 512
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 337,
                            "y": 470
                          },
                          {
                            "x": 354,
                            "y": 470
                          },
                          {
                            "x": 354,
                            "y": 512
                          },
                          {
                            "x": 337,
                            "y": 512
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.9
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 337,
                            "y": 470
                          },
                          {
                            "x": 354,
                            "y": 470
                          },
                          {
                            "x": 354,
                            "y": 512
                          },
                          {
                            "x": 337,
                            "y": 512
                          }
                        ]
                      },
                      "text": "ु",
                      "confidence": 0.9
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 360,
                            "y": 470
                          },
                          {
                            "x": 388,
                            "y": 470
                          },
                          {
                            "x": 388,
                            "y": 512
                          },
                          {
                            "x": 360,
                            "y": 512
                          }
                        ]
                      },
                      "text": "च",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 360,
                            "y": 470
                          },
                          {
                            "x": 388,
                            "y": 470
                          },
                          {
                            "x": 388,
                            "y": 512
                          },
                          {
                            "x": 360,
                            "y": 512
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 360,
                            "y": 470
                          },
                          {
                            "x": 388,
                            "y": 470
                          },
                          {
                            "x": 388,
                            "y": 512
                          },
                          {
                            "x": 360,
                            "y": 512
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 391,
                            "y": 470
                          },
                          {
                            "x": 404,
                            "y": 470
                          },
                          {
                            "x": 404,
                            "y": 512
                          },
                          {
                            "x": 391,
                            "y": 512
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 391,
                            "y": 470
                          },
                          {
                            "x": 404,
                            "y": 470
                          },
                          {
                            "x": 404,
                            "y": 512
                          },
                          {
                            "x": 391,
                            "y": 512
                          }
                        ]
                      },
                      "text": "े",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.93
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 416,
                        "y": 470
                      },
                      {
                        "x": 456,
                        "y": 470
                      },
                      {
                        "x": 456,
                        "y": 512
                      },
                      {
                        "x": 416,
                        "y": 512
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 416,
                            "y": 470
                          },
                          {
                            "x": 438,
                            "y": 470
                          },
                          {
                            "x": 438,
                            "y": 512
                          },
                          {
                            "x": 416,
                            "y": 512
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 416,
                            "y": 470
                          },
                          {
                            "x": 438,
                            "y": 470
                          },
                          {
                            "x": 438,
                            "y": 512
                          },
                          {
                            "x": 416,
                            "y": 512
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 442,
                            "y": 470
                          },
                          {
                            "x": 456,
                            "y": 470
                          },
                          {
                            "x": 456,
                            "y": 512
                          },
                          {
                            "x": 442,
                            "y": 512
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 472,
                        "y": 470
                      },
                      {
                        "x": 520,
                        "y": 470
                      },
                      {
                        "x": 520,
                        "y": 512
                      },
                      {
                        "x": 472,
                        "y": 512
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 472,
                            "y": 470
                          },
                          {
                            "x": 486,
                            "y": 470
                          },
                          {
                            "x": 486,
                            "y": 512
                          },
                          {
                            "x": 472,
                            "y": 512
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 490,
                            "y": 470
                          },
                          {
                            "x": 503,
                            "y": 470
                          },
                          {
                            "x": 503,
                            "y": 512
                          },
                          {
                            "x": 490,
                            "y": 512
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 507,
                            "y": 470
                          },
                          {
                            "x": 520,
                            "y": 470
                          },
                          {
                            "x": 520,
                            "y": 512
                          },
                          {
                            "x": 507,
                            "y": 512
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 507,
                            "y": 470
                          },
                          {
                            "x": 520,
                            "y": 470
                          },
                          {
                            "x": 520,
                            "y": 512
                          },
                          {
                            "x": 507,
                            "y": 512
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.97
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 528,
                        "y": 470
                      },
                      {
                        "x": 658,
                        "y": 470
                      },
                      {
                        "x": 658,
                        "y": 512
                      },
                      {
                        "x": 528,
                        "y": 512
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 528,
                            "y": 470
                          },
                          {
                            "x": 554,
                            "y": 470
                          },
                          {
                            "x": 554,
                            "y": 512
                          },
                          {
                            "x": 528,
                            "y": 512
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 528,
                            "y": 470
                          },
                          {
                            "x": 554,
                            "y": 470
                          },
                          {
                            "x": 554,
                            "y": 512
                          },
                          {
                            "x": 528,
                            "y": 512
                          }
                        ]
                      },
                      "text": "ि",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 558,
                            "y": 470
                          },
                          {
                            "x": 585,
                            "y": 470
                          },
                          {
                            "x": 585,
                            "y": 512
                          },
                          {
                            "x": 558,
                            "y": 512
                          }
                        ]
                      },
                      "text": "ष",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 558,
                            "y": 470
                          },
                          {
                            "x": 585,
                            "y": 470
                          },
                          {
                            "x": 585,
                            "y": 512
                          },
                          {
                            "x": 558,
                            "y": 512
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 558,
                            "y": 470
                          },
                          {
                            "x": 585,
                            "y": 470
                          },
                          {
                            "x": 585,
                            "y": 512
                          },
                          {
                            "x": 558,
                            "y": 512
                          }
                        ]
                      },
                      "text": "ण",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 558,
                            "y": 470
                          },
                          {
                            "x": 585,
                            "y": 470
                          },
                          {
                            "x": 585,
                            "y": 512
                          },
                          {
                            "x": 558,
                            "y": 512
                          }
                        ]
                      },
                      "text": "ु",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 588,
                            "y": 470
                          },
                          {
                            "x": 602,
                            "y": 470
                          },
                          {
                            "x": 602,
                            "y": 512
                          },
                          {
                            "x": 588,
                            "y": 512
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 606,
                            "y": 470
                          },
                          {
                            "x": 628,
                            "y": 470
                          },
                          {
                            "x": 628,
                            "y": 512
                          },
                          {
                            "x": 606,
                            "y": 512
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 606,
                            "y": 470
                          },
                          {
                            "x": 628,
                            "y": 470
                          },
                          {
                            "x": 628,
                            "y": 512
                          },
                          {
                            "x": 606,
                            "y": 512
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 606,
                            "y": 470
                          },
                          {
                            "x": 628,
                            "y": 470
                          },
                          {
                            "x": 628,
                            "y": 512
                          },
                          {
                            "x": 606,
                            "y": 512
                          }
                        ]
                      },
                      "text": "प",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 631,
                            "y": 470
                          },
                          {
                            "x": 658,
                            "y": 470
                          },
                          {
                            "x": 658,
                            "y": 512
                          },
                          {
                            "x": 631,
                            "y": 512
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 631,
                            "y": 470
                          },
                          {
                            "x": 658,
                            "y": 470
                          },
                          {
                            "x": 658,
                            "y": 512
                          },
                          {
                            "x": 631,
                            "y": 512
                          }
                        ]
                      },
                      "text": "ः",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 663,
                        "y": 470
                      },
                      {
                        "x": 674,
                        "y": 470
                      },
                      {
                        "x": 674,
                        "y": 512
                      },
                      {
                        "x": 663,
                        "y": 512
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "EOL_SURE_SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 663,
                            "y": 470
                          },
                          {
                            "x": 674,
                            "y": 470
                          },
                          {
                            "x": 674,
                            "y": 512
                          },
                          {
                            "x": 663,
                            "y": 512
                          }
                        ]
                      },
                      "text": "।",
                      "confidence": 0.97
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 238,
                        "y": 516
                      },
                      {
                        "x": 372,
                        "y": 516
                      },
                      {
                        "x": 372,
                        "y": 556
                      },
                      {
                        "x": 238,
                        "y": 556
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 238,
                            "y": 516
                          },
                          {
                            "x": 255,
                            "y": 516
                          },
                          {
                            "x": 255,
                            "y": 556
                          },
                          {
                            "x": 238,
                            "y": 556
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 238,
                            "y": 516
                          },
                          {
                            "x": 255,
                            "y": 516
                          },
                          {
                            "x": 255,
                            "y": 556
                          },
                          {
                            "x": 238,
                            "y": 556
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 261,
                            "y": 516
                          },
                          {
                            "x": 282,
                            "y": 516
                          },
                          {
                            "x": 282,
                            "y": 556
                          },
                          {
                            "x": 261,
                            "y": 556
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 261,
                            "y": 516
                          },
                          {
                            "x": 282,
                            "y": 516
                          },
                          {
                            "x": 282,
                            "y": 556
                          },
                          {
                            "x": 261,
                            "y": 556
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 282,
                            "y": 516
                          },
                          {
                            "x": 293,
                            "y": 516
                          },
                          {
                            "x": 293,
                            "y": 556
                          },
                          {
                            "x": 282,
                            "y": 556
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 296,
                            "y": 516
                          },
                          {
                            "x": 325,
                            "y": 516
                          },
                          {
                            "x": 325,
                            "y": 556
                          },
                          {
                            "x": 296,
                            "y": 556
                          }
                        ]
                      },
                      "text": "द",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 296,
                            "y": 516
                          },
                          {
                            "x": 325,
                            "y": 516
                          },
                          {
                            "x": 325,
                            "y": 556
                          },
                          {
                            "x": 296,
                            "y": 556
                          }
                        ]
                      },
                      "text": "ु",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 296,
                            "y": 516
                          },
                          {
                            "x": 325,
                            "y": 516
                          },
                          {
                            "x": 325,
                            "y": 556
                          },
                          {
                            "x": 296,
                            "y": 556
                          }
                        ]
                      },
                      "text": "ः",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 333,
                            "y": 516
                          },
                          {
                            "x": 357,
                            "y": 516
                          },
                          {
                            "x": 357,
                            "y": 556
                          },
                          {
                            "x": 333,
                            "y": 556
                          }
                        ]
                      },
                      "text": "ख",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 333,
                            "y": 516
                          },
                          {
                            "x": 357,
                            "y": 516
                          },
                          {
                            "x": 357,
                            "y": 556
                          },
                          {
                            "x": 333,
                            "y": 556
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 359,
                            "y": 516
                          },
                          {
                            "x": 372,
                            "y": 516
                          },
                          {
                            "x": 372,
                            "y": 556
                          },
                          {
                            "x": 359,
                            "y": 556
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 359,
                            "y": 516
                          },
                          {
                            "x": 372,
                            "y": 516
                          },
                          {
                            "x": 372,
                            "y": 556
                          },
                          {
                            "x": 359,
                            "y": 556
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.96
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 388,
                        "y": 516
                      },
                      {
                        "x": 442,
                        "y": 516
                      },
                      {
                        "x": 442,
                        "y": 556
                      },
                      {
                        "x": 388,
                        "y": 556
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 388,
                            "y": 516
                          },
                          {
                            "x": 401,
                            "y": 516
                          },
                          {
                            "x": 401,
                            "y": 556
                          },
                          {
                            "x": 388,
                            "y": 556
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 404,
                            "y": 516
                          },
                          {
                            "x": 417,
                            "y": 516
                          },
                          {
                            "x": 417,
                            "y": 556
                          },
                          {
                            "x": 404,
                            "y": 556
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 404,
                            "y": 516
                          },
                          {
                            "x": 417,
                            "y": 516
                          },
                          {
                            "x": 417,
                            "y": 556
                          },
                          {
                            "x": 404,
                            "y": 556
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 404,
                            "y": 516
                          },
                          {
                            "x": 417,
                            "y": 516
                          },
                          {
                            "x": 417,
                            "y": 556
                          },
                          {
                            "x": 404,
                            "y": 556
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 404,
                            "y": 516
                          },
                          {
                            "x": 417,
                            "y": 516
                          },
                          {
                            "x": 417,
                            "y": 556
                          },
                          {
                            "x": 404,
                            "y": 556
                          }
                        ]
                      },
                      "text": "े",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 421,
                            "y": 516
                          },
                          {
                            "x": 442,
                            "y": 516
                          },
                          {
                            "x": 442,
                            "y": 556
                          },
                          {
                            "x": 421,
                            "y": 556
                          }
                        ]
                      },
                      "text": "ष",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 421,
                            "y": 516
                          },
                          {
                            "x": 442,
                            "y": 516
                          },
                          {
                            "x": 442,
                            "y": 556
                          },
                          {
                            "x": 421,
                            "y": 556
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 421,
                            "y": 516
                          },
                          {
                            "x": 442,
                            "y": 516
                          },
                          {
                            "x": 442,
                            "y": 556
                          },
                          {
                            "x": 421,
                            "y": 556
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.97
                    }
                  ],
                  "confidence": 0.95
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 448,
                        "y": 516
                      },
                      {
                        "x": 522,
                        "y": 516
                      },
                      {
                        "x": 522,
                        "y": 556
                      },
                      {
                        "x": 448,
                        "y": 556
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 448,
                            "y": 516
                          },
                          {
                            "x": 472,
                            "y": 516
                          },
                          {
                            "x": 472,
                            "y": 556
                          },
                          {
                            "x": 448,
                            "y": 556
                          }
                        ]
                      },
                      "text": "ह",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 448,
                            "y": 516
                          },
                          {
                            "x": 472,
                            "y": 516
                          },
                          {
                            "x": 472,
                            "y": 556
                          },
                          {
                            "x": 448,
                            "y": 556
                          }
                        ]
                      },
                      "text": "ि",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 476,
                            "y": 516
                          },
                          {
                            "x": 500,
                            "y": 516
                          },
                          {
                            "x": 500,
                            "y": 556
                          },
                          {
                            "x": 476,
                            "y": 556
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 476,
                            "y": 516
                          },
                          {
                            "x": 500,
                            "y": 516
                          },
                          {
                            "x": 500,
                            "y": 556
                          },
                          {
                            "x": 476,
                            "y": 556
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 505,
                            "y": 516
                          },
                          {
                            "x": 522,
                            "y": 516
                          },
                          {
                            "x": 522,
                            "y": 556
                          },
                          {
                            "x": 505,
                            "y": 556
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 531,
                        "y": 516
                      },
                      {
                        "x": 561,
                        "y": 516
                      },
                      {
                        "x": 561,
                        "y": 556
                      },
                      {
                        "x": 531,
                        "y": 556
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 531,
                            "y": 516
                          },
                          {
                            "x": 545,
                            "y": 516
                          },
                          {
                            "x": 545,
                            "y": 556
                          },
                          {
                            "x": 531,
                            "y": 556
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 548,
                            "y": 516
                          },
                          {
                            "x": 561,
                            "y": 516
                          },
                          {
                            "x": 561,
                            "y": 556
                          },
                          {
                            "x": 548,
                            "y": 556
                          }
                        ]
                      },
                      "text": "द",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 573,
                        "y": 516
                      },
                      {
                        "x": 584,
                        "y": 516
                      },
                      {
                        "x": 584,
                        "y": 556
                      },
                      {
                        "x": 573,
                        "y": 556
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 573,
                            "y": 516
                          },
                          {
                            "x": 584,
                            "y": 516
                          },
                          {
                            "x": 584,
                            "y": 556
                          },
                          {
                            "x": 573,
                            "y": 556
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 573,
                            "y": 516
                          },
                          {
                            "x": 584,
                            "y": 516
                          },
                          {
                            "x": 584,
                            "y": 556
                          },
                          {
                            "x": 573,
                            "y": 556
                          }
                        ]
                      },
                      "text": "े",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 591,
                        "y": 516
                      },
                      {
                        "x": 653,
                        "y": 516
                      },
                      {
                        "x": 653,
                        "y": 556
                      },
                      {
                        "x": 591,
                        "y": 556
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 591,
                            "y": 516
                          },
                          {
                            "x": 620,
                            "y": 516
                          },
                          {
                            "x": 620,
                            "y": 556
                          },
                          {
                            "x": 591,
                            "y": 556
                          }
                        ]
                      },
                      "text": "प",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 591,
                            "y": 516
                          },
                          {
                            "x": 620,
                            "y": 516
                          },
                          {
                            "x": 620,
                            "y": 556
                          },
                          {
                            "x": 591,
                            "y": 556
                          }
                        ]
                      },
                      "text": "ि",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 624,
                            "y": 516
                          },
                          {
                            "x": 653,
                            "y": 516
                          },
                          {
                            "x": 653,
                            "y": 556
                          },
                          {
                            "x": 624,
                            "y": 556
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.85
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 624,
                            "y": 516
                          },
                          {
                            "x": 653,
                            "y": 516
                          },
                          {
                            "x": 653,
                            "y": 556
                          },
                          {
                            "x": 624,
                            "y": 556
                          }
                        ]
                      },
                      "text": "ः",
                      "confidence": 0.85
                    }
                  ],
                  "confidence": 0.9
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 668,
                        "y": 516
                      },
                      {
                        "x": 679,
                        "y": 516
                      },
                      {
                        "x": 679,
                        "y": 556
                      },
                      {
                        "x": 668,
                        "y": 556
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 668,
                            "y": 516
                          },
                          {
                            "x": 679,
                            "y": 516
                          },
                          {
                            "x": 679,
                            "y": 556
                          },
                          {
                            "x": 668,
                            "y": 556
                          }
                        ]
                      },
                      "text": "॥",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 692,
                        "y": 516
                      },
                      {
                        "x": 703,
                        "y": 516
                      },
                      {
                        "x": 703,
                        "y": 556
                      },
                      {
                        "x": 692,
                        "y": 556
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 692,
                            "y": 516
                          },
                          {
                            "x": 703,
                            "y": 516
                          },
                          {
                            "x": 703,
                            "y": 556
                          },
                          {
                            "x": 692,
                            "y": 556
                          }
                        ]
                      },
                      "text": "१",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 717,
                        "y": 516
                      },
                      {
                        "x": 728,
                        "y": 516
                      },
                      {
                        "x": 728,
                        "y": 556
                      },
                      {
                        "x": 717,
                        "y": 556
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "EOL_SURE_SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 717,
                            "y": 516
                          },
                          {
                            "x": 728,
                            "y": 516
                          },
                          {
                            "x": 728,
                            "y": 556
                          },
                          {
                            "x": 717,
                            "y": 556
                          }
                        ]
                      },
                      "text": "॥",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 235,
                        "y": 578
                      },
                      {
                        "x": 291,
                        "y": 577
                      },
                      {
                        "x": 292,
                        "y": 612
                      },
                      {
                        "x": 236,
                        "y": 613
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 235,
                            "y": 578
                          },
                          {
                            "x": 270,
                            "y": 577
                          },
                          {
                            "x": 271,
                            "y": 612
                          },
                          {
                            "x": 236,
                            "y": 613
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 235,
                            "y": 578
                          },
                          {
                            "x": 270,
                            "y": 577
                          },
                          {
                            "x": 271,
                            "y": 612
                          },
                          {
                            "x": 236,
                            "y": 613
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 235,
                            "y": 578
                          },
                          {
                            "x": 270,
                            "y": 577
                          },
                          {
                            "x": 271,
                            "y": 612
                          },
                          {
                            "x": 236,
                            "y": 613
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 235,
                            "y": 578
                          },
                          {
                            "x": 270,
                            "y": 577
                          },
                          {
                            "x": 271,
                            "y": 612
                          },
                          {
                            "x": 236,
                            "y": 613
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 275,
                            "y": 577
                          },
                          {
                            "x": 291,
                            "y": 577
                          },
                          {
                            "x": 292,
                            "y": 612
                          },
                          {
                            "x": 276,
                            "y": 612
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 302,
                        "y": 576
                      },
                      {
                        "x": 363,
                        "y": 574
                      },
                      {
                        "x": 364,
                        "y": 609
                      },
                      {
                        "x": 303,
                        "y": 611
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 302,
                            "y": 576
                          },
                          {
                            "x": 316,
                            "y": 576
                          },
                          {
                            "x": 317,
                            "y": 611
                          },
                          {
                            "x": 303,
                            "y": 611
                          }
                        ]
                      },
                      "text": "उ",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 319,
                            "y": 576
                          },
                          {
                            "x": 342,
                            "y": 575
                          },
                          {
                            "x": 343,
                            "y": 610
                          },
                          {
                            "x": 320,
                            "y": 611
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 319,
                            "y": 576
                          },
                          {
                            "x": 342,
                            "y": 575
                          },
                          {
                            "x": 343,
                            "y": 610
                          },
                          {
                            "x": 320,
                            "y": 611
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 347,
                            "y": 575
                          },
                          {
                            "x": 363,
                            "y": 575
                          },
                          {
                            "x": 364,
                            "y": 610
                          },
                          {
                            "x": 348,
                            "y": 610
                          }
                        ]
                      },
                      "text": "च",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 372,
                        "y": 574
                      },
                      {
                        "x": 381,
                        "y": 574
                      },
                      {
                        "x": 382,
                        "y": 609
                      },
                      {
                        "x": 373,
                        "y": 609
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "EOL_SURE_SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 372,
                            "y": 574
                          },
                          {
                            "x": 381,
                            "y": 574
                          },
                          {
                            "x": 382,
                            "y": 609
                          },
                          {
                            "x": 373,
                            "y": 609
                          }
                        ]
                      },
                      "text": "-",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 245,
                        "y": 618
                      },
                      {
                        "x": 314,
                        "y": 618
                      },
                      {
                        "x": 314,
                        "y": 658
                      },
                      {
                        "x": 245,
                        "y": 658
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 245,
                            "y": 618
                          },
                          {
                            "x": 259,
                            "y": 618
                          },
                          {
                            "x": 259,
                            "y": 658
                          },
                          {
                            "x": 245,
                            "y": 658
                          }
                        ]
                      },
                      "text": "अ",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 261,
                            "y": 618
                          },
                          {
                            "x": 284,
                            "y": 618
                          },
                          {
                            "x": 284,
                            "y": 658
                          },
                          {
                            "x": 261,
                            "y": 658
                          }
                        ]
                      },
                      "text": "ष",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 261,
                            "y": 618
                          },
                          {
                            "x": 284,
                            "y": 618
                          },
                          {
                            "x": 284,
                            "y": 658
                          },
                          {
                            "x": 261,
                            "y": 658
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 261,
                            "y": 618
                          },
                          {
                            "x": 284,
                            "y": 618
                          },
                          {
                            "x": 284,
                            "y": 658
                          },
                          {
                            "x": 261,
                            "y": 658
                          }
                        ]
                      },
                      "text": "ट",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 261,
                            "y": 618
                          },
                          {
                            "x": 284,
                            "y": 618
                          },
                          {
                            "x": 284,
                            "y": 658
                          },
                          {
                            "x": 261,
                            "y": 658
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 291,
                            "y": 618
                          },
                          {
                            "x": 304,
                            "y": 618
                          },
                          {
                            "x": 304,
                            "y": 658
                          },
                          {
                            "x": 291,
                            "y": 658
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 291,
                            "y": 618
                          },
                          {
                            "x": 304,
                            "y": 618
                          },
                          {
                            "x": 304,
                            "y": 658
                          },
                          {
                            "x": 291,
                            "y": 658
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 291,
                            "y": 618
                          },
                          {
                            "x": 304,
                            "y": 618
                          },
                          {
                            "x": 304,
                            "y": 658
                          },
                          {
                            "x": 291,
                            "y": 658
                          }
                        ]
                      },
                      "text": "ष",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 305,
                            "y": 618
                          },
                          {
                            "x": 314,
                            "y": 618
                          },
                          {
                            "x": 314,
                            "y": 658
                          },
                          {
                            "x": 305,
                            "y": 658
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 305,
                            "y": 618
                          },
                          {
                            "x": 314,
                            "y": 618
                          },
                          {
                            "x": 314,
                            "y": 658
                          },
                          {
                            "x": 305,
                            "y": 658
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.97
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 328,
                        "y": 618
                      },
                      {
                        "x": 421,
                        "y": 618
                      },
                      {
                        "x": 421,
                        "y": 658
                      },
                      {
                        "x": 328,
                        "y": 658
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 328,
                            "y": 618
                          },
                          {
                            "x": 341,
                            "y": 618
                          },
                          {
                            "x": 341,
                            "y": 658
                          },
                          {
                            "x": 328,
                            "y": 658
                          }
                        ]
                      },
                      "text": "प",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 328,
                            "y": 618
                          },
                          {
                            "x": 341,
                            "y": 618
                          },
                          {
                            "x": 341,
                            "y": 658
                          },
                          {
                            "x": 328,
                            "y": 658
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 328,
                            "y": 618
                          },
                          {
                            "x": 341,
                            "y": 618
                          },
                          {
                            "x": 341,
                            "y": 658
                          },
                          {
                            "x": 328,
                            "y": 658
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 344,
                            "y": 618
                          },
                          {
                            "x": 357,
                            "y": 618
                          },
                          {
                            "x": 357,
                            "y": 658
                          },
                          {
                            "x": 344,
                            "y": 658
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 361,
                            "y": 618
                          },
                          {
                            "x": 393,
                            "y": 618
                          },
                          {
                            "x": 393,
                            "y": 658
                          },
                          {
                            "x": 361,
                            "y": 658
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 361,
                            "y": 618
                          },
                          {
                            "x": 393,
                            "y": 618
                          },
                          {
                            "x": 393,
                            "y": 658
                          },
                          {
                            "x": 361,
                            "y": 658
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 361,
                            "y": 618
                          },
                          {
                            "x": 393,
                            "y": 618
                          },
                          {
                            "x": 393,
                            "y": 658
                          },
                          {
                            "x": 361,
                            "y": 658
                          }
                        ]
                      },
                      "text": "ष",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 361,
                            "y": 618
                          },
                          {
                            "x": 393,
                            "y": 618
                          },
                          {
                            "x": 393,
                            "y": 658
                          },
                          {
                            "x": 361,
                            "y": 658
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 361,
                            "y": 618
                          },
                          {
                            "x": 393,
                            "y": 618
                          },
                          {
                            "x": 393,
                            "y": 658
                          },
                          {
                            "x": 361,
                            "y": 658
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 361,
                            "y": 618
                          },
                          {
                            "x": 393,
                            "y": 618
                          },
                          {
                            "x": 393,
                            "y": 658
                          },
                          {
                            "x": 361,
                            "y": 658
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 395,
                            "y": 618
                          },
                          {
                            "x": 421,
                            "y": 618
                          },
                          {
                            "x": 421,
                            "y": 658
                          },
                          {
                            "x": 395,
                            "y": 658
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 395,
                            "y": 618
                          },
                          {
                            "x": 421,
                            "y": 618
                          },
                          {
                            "x": 421,
                            "y": 658
                          },
                          {
                            "x": 395,
                            "y": 658
                          }
                        ]
                      },
                      "text": "ि",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 434,
                        "y": 618
                      },
                      {
                        "x": 516,
                        "y": 618
                      },
                      {
                        "x": 516,
                        "y": 658
                      },
                      {
                        "x": 434,
                        "y": 658
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 434,
                            "y": 618
                          },
                          {
                            "x": 447,
                            "y": 618
                          },
                          {
                            "x": 447,
                            "y": 658
                          },
                          {
                            "x": 434,
                            "y": 658
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 449,
                            "y": 618
                          },
                          {
                            "x": 481,
                            "y": 618
                          },
                          {
                            "x": 481,
                            "y": 658
                          },
                          {
                            "x": 449,
                            "y": 658
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 449,
                            "y": 618
                          },
                          {
                            "x": 481,
                            "y": 618
                          },
                          {
                            "x": 481,
                            "y": 658
                          },
                          {
                            "x": 449,
                            "y": 658
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 449,
                            "y": 618
                          },
                          {
                            "x": 481,
                            "y": 618
                          },
                          {
                            "x": 481,
                            "y": 658
                          },
                          {
                            "x": 449,
                            "y": 658
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 449,
                            "y": 618
                          },
                          {
                            "x": 481,
                            "y": 618
                          },
                          {
                            "x": 481,
                            "y": 658
                          },
                          {
                            "x": 449,
                            "y": 658
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 449,
                            "y": 618
                          },
                          {
                            "x": 481,
                            "y": 618
                          },
                          {
                            "x": 481,
                            "y": 658
                          },
                          {
                            "x": 449,
                            "y": 658
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 449,
                            "y": 618
                          },
                          {
                            "x": 481,
                            "y": 618
                          },
                          {
                            "x": 481,
                            "y": 658
                          },
                          {
                            "x": 449,
                            "y": 658
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 488,
                            "y": 618
                          },
                          {
                            "x": 516,
                            "y": 618
                          },
                          {
                            "x": 516,
                            "y": 658
                          },
                          {
                            "x": 488,
                            "y": 658
                          }
                        ]
                      },
                      "text": "ण",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 488,
                            "y": 618
                          },
                          {
                            "x": 516,
                            "y": 618
                          },
                          {
                            "x": 516,
                            "y": 658
                          },
                          {
                            "x": 488,
                            "y": 658
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 488,
                            "y": 618
                          },
                          {
                            "x": 516,
                            "y": 618
                          },
                          {
                            "x": 516,
                            "y": 658
                          },
                          {
                            "x": 488,
                            "y": 658
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 525,
                        "y": 618
                      },
                      {
                        "x": 646,
                        "y": 618
                      },
                      {
                        "x": 646,
                        "y": 658
                      },
                      {
                        "x": 525,
                        "y": 658
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 525,
                            "y": 618
                          },
                          {
                            "x": 535,
                            "y": 618
                          },
                          {
                            "x": 535,
                            "y": 658
                          },
                          {
                            "x": 525,
                            "y": 658
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 537,
                            "y": 618
                          },
                          {
                            "x": 562,
                            "y": 618
                          },
                          {
                            "x": 562,
                            "y": 658
                          },
                          {
                            "x": 537,
                            "y": 658
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 537,
                            "y": 618
                          },
                          {
                            "x": 562,
                            "y": 618
                          },
                          {
                            "x": 562,
                            "y": 658
                          },
                          {
                            "x": 537,
                            "y": 658
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 537,
                            "y": 618
                          },
                          {
                            "x": 562,
                            "y": 618
                          },
                          {
                            "x": 562,
                            "y": 658
                          },
                          {
                            "x": 537,
                            "y": 658
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 537,
                            "y": 618
                          },
                          {
                            "x": 562,
                            "y": 618
                          },
                          {
                            "x": 562,
                            "y": 658
                          },
                          {
                            "x": 537,
                            "y": 658
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 537,
                            "y": 618
                          },
                          {
                            "x": 562,
                            "y": 618
                          },
                          {
                            "x": 562,
                            "y": 658
                          },
                          {
                            "x": 537,
                            "y": 658
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 567,
                            "y": 618
                          },
                          {
                            "x": 583,
                            "y": 618
                          },
                          {
                            "x": 583,
                            "y": 658
                          },
                          {
                            "x": 567,
                            "y": 658
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 567,
                            "y": 618
                          },
                          {
                            "x": 583,
                            "y": 618
                          },
                          {
                            "x": 583,
                            "y": 658
                          },
                          {
                            "x": 567,
                            "y": 658
                          }
                        ]
                      },
                      "text": "ु",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 588,
                            "y": 618
                          },
                          {
                            "x": 604,
                            "y": 618
                          },
                          {
                            "x": 604,
                            "y": 658
                          },
                          {
                            "x": 588,
                            "y": 658
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 588,
                            "y": 618
                          },
                          {
                            "x": 604,
                            "y": 618
                          },
                          {
                            "x": 604,
                            "y": 658
                          },
                          {
                            "x": 588,
                            "y": 658
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 588,
                            "y": 618
                          },
                          {
                            "x": 604,
                            "y": 618
                          },
                          {
                            "x": 604,
                            "y": 658
                          },
                          {
                            "x": 588,
                            "y": 658
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 608,
                            "y": 618
                          },
                          {
                            "x": 624,
                            "y": 618
                          },
                          {
                            "x": 624,
                            "y": 658
                          },
                          {
                            "x": 608,
                            "y": 658
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 629,
                            "y": 618
                          },
                          {
                            "x": 646,
                            "y": 618
                          },
                          {
                            "x": 646,
                            "y": 658
                          },
                          {
                            "x": 629,
                            "y": 658
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 629,
                            "y": 618
                          },
                          {
                            "x": 646,
                            "y": 618
                          },
                          {
                            "x": 646,
                            "y": 658
                          },
                          {
                            "x": 629,
                            "y": 658
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 652,
                        "y": 618
                      },
                      {
                        "x": 663,
                        "y": 618
                      },
                      {
                        "x": 663,
                        "y": 658
                      },
                      {
                        "x": 652,
                        "y": 658
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "EOL_SURE_SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 652,
                            "y": 618
                          },
                          {
                            "x": 663,
                            "y": 618
                          },
                          {
                            "x": 663,
                            "y": 658
                          },
                          {
                            "x": 652,
                            "y": 658
                          }
                        ]
                      },
                      "text": "।",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 239,
                        "y": 663
                      },
                      {
                        "x": 250,
                        "y": 663
                      },
                      {
                        "x": 250,
                        "y": 704
                      },
                      {
                        "x": 239,
                        "y": 704
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 239,
                            "y": 663
                          },
                          {
                            "x": 250,
                            "y": 663
                          },
                          {
                            "x": 250,
                            "y": 704
                          },
                          {
                            "x": 239,
                            "y": 704
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 239,
                            "y": 663
                          },
                          {
                            "x": 250,
                            "y": 663
                          },
                          {
                            "x": 250,
                            "y": 704
                          },
                          {
                            "x": 239,
                            "y": 704
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.94
                    }
                  ],
                  "confidence": 0.94
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 267,
                        "y": 663
                      },
                      {
                        "x": 320,
                        "y": 663
                      },
                      {
                        "x": 320,
                        "y": 704
                      },
                      {
                        "x": 267,
                        "y": 704
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 267,
                            "y": 663
                          },
                          {
                            "x": 280,
                            "y": 663
                          },
                          {
                            "x": 280,
                            "y": 704
                          },
                          {
                            "x": 267,
                            "y": 704
                          }
                        ]
                      },
                      "text": "ज",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 283,
                            "y": 663
                          },
                          {
                            "x": 298,
                            "y": 663
                          },
                          {
                            "x": 298,
                            "y": 704
                          },
                          {
                            "x": 283,
                            "y": 704
                          }
                        ]
                      },
                      "text": "प",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 303,
                            "y": 663
                          },
                          {
                            "x": 320,
                            "y": 663
                          },
                          {
                            "x": 320,
                            "y": 704
                          },
                          {
                            "x": 303,
                            "y": 704
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.91
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 303,
                            "y": 663
                          },
                          {
                            "x": 320,
                            "y": 663
                          },
                          {
                            "x": 320,
                            "y": 704
                          },
                          {
                            "x": 303,
                            "y": 704
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.91
                    }
                  ],
                  "confidence": 0.94
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 328,
                        "y": 663
                      },
                      {
                        "x": 394,
                        "y": 663
                      },
                      {
                        "x": 394,
                        "y": 704
                      },
                      {
                        "x": 328,
                        "y": 704
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 328,
                            "y": 663
                          },
                          {
                            "x": 345,
                            "y": 663
                          },
                          {
                            "x": 345,
                            "y": 704
                          },
                          {
                            "x": 328,
                            "y": 704
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.88
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 328,
                            "y": 663
                          },
                          {
                            "x": 345,
                            "y": 663
                          },
                          {
                            "x": 345,
                            "y": 704
                          },
                          {
                            "x": 328,
                            "y": 704
                          }
                        ]
                      },
                      "text": "ु",
                      "confidence": 0.88
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 350,
                            "y": 663
                          },
                          {
                            "x": 378,
                            "y": 663
                          },
                          {
                            "x": 378,
                            "y": 704
                          },
                          {
                            "x": 350,
                            "y": 704
                          }
                        ]
                      },
                      "text": "च",
                      "confidence": 0.92
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 350,
                            "y": 663
                          },
                          {
                            "x": 378,
                            "y": 663
                          },
                          {
                            "x": 378,
                            "y": 704
                          },
                          {
                            "x": 350,
                            "y": 704
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.92
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 350,
                            "y": 663
                          },
                          {
                            "x": 378,
                            "y": 663
                          },
                          {
                            "x": 378,
                            "y": 704
                          },
                          {
                            "x": 350,
                            "y": 704
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.92
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 381,
                            "y": 663
                          },
                          {
                            "x": 394,
                            "y": 663
                          },
                          {
                            "x": 394,
                            "y": 704
                          },
                          {
                            "x": 381,
                            "y": 704
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 381,
                            "y": 663
                          },
                          {
                            "x": 394,
                            "y": 663
                          },
                          {
                            "x": 394,
                            "y": 704
                          },
                          {
                            "x": 381,
                            "y": 704
                          }
                        ]
                      },
                      "text": "े",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.92
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 405,
                        "y": 663
                      },
                      {
                        "x": 458,
                        "y": 663
                      },
                      {
                        "x": 458,
                        "y": 704
                      },
                      {
                        "x": 405,
                        "y": 704
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 405,
                            "y": 663
                          },
                          {
                            "x": 428,
                            "y": 663
                          },
                          {
                            "x": 428,
                            "y": 704
                          },
                          {
                            "x": 405,
                            "y": 704
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 434,
                            "y": 663
                          },
                          {
                            "x": 458,
                            "y": 663
                          },
                          {
                            "x": 458,
                            "y": 704
                          },
                          {
                            "x": 434,
                            "y": 704
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.9
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 434,
                            "y": 663
                          },
                          {
                            "x": 458,
                            "y": 663
                          },
                          {
                            "x": 458,
                            "y": 704
                          },
                          {
                            "x": 434,
                            "y": 704
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.9
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 434,
                            "y": 663
                          },
                          {
                            "x": 458,
                            "y": 663
                          },
                          {
                            "x": 458,
                            "y": 704
                          },
                          {
                            "x": 434,
                            "y": 704
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.9
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 434,
                            "y": 663
                          },
                          {
                            "x": 458,
                            "y": 663
                          },
                          {
                            "x": 458,
                            "y": 704
                          },
                          {
                            "x": 434,
                            "y": 704
                          }
                        ]
                      },
                      "text": "ो",
                      "confidence": 0.9
                    }
                  ],
                  "confidence": 0.91
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 478,
                        "y": 663
                      },
                      {
                        "x": 671,
                        "y": 663
                      },
                      {
                        "x": 671,
                        "y": 704
                      },
                      {
                        "x": 478,
                        "y": 704
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 478,
                            "y": 663
                          },
                          {
                            "x": 488,
                            "y": 663
                          },
                          {
                            "x": 488,
                            "y": 704
                          },
                          {
                            "x": 478,
                            "y": 704
                          }
                        ]
                      },
                      "text": "ज",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 490,
                            "y": 663
                          },
                          {
                            "x": 520,
                            "y": 663
                          },
                          {
                            "x": 520,
                            "y": 704
                          },
                          {
                            "x": 490,
                            "y": 704
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 490,
                            "y": 663
                          },
                          {
                            "x": 520,
                            "y": 663
                          },
                          {
                            "x": 520,
                            "y": 704
                          },
                          {
                            "x": 490,
                            "y": 704
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 490,
                            "y": 663
                          },
                          {
                            "x": 520,
                            "y": 663
                          },
                          {
                            "x": 520,
                            "y": 704
                          },
                          {
                            "x": 490,
                            "y": 704
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 526,
                            "y": 663
                          },
                          {
                            "x": 543,
                            "y": 663
                          },
                          {
                            "x": 543,
                            "y": 704
                          },
                          {
                            "x": 526,
                            "y": 704
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 526,
                            "y": 663
                          },
                          {
                            "x": 543,
                            "y": 663
                          },
                          {
                            "x": 543,
                            "y": 704
                          },
                          {
                            "x": 526,
                            "y": 704
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 549,
                            "y": 663
                          },
                          {
                            "x": 570,
                            "y": 663
                          },
                          {
                            "x": 570,
                            "y": 704
                          },
                          {
                            "x": 549,
                            "y": 704
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 549,
                            "y": 663
                          },
                          {
                            "x": 570,
                            "y": 663
                          },
                          {
                            "x": 570,
                            "y": 704
                          },
                          {
                            "x": 549,
                            "y": 704
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 571,
                            "y": 663
                          },
                          {
                            "x": 582,
                            "y": 663
                          },
                          {
                            "x": 582,
                            "y": 704
                          },
                          {
                            "x": 571,
                            "y": 704
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 587,
                            "y": 663
                          },
                          {
                            "x": 599,
                            "y": 663
                          },
                          {
                            "x": 599,
                            "y": 704
                          },
                          {
                            "x": 587,
                            "y": 704
                          }
                        ]
                      },
                      "text": "ब",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 600,
                            "y": 663
                          },
                          {
                            "x": 628,
                            "y": 663
                          },
                          {
                            "x": 628,
                            "y": 704
                          },
                          {
                            "x": 600,
                            "y": 704
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 600,
                            "y": 663
                          },
                          {
                            "x": 628,
                            "y": 663
                          },
                          {
                            "x": 628,
                            "y": 704
                          },
                          {
                            "x": 600,
                            "y": 704
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 600,
                            "y": 663
                          },
                          {
                            "x": 628,
                            "y": 663
                          },
                          {
                            "x": 628,
                            "y": 704
                          },
                          {
                            "x": 600,
                            "y": 704
                          }
                        ]
                      },
                      "text": "ध",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 633,
                            "y": 663
                          },
                          {
                            "x": 654,
                            "y": 663
                          },
                          {
                            "x": 654,
                            "y": 704
                          },
                          {
                            "x": 633,
                            "y": 704
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 633,
                            "y": 663
                          },
                          {
                            "x": 654,
                            "y": 663
                          },
                          {
                            "x": 654,
                            "y": 704
                          },
                          {
                            "x": 633,
                            "y": 704
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 658,
                            "y": 663
                          },
                          {
                            "x": 671,
                            "y": 663
                          },
                          {
                            "x": 671,
                            "y": 704
                          },
                          {
                            "x": 658,
                            "y": 704
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 658,
                            "y": 663
                          },
                          {
                            "x": 671,
                            "y": 663
                          },
                          {
                            "x": 671,
                            "y": 704
                          },
                          {
                            "x": 658,
                            "y": 704
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 688,
                        "y": 663
                      },
                      {
                        "x": 699,
                        "y": 663
                      },
                      {
                        "x": 699,
                        "y": 704
                      },
                      {
                        "x": 688,
                        "y": 704
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 688,
                            "y": 663
                          },
                          {
                            "x": 699,
                            "y": 663
                          },
                          {
                            "x": 699,
                            "y": 704
                          },
                          {
                            "x": 688,
                            "y": 704
                          }
                        ]
                      },
                      "text": "॥",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 713,
                        "y": 663
                      },
                      {
                        "x": 724,
                        "y": 663
                      },
                      {
                        "x": 724,
                        "y": 704
                      },
                      {
                        "x": 713,
                        "y": 704
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 713,
                            "y": 663
                          },
                          {
                            "x": 724,
                            "y": 663
                          },
                          {
                            "x": 724,
                            "y": 704
                          },
                          {
                            "x": 713,
                            "y": 704
                          }
                        ]
                      },
                      "text": "२",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 739,
                        "y": 663
                      },
                      {
                        "x": 750,
                        "y": 663
                      },
                      {
                        "x": 750,
                        "y": 704
                      },
                      {
                        "x": 739,
                        "y": 704
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "EOL_SURE_SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 739,
                            "y": 663
                          },
                          {
                            "x": 750,
                            "y": 663
                          },
                          {
                            "x": 750,
                            "y": 704
                          },
                          {
                            "x": 739,
                            "y": 704
                          }
                        ]
                      },
                      "text": "॥",
                      "confidence": 0.97
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 236,
                        "y": 720
                      },
                      {
                        "x": 434,
                        "y": 720
                      },
                      {
                        "x": 434,
                        "y": 762
                      },
                      {
                        "x": 236,
                        "y": 762
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 236,
                            "y": 720
                          },
                          {
                            "x": 249,
                            "y": 720
                          },
                          {
                            "x": 249,
                            "y": 762
                          },
                          {
                            "x": 236,
                            "y": 762
                          }
                        ]
                      },
                      "text": "ह",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 236,
                            "y": 720
                          },
                          {
                            "x": 249,
                            "y": 720
                          },
                          {
                            "x": 249,
                            "y": 762
                          },
                          {
                            "x": 236,
                            "y": 762
                          }
                        ]
                      },
                      "text": "ृ",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 253,
                            "y": 720
                          },
                          {
                            "x": 275,
                            "y": 720
                          },
                          {
                            "x": 275,
                            "y": 762
                          },
                          {
                            "x": 253,
                            "y": 762
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 253,
                            "y": 720
                          },
                          {
                            "x": 275,
                            "y": 720
                          },
                          {
                            "x": 275,
                            "y": 762
                          },
                          {
                            "x": 253,
                            "y": 762
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 253,
                            "y": 720
                          },
                          {
                            "x": 275,
                            "y": 720
                          },
                          {
                            "x": 275,
                            "y": 762
                          },
                          {
                            "x": 253,
                            "y": 762
                          }
                        ]
                      },
                      "text": "प",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 253,
                            "y": 720
                          },
                          {
                            "x": 275,
                            "y": 720
                          },
                          {
                            "x": 275,
                            "y": 762
                          },
                          {
                            "x": 253,
                            "y": 762
                          }
                        ]
                      },
                      "text": "ु",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 278,
                            "y": 720
                          },
                          {
                            "x": 310,
                            "y": 720
                          },
                          {
                            "x": 310,
                            "y": 762
                          },
                          {
                            "x": 278,
                            "y": 762
                          }
                        ]
                      },
                      "text": "ण",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 278,
                            "y": 720
                          },
                          {
                            "x": 310,
                            "y": 720
                          },
                          {
                            "x": 310,
                            "y": 762
                          },
                          {
                            "x": 278,
                            "y": 762
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 278,
                            "y": 720
                          },
                          {
                            "x": 310,
                            "y": 720
                          },
                          {
                            "x": 310,
                            "y": 762
                          },
                          {
                            "x": 278,
                            "y": 762
                          }
                        ]
                      },
                      "text": "ड",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 316,
                            "y": 720
                          },
                          {
                            "x": 333,
                            "y": 720
                          },
                          {
                            "x": 333,
                            "y": 762
                          },
                          {
                            "x": 316,
                            "y": 762
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 316,
                            "y": 720
                          },
                          {
                            "x": 333,
                            "y": 720
                          },
                          {
                            "x": 333,
                            "y": 762
                          },
                          {
                            "x": 316,
                            "y": 762
                          }
                        ]
                      },
                      "text": "ी",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 338,
                            "y": 720
                          },
                          {
                            "x": 353,
                            "y": 720
                          },
                          {
                            "x": 353,
                            "y": 762
                          },
                          {
                            "x": 338,
                            "y": 762
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 355,
                            "y": 720
                          },
                          {
                            "x": 371,
                            "y": 720
                          },
                          {
                            "x": 371,
                            "y": 762
                          },
                          {
                            "x": 355,
                            "y": 762
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 377,
                            "y": 720
                          },
                          {
                            "x": 405,
                            "y": 720
                          },
                          {
                            "x": 405,
                            "y": 762
                          },
                          {
                            "x": 377,
                            "y": 762
                          }
                        ]
                      },
                      "text": "ध",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 377,
                            "y": 720
                          },
                          {
                            "x": 405,
                            "y": 720
                          },
                          {
                            "x": 405,
                            "y": 762
                          },
                          {
                            "x": 377,
                            "y": 762
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 377,
                            "y": 720
                          },
                          {
                            "x": 405,
                            "y": 720
                          },
                          {
                            "x": 405,
                            "y": 762
                          },
                          {
                            "x": 377,
                            "y": 762
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 408,
                            "y": 720
                          },
                          {
                            "x": 434,
                            "y": 720
                          },
                          {
                            "x": 434,
                            "y": 762
                          },
                          {
                            "x": 408,
                            "y": 762
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 408,
                            "y": 720
                          },
                          {
                            "x": 434,
                            "y": 720
                          },
                          {
                            "x": 434,
                            "y": 762
                          },
                          {
                            "x": 408,
                            "y": 762
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 408,
                            "y": 720
                          },
                          {
                            "x": 434,
                            "y": 720
                          },
                          {
                            "x": 434,
                            "y": 762
                          },
                          {
                            "x": 408,
                            "y": 762
                          }
                        ]
                      },
                      "text": "थ",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 408,
                            "y": 720
                          },
                          {
                            "x": 434,
                            "y": 720
                          },
                          {
                            "x": 434,
                            "y": 762
                          },
                          {
                            "x": 408,
                            "y": 762
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.96
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 449,
                        "y": 720
                      },
                      {
                        "x": 630,
                        "y": 720
                      },
                      {
                        "x": 630,
                        "y": 762
                      },
                      {
                        "x": 449,
                        "y": 762
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 449,
                            "y": 720
                          },
                          {
                            "x": 466,
                            "y": 720
                          },
                          {
                            "x": 466,
                            "y": 762
                          },
                          {
                            "x": 449,
                            "y": 762
                          }
                        ]
                      },
                      "text": "श",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 470,
                            "y": 720
                          },
                          {
                            "x": 488,
                            "y": 720
                          },
                          {
                            "x": 488,
                            "y": 762
                          },
                          {
                            "x": 470,
                            "y": 762
                          }
                        ]
                      },
                      "text": "ङ",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 470,
                            "y": 720
                          },
                          {
                            "x": 488,
                            "y": 720
                          },
                          {
                            "x": 488,
                            "y": 762
                          },
                          {
                            "x": 470,
                            "y": 762
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 470,
                            "y": 720
                          },
                          {
                            "x": 488,
                            "y": 720
                          },
                          {
                            "x": 488,
                            "y": 762
                          },
                          {
                            "x": 470,
                            "y": 762
                          }
                        ]
                      },
                      "text": "ख",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 492,
                            "y": 720
                          },
                          {
                            "x": 509,
                            "y": 720
                          },
                          {
                            "x": 509,
                            "y": 762
                          },
                          {
                            "x": 492,
                            "y": 762
                          }
                        ]
                      },
                      "text": "च",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 513,
                            "y": 720
                          },
                          {
                            "x": 531,
                            "y": 720
                          },
                          {
                            "x": 531,
                            "y": 762
                          },
                          {
                            "x": 513,
                            "y": 762
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 513,
                            "y": 720
                          },
                          {
                            "x": 531,
                            "y": 720
                          },
                          {
                            "x": 531,
                            "y": 762
                          },
                          {
                            "x": 513,
                            "y": 762
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 513,
                            "y": 720
                          },
                          {
                            "x": 531,
                            "y": 720
                          },
                          {
                            "x": 531,
                            "y": 762
                          },
                          {
                            "x": 513,
                            "y": 762
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 536,
                            "y": 720
                          },
                          {
                            "x": 551,
                            "y": 720
                          },
                          {
                            "x": 551,
                            "y": 762
                          },
                          {
                            "x": 536,
                            "y": 762
                          }
                        ]
                      },
                      "text": "ग",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 554,
                            "y": 720
                          },
                          {
                            "x": 576,
                            "y": 720
                          },
                          {
                            "x": 576,
                            "y": 762
                          },
                          {
                            "x": 554,
                            "y": 762
                          }
                        ]
                      },
                      "text": "द",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 554,
                            "y": 720
                          },
                          {
                            "x": 576,
                            "y": 720
                          },
                          {
                            "x": 576,
                            "y": 762
                          },
                          {
                            "x": 554,
                            "y": 762
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 580,
                            "y": 720
                          },
                          {
                            "x": 592,
                            "y": 720
                          },
                          {
                            "x": 592,
                            "y": 762
                          },
                          {
                            "x": 580,
                            "y": 762
                          }
                        ]
                      },
                      "text": "ध",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 593,
                            "y": 720
                          },
                          {
                            "x": 606,
                            "y": 720
                          },
                          {
                            "x": 606,
                            "y": 762
                          },
                          {
                            "x": 593,
                            "y": 762
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 612,
                            "y": 720
                          },
                          {
                            "x": 630,
                            "y": 720
                          },
                          {
                            "x": 630,
                            "y": 762
                          },
                          {
                            "x": 612,
                            "y": 762
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 612,
                            "y": 720
                          },
                          {
                            "x": 630,
                            "y": 720
                          },
                          {
                            "x": 630,
                            "y": 762
                          },
                          {
                            "x": 612,
                            "y": 762
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.96
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 637,
                        "y": 720
                      },
                      {
                        "x": 648,
                        "y": 720
                      },
                      {
                        "x": 648,
                        "y": 762
                      },
                      {
                        "x": 637,
                        "y": 762
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "EOL_SURE_SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 637,
                            "y": 720
                          },
                          {
                            "x": 648,
                            "y": 720
                          },
                          {
                            "x": 648,
                            "y": 762
                          },
                          {
                            "x": 637,
                            "y": 762
                          }
                        ]
                      },
                      "text": "।",
                      "confidence": 0.97
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 233,
                        "y": 768
                      },
                      {
                        "x": 365,
                        "y": 767
                      },
                      {
                        "x": 365,
                        "y": 807
                      },
                      {
                        "x": 233,
                        "y": 808
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 233,
                            "y": 768
                          },
                          {
                            "x": 250,
                            "y": 768
                          },
                          {
                            "x": 250,
                            "y": 808
                          },
                          {
                            "x": 233,
                            "y": 808
                          }
                        ]
                      },
                      "text": "ए",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 255,
                            "y": 768
                          },
                          {
                            "x": 279,
                            "y": 768
                          },
                          {
                            "x": 279,
                            "y": 808
                          },
                          {
                            "x": 255,
                            "y": 808
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 255,
                            "y": 768
                          },
                          {
                            "x": 279,
                            "y": 768
                          },
                          {
                            "x": 279,
                            "y": 808
                          },
                          {
                            "x": 255,
                            "y": 808
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 283,
                            "y": 768
                          },
                          {
                            "x": 300,
                            "y": 768
                          },
                          {
                            "x": 300,
                            "y": 808
                          },
                          {
                            "x": 283,
                            "y": 808
                          }
                        ]
                      },
                      "text": "ग",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 283,
                            "y": 768
                          },
                          {
                            "x": 300,
                            "y": 768
                          },
                          {
                            "x": 300,
                            "y": 808
                          },
                          {
                            "x": 283,
                            "y": 808
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 283,
                            "y": 768
                          },
                          {
                            "x": 300,
                            "y": 768
                          },
                          {
                            "x": 300,
                            "y": 808
                          },
                          {
                            "x": 283,
                            "y": 808
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 305,
                            "y": 767
                          },
                          {
                            "x": 319,
                            "y": 767
                          },
                          {
                            "x": 319,
                            "y": 807
                          },
                          {
                            "x": 305,
                            "y": 807
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 320,
                            "y": 767
                          },
                          {
                            "x": 335,
                            "y": 767
                          },
                          {
                            "x": 335,
                            "y": 807
                          },
                          {
                            "x": 320,
                            "y": 807
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 340,
                            "y": 767
                          },
                          {
                            "x": 365,
                            "y": 767
                          },
                          {
                            "x": 365,
                            "y": 807
                          },
                          {
                            "x": 340,
                            "y": 807
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 340,
                            "y": 767
                          },
                          {
                            "x": 365,
                            "y": 767
                          },
                          {
                            "x": 365,
                            "y": 807
                          },
                          {
                            "x": 340,
                            "y": 807
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 375,
                        "y": 767
                      },
                      {
                        "x": 445,
                        "y": 766
                      },
                      {
                        "x": 445,
                        "y": 806
                      },
                      {
                        "x": 375,
                        "y": 807
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 375,
                            "y": 767
                          },
                          {
                            "x": 408,
                            "y": 767
                          },
                          {
                            "x": 408,
                            "y": 807
                          },
                          {
                            "x": 375,
                            "y": 807
                          }
                        ]
                      },
                      "text": "ध",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 375,
                            "y": 767
                          },
                          {
                            "x": 408,
                            "y": 767
                          },
                          {
                            "x": 408,
                            "y": 807
                          },
                          {
                            "x": 375,
                            "y": 807
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 375,
                            "y": 767
                          },
                          {
                            "x": 408,
                            "y": 767
                          },
                          {
                            "x": 408,
                            "y": 807
                          },
                          {
                            "x": 375,
                            "y": 807
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 375,
                            "y": 767
                          },
                          {
                            "x": 408,
                            "y": 767
                          },
                          {
                            "x": 408,
                            "y": 807
                          },
                          {
                            "x": 375,
                            "y": 807
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 412,
                            "y": 767
                          },
                          {
                            "x": 445,
                            "y": 767
                          },
                          {
                            "x": 445,
                            "y": 807
                          },
                          {
                            "x": 412,
                            "y": 807
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 412,
                            "y": 767
                          },
                          {
                            "x": 445,
                            "y": 767
                          },
                          {
                            "x": 445,
                            "y": 807
                          },
                          {
                            "x": 412,
                            "y": 807
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 412,
                            "y": 767
                          },
                          {
                            "x": 445,
                            "y": 767
                          },
                          {
                            "x": 445,
                            "y": 807
                          },
                          {
                            "x": 412,
                            "y": 807
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 412,
                            "y": 767
                          },
                          {
                            "x": 445,
                            "y": 767
                          },
                          {
                            "x": 445,
                            "y": 807
                          },
                          {
                            "x": 412,
                            "y": 807
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 449,
                        "y": 766
                      },
                      {
                        "x": 507,
                        "y": 766
                      },
                      {
                        "x": 507,
                        "y": 806
                      },
                      {
                        "x": 449,
                        "y": 806
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 449,
                            "y": 766
                          },
                          {
                            "x": 474,
                            "y": 766
                          },
                          {
                            "x": 474,
                            "y": 806
                          },
                          {
                            "x": 449,
                            "y": 806
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 449,
                            "y": 766
                          },
                          {
                            "x": 474,
                            "y": 766
                          },
                          {
                            "x": 474,
                            "y": 806
                          },
                          {
                            "x": 449,
                            "y": 806
                          }
                        ]
                      },
                      "text": "ि",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 477,
                            "y": 766
                          },
                          {
                            "x": 507,
                            "y": 766
                          },
                          {
                            "x": 507,
                            "y": 806
                          },
                          {
                            "x": 477,
                            "y": 806
                          }
                        ]
                      },
                      "text": "ष",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 477,
                            "y": 766
                          },
                          {
                            "x": 507,
                            "y": 766
                          },
                          {
                            "x": 507,
                            "y": 806
                          },
                          {
                            "x": 477,
                            "y": 806
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 477,
                            "y": 766
                          },
                          {
                            "x": 507,
                            "y": 766
                          },
                          {
                            "x": 507,
                            "y": 806
                          },
                          {
                            "x": 477,
                            "y": 806
                          }
                        ]
                      },
                      "text": "ण",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 477,
                            "y": 766
                          },
                          {
                            "x": 507,
                            "y": 766
                          },
                          {
                            "x": 507,
                            "y": 806
                          },
                          {
                            "x": 477,
                            "y": 806
                          }
                        ]
                      },
                      "text": "ु",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 477,
                            "y": 766
                          },
                          {
                            "x": 507,
                            "y": 766
                          },
                          {
                            "x": 507,
                            "y": 806
                          },
                          {
                            "x": 477,
                            "y": 806
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.93
                    }
                  ],
                  "confidence": 0.94
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 520,
                        "y": 765
                      },
                      {
                        "x": 605,
                        "y": 764
                      },
                      {
                        "x": 605,
                        "y": 805
                      },
                      {
                        "x": 520,
                        "y": 806
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 520,
                            "y": 766
                          },
                          {
                            "x": 537,
                            "y": 766
                          },
                          {
                            "x": 537,
                            "y": 806
                          },
                          {
                            "x": 520,
                            "y": 806
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.88
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 520,
                            "y": 766
                          },
                          {
                            "x": 537,
                            "y": 766
                          },
                          {
                            "x": 537,
                            "y": 806
                          },
                          {
                            "x": 520,
                            "y": 806
                          }
                        ]
                      },
                      "text": "ु",
                      "confidence": 0.88
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 541,
                            "y": 766
                          },
                          {
                            "x": 559,
                            "y": 766
                          },
                          {
                            "x": 559,
                            "y": 806
                          },
                          {
                            "x": 541,
                            "y": 806
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 541,
                            "y": 766
                          },
                          {
                            "x": 559,
                            "y": 766
                          },
                          {
                            "x": 559,
                            "y": 806
                          },
                          {
                            "x": 541,
                            "y": 806
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 541,
                            "y": 766
                          },
                          {
                            "x": 559,
                            "y": 766
                          },
                          {
                            "x": 559,
                            "y": 806
                          },
                          {
                            "x": 541,
                            "y": 806
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 541,
                            "y": 766
                          },
                          {
                            "x": 559,
                            "y": 766
                          },
                          {
                            "x": 559,
                            "y": 806
                          },
                          {
                            "x": 541,
                            "y": 806
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 566,
                            "y": 765
                          },
                          {
                            "x": 591,
                            "y": 765
                          },
                          {
                            "x": 591,
                            "y": 805
                          },
                          {
                            "x": 566,
                            "y": 805
                          }
                        ]
                      },
                      "text": "ज",
                      "confidence": 0.88
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 566,
                            "y": 765
                          },
                          {
                            "x": 591,
                            "y": 765
                          },
                          {
                            "x": 591,
                            "y": 805
                          },
                          {
                            "x": 566,
                            "y": 805
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.88
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 566,
                            "y": 765
                          },
                          {
                            "x": 591,
                            "y": 765
                          },
                          {
                            "x": 591,
                            "y": 805
                          },
                          {
                            "x": 566,
                            "y": 805
                          }
                        ]
                      },
                      "text": "ज",
                      "confidence": 0.88
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 592,
                            "y": 765
                          },
                          {
                            "x": 605,
                            "y": 765
                          },
                          {
                            "x": 605,
                            "y": 805
                          },
                          {
                            "x": 592,
                            "y": 805
                          }
                        ]
                      },
                      "text": "प",
                      "confidence": 0.9
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 592,
                            "y": 765
                          },
                          {
                            "x": 605,
                            "y": 765
                          },
                          {
                            "x": 605,
                            "y": 805
                          },
                          {
                            "x": 592,
                            "y": 805
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.9
                    }
                  ],
                  "confidence": 0.9
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 605,
                        "y": 765
                      },
                      {
                        "x": 674,
                        "y": 764
                      },
                      {
                        "x": 674,
                        "y": 804
                      },
                      {
                        "x": 605,
                        "y": 805
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 605,
                            "y": 765
                          },
                          {
                            "x": 637,
                            "y": 765
                          },
                          {
                            "x": 637,
                            "y": 805
                          },
                          {
                            "x": 605,
                            "y": 805
                          }
                        ]
                      },
                      "text": "द",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 605,
                            "y": 765
                          },
                          {
                            "x": 637,
                            "y": 765
                          },
                          {
                            "x": 637,
                            "y": 805
                          },
                          {
                            "x": 605,
                            "y": 805
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 605,
                            "y": 765
                          },
                          {
                            "x": 637,
                            "y": 765
                          },
                          {
                            "x": 637,
                            "y": 805
                          },
                          {
                            "x": 605,
                            "y": 805
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 605,
                            "y": 765
                          },
                          {
                            "x": 637,
                            "y": 765
                          },
                          {
                            "x": 637,
                            "y": 805
                          },
                          {
                            "x": 605,
                            "y": 805
                          }
                        ]
                      },
                      "text": "ि",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 642,
                            "y": 765
                          },
                          {
                            "x": 674,
                            "y": 765
                          },
                          {
                            "x": 674,
                            "y": 805
                          },
                          {
                            "x": 642,
                            "y": 805
                          }
                        ]
                      },
                      "text": "ज",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 642,
                            "y": 765
                          },
                          {
                            "x": 674,
                            "y": 765
                          },
                          {
                            "x": 674,
                            "y": 805
                          },
                          {
                            "x": 642,
                            "y": 805
                          }
                        ]
                      },
                      "text": "ः",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 687,
                        "y": 764
                      },
                      {
                        "x": 698,
                        "y": 764
                      },
                      {
                        "x": 698,
                        "y": 804
                      },
                      {
                        "x": 687,
                        "y": 804
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 687,
                            "y": 764
                          },
                          {
                            "x": 698,
                            "y": 764
                          },
                          {
                            "x": 698,
                            "y": 804
                          },
                          {
                            "x": 687,
                            "y": 804
                          }
                        ]
                      },
                      "text": "॥",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 716,
                        "y": 764
                      },
                      {
                        "x": 727,
                        "y": 764
                      },
                      {
                        "x": 727,
                        "y": 804
                      },
                      {
                        "x": 716,
                        "y": 804
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 716,
                            "y": 764
                          },
                          {
                            "x": 727,
                            "y": 764
                          },
                          {
                            "x": 727,
                            "y": 804
                          },
                          {
                            "x": 716,
                            "y": 804
                          }
                        ]
                      },
                      "text": "३",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 737,
                        "y": 764
                      },
                      {
                        "x": 748,
                        "y": 764
                      },
                      {
                        "x": 748,
                        "y": 804
                      },
                      {
                        "x": 737,
                        "y": 804
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "EOL_SURE_SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 737,
                            "y": 764
                          },
                          {
                            "x": 748,
                            "y": 764
                          },
                          {
                            "x": 748,
                            "y": 804
                          },
                          {
                            "x": 737,
                            "y": 804
                          }
                        ]
                      },
                      "text": "॥",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 234,
                        "y": 820
                      },
                      {
                        "x": 309,
                        "y": 820
                      },
                      {
                        "x": 309,
                        "y": 862
                      },
                      {
                        "x": 234,
                        "y": 862
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 234,
                            "y": 820
                          },
                          {
                            "x": 251,
                            "y": 820
                          },
                          {
                            "x": 251,
                            "y": 862
                          },
                          {
                            "x": 234,
                            "y": 862
                          }
                        ]
                      },
                      "text": "ए",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 256,
                            "y": 820
                          },
                          {
                            "x": 280,
                            "y": 820
                          },
                          {
                            "x": 280,
                            "y": 862
                          },
                          {
                            "x": 256,
                            "y": 862
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 256,
                            "y": 820
                          },
                          {
                            "x": 280,
                            "y": 820
                          },
                          {
                            "x": 280,
                            "y": 862
                          },
                          {
                            "x": 256,
                            "y": 862
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 283,
                            "y": 820
                          },
                          {
                            "x": 309,
                            "y": 820
                          },
                          {
                            "x": 309,
                            "y": 862
                          },
                          {
                            "x": 283,
                            "y": 862
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 283,
                            "y": 820
                          },
                          {
                            "x": 309,
                            "y": 820
                          },
                          {
                            "x": 309,
                            "y": 862
                          },
                          {
                            "x": 283,
                            "y": 862
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 283,
                            "y": 820
                          },
                          {
                            "x": 309,
                            "y": 820
                          },
                          {
                            "x": 309,
                            "y": 862
                          },
                          {
                            "x": 283,
                            "y": 862
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 283,
                            "y": 820
                          },
                          {
                            "x": 309,
                            "y": 820
                          },
                          {
                            "x": 309,
                            "y": 862
                          },
                          {
                            "x": 283,
                            "y": 862
                          }
                        ]
                      },
                      "text": "े",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 309,
                        "y": 820
                      },
                      {
                        "x": 438,
                        "y": 820
                      },
                      {
                        "x": 438,
                        "y": 862
                      },
                      {
                        "x": 309,
                        "y": 862
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 309,
                            "y": 820
                          },
                          {
                            "x": 343,
                            "y": 820
                          },
                          {
                            "x": 343,
                            "y": 862
                          },
                          {
                            "x": 309,
                            "y": 862
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 309,
                            "y": 820
                          },
                          {
                            "x": 343,
                            "y": 820
                          },
                          {
                            "x": 343,
                            "y": 862
                          },
                          {
                            "x": 309,
                            "y": 862
                          }
                        ]
                      },
                      "text": "ि",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 350,
                            "y": 820
                          },
                          {
                            "x": 367,
                            "y": 820
                          },
                          {
                            "x": 367,
                            "y": 862
                          },
                          {
                            "x": 350,
                            "y": 862
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 350,
                            "y": 820
                          },
                          {
                            "x": 367,
                            "y": 820
                          },
                          {
                            "x": 367,
                            "y": 862
                          },
                          {
                            "x": 350,
                            "y": 862
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 350,
                            "y": 820
                          },
                          {
                            "x": 367,
                            "y": 820
                          },
                          {
                            "x": 367,
                            "y": 862
                          },
                          {
                            "x": 350,
                            "y": 862
                          }
                        ]
                      },
                      "text": "ज",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 369,
                            "y": 820
                          },
                          {
                            "x": 382,
                            "y": 820
                          },
                          {
                            "x": 382,
                            "y": 862
                          },
                          {
                            "x": 369,
                            "y": 862
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 386,
                            "y": 820
                          },
                          {
                            "x": 421,
                            "y": 820
                          },
                          {
                            "x": 421,
                            "y": 862
                          },
                          {
                            "x": 386,
                            "y": 862
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 386,
                            "y": 820
                          },
                          {
                            "x": 421,
                            "y": 820
                          },
                          {
                            "x": 421,
                            "y": 862
                          },
                          {
                            "x": 386,
                            "y": 862
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 386,
                            "y": 820
                          },
                          {
                            "x": 421,
                            "y": 820
                          },
                          {
                            "x": 421,
                            "y": 862
                          },
                          {
                            "x": 386,
                            "y": 862
                          }
                        ]
                      },
                      "text": "थ",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 386,
                            "y": 820
                          },
                          {
                            "x": 421,
                            "y": 820
                          },
                          {
                            "x": 421,
                            "y": 862
                          },
                          {
                            "x": 386,
                            "y": 862
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 425,
                            "y": 820
                          },
                          {
                            "x": 438,
                            "y": 820
                          },
                          {
                            "x": 438,
                            "y": 862
                          },
                          {
                            "x": 425,
                            "y": 862
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 425,
                            "y": 820
                          },
                          {
                            "x": 438,
                            "y": 820
                          },
                          {
                            "x": 438,
                            "y": 862
                          },
                          {
                            "x": 425,
                            "y": 862
                          }
                        ]
                      },
                      "text": "े",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 444,
                        "y": 820
                      },
                      {
                        "x": 537,
                        "y": 820
                      },
                      {
                        "x": 537,
                        "y": 862
                      },
                      {
                        "x": 444,
                        "y": 862
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 444,
                            "y": 820
                          },
                          {
                            "x": 471,
                            "y": 820
                          },
                          {
                            "x": 471,
                            "y": 862
                          },
                          {
                            "x": 444,
                            "y": 862
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 444,
                            "y": 820
                          },
                          {
                            "x": 471,
                            "y": 820
                          },
                          {
                            "x": 471,
                            "y": 862
                          },
                          {
                            "x": 444,
                            "y": 862
                          }
                        ]
                      },
                      "text": "ि",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 473,
                            "y": 820
                          },
                          {
                            "x": 502,
                            "y": 820
                          },
                          {
                            "x": 502,
                            "y": 862
                          },
                          {
                            "x": 473,
                            "y": 862
                          }
                        ]
                      },
                      "text": "ष",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 473,
                            "y": 820
                          },
                          {
                            "x": 502,
                            "y": 820
                          },
                          {
                            "x": 502,
                            "y": 862
                          },
                          {
                            "x": 473,
                            "y": 862
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 473,
                            "y": 820
                          },
                          {
                            "x": 502,
                            "y": 820
                          },
                          {
                            "x": 502,
                            "y": 862
                          },
                          {
                            "x": 473,
                            "y": 862
                          }
                        ]
                      },
                      "text": "ण",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 507,
                            "y": 820
                          },
                          {
                            "x": 520,
                            "y": 820
                          },
                          {
                            "x": 520,
                            "y": 862
                          },
                          {
                            "x": 507,
                            "y": 862
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 524,
                            "y": 820
                          },
                          {
                            "x": 537,
                            "y": 820
                          },
                          {
                            "x": 537,
                            "y": 862
                          },
                          {
                            "x": 524,
                            "y": 862
                          }
                        ]
                      },
                      "text": "ग",
                      "confidence": 0.85
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 524,
                            "y": 820
                          },
                          {
                            "x": 537,
                            "y": 820
                          },
                          {
                            "x": 537,
                            "y": 862
                          },
                          {
                            "x": 524,
                            "y": 862
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.85
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 524,
                            "y": 820
                          },
                          {
                            "x": 537,
                            "y": 820
                          },
                          {
                            "x": 537,
                            "y": 862
                          },
                          {
                            "x": 524,
                            "y": 862
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.85
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 524,
                            "y": 820
                          },
                          {
                            "x": 537,
                            "y": 820
                          },
                          {
                            "x": 537,
                            "y": 862
                          },
                          {
                            "x": 524,
                            "y": 862
                          }
                        ]
                      },
                      "text": "े",
                      "confidence": 0.85
                    }
                  ],
                  "confidence": 0.92
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 555,
                        "y": 820
                      },
                      {
                        "x": 567,
                        "y": 820
                      },
                      {
                        "x": 567,
                        "y": 862
                      },
                      {
                        "x": 555,
                        "y": 862
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 555,
                            "y": 820
                          },
                          {
                            "x": 567,
                            "y": 820
                          },
                          {
                            "x": 567,
                            "y": 862
                          },
                          {
                            "x": 555,
                            "y": 862
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 555,
                            "y": 820
                          },
                          {
                            "x": 567,
                            "y": 820
                          },
                          {
                            "x": 567,
                            "y": 862
                          },
                          {
                            "x": 555,
                            "y": 862
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.96
                    }
                  ],
                  "confidence": 0.96
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 586,
                        "y": 820
                      },
                      {
                        "x": 690,
                        "y": 820
                      },
                      {
                        "x": 690,
                        "y": 862
                      },
                      {
                        "x": 586,
                        "y": 862
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 586,
                            "y": 820
                          },
                          {
                            "x": 604,
                            "y": 820
                          },
                          {
                            "x": 604,
                            "y": 862
                          },
                          {
                            "x": 586,
                            "y": 862
                          }
                        ]
                      },
                      "text": "ज",
                      "confidence": 1
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 611,
                            "y": 820
                          },
                          {
                            "x": 631,
                            "y": 820
                          },
                          {
                            "x": 631,
                            "y": 862
                          },
                          {
                            "x": 611,
                            "y": 862
                          }
                        ]
                      },
                      "text": "ल",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 611,
                            "y": 820
                          },
                          {
                            "x": 631,
                            "y": 820
                          },
                          {
                            "x": 631,
                            "y": 862
                          },
                          {
                            "x": 611,
                            "y": 862
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 628,
                            "y": 820
                          },
                          {
                            "x": 665,
                            "y": 820
                          },
                          {
                            "x": 665,
                            "y": 862
                          },
                          {
                            "x": 628,
                            "y": 862
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 628,
                            "y": 820
                          },
                          {
                            "x": 665,
                            "y": 820
                          },
                          {
                            "x": 665,
                            "y": 862
                          },
                          {
                            "x": 628,
                            "y": 862
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 628,
                            "y": 820
                          },
                          {
                            "x": 665,
                            "y": 820
                          },
                          {
                            "x": 665,
                            "y": 862
                          },
                          {
                            "x": 628,
                            "y": 862
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 628,
                            "y": 820
                          },
                          {
                            "x": 665,
                            "y": 820
                          },
                          {
                            "x": 665,
                            "y": 862
                          },
                          {
                            "x": 628,
                            "y": 862
                          }
                        ]
                      },
                      "text": "ि",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 672,
                            "y": 820
                          },
                          {
                            "x": 690,
                            "y": 820
                          },
                          {
                            "x": 690,
                            "y": 862
                          },
                          {
                            "x": 672,
                            "y": 862
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 672,
                            "y": 820
                          },
                          {
                            "x": 690,
                            "y": 820
                          },
                          {
                            "x": 690,
                            "y": 862
                          },
                          {
                            "x": 672,
                            "y": 862
                          }
                        ]
                      },
                      "text": "े",
                      "confidence": 0.93
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 697,
                        "y": 820
                      },
                      {
                        "x": 708,
                        "y": 820
                      },
                      {
                        "x": 708,
                        "y": 862
                      },
                      {
                        "x": 697,
                        "y": 862
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "EOL_SURE_SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 697,
                            "y": 820
                          },
                          {
                            "x": 708,
                            "y": 820
                          },
                          {
                            "x": 708,
                            "y": 862
                          },
                          {
                            "x": 697,
                            "y": 862
                          }
                        ]
                      },
                      "text": "।",
                      "confidence": 0.81
                    }
                  ],
                  "confidence": 0.81
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 245,
                        "y": 865
                      },
                      {
                        "x": 345,
                        "y": 865
                      },
                      {
                        "x": 345,
                        "y": 911
                      },
                      {
                        "x": 245,
                        "y": 911
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 245,
                            "y": 865
                          },
                          {
                            "x": 256,
                            "y": 865
                          },
                          {
                            "x": 256,
                            "y": 911
                          },
                          {
                            "x": 245,
                            "y": 911
                          }
                        ]
                      },
                      "text": "ज",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 259,
                            "y": 865
                          },
                          {
                            "x": 271,
                            "y": 865
                          },
                          {
                            "x": 271,
                            "y": 911
                          },
                          {
                            "x": 259,
                            "y": 911
                          }
                        ]
                      },
                      "text": "प",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 259,
                            "y": 865
                          },
                          {
                            "x": 271,
                            "y": 865
                          },
                          {
                            "x": 271,
                            "y": 911
                          },
                          {
                            "x": 259,
                            "y": 911
                          }
                        ]
                      },
                      "text": "े",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 273,
                            "y": 865
                          },
                          {
                            "x": 289,
                            "y": 865
                          },
                          {
                            "x": 289,
                            "y": 911
                          },
                          {
                            "x": 273,
                            "y": 911
                          }
                        ]
                      },
                      "text": "द",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 291,
                            "y": 865
                          },
                          {
                            "x": 314,
                            "y": 865
                          },
                          {
                            "x": 314,
                            "y": 911
                          },
                          {
                            "x": 291,
                            "y": 911
                          }
                        ]
                      },
                      "text": "ष",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 291,
                            "y": 865
                          },
                          {
                            "x": 314,
                            "y": 865
                          },
                          {
                            "x": 314,
                            "y": 911
                          },
                          {
                            "x": 291,
                            "y": 911
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 291,
                            "y": 865
                          },
                          {
                            "x": 314,
                            "y": 865
                          },
                          {
                            "x": 314,
                            "y": 911
                          },
                          {
                            "x": 291,
                            "y": 911
                          }
                        ]
                      },
                      "text": "ट",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 291,
                            "y": 865
                          },
                          {
                            "x": 314,
                            "y": 865
                          },
                          {
                            "x": 314,
                            "y": 911
                          },
                          {
                            "x": 291,
                            "y": 911
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 319,
                            "y": 865
                          },
                          {
                            "x": 332,
                            "y": 865
                          },
                          {
                            "x": 332,
                            "y": 911
                          },
                          {
                            "x": 319,
                            "y": 911
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 319,
                            "y": 865
                          },
                          {
                            "x": 332,
                            "y": 865
                          },
                          {
                            "x": 332,
                            "y": 911
                          },
                          {
                            "x": 319,
                            "y": 911
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 319,
                            "y": 865
                          },
                          {
                            "x": 332,
                            "y": 865
                          },
                          {
                            "x": 332,
                            "y": 911
                          },
                          {
                            "x": 319,
                            "y": 911
                          }
                        ]
                      },
                      "text": "ष",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 334,
                            "y": 865
                          },
                          {
                            "x": 345,
                            "y": 865
                          },
                          {
                            "x": 345,
                            "y": 911
                          },
                          {
                            "x": 334,
                            "y": 911
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 334,
                            "y": 865
                          },
                          {
                            "x": 345,
                            "y": 865
                          },
                          {
                            "x": 345,
                            "y": 911
                          },
                          {
                            "x": 334,
                            "y": 911
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.93
                    }
                  ],
                  "confidence": 0.96
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 358,
                        "y": 865
                      },
                      {
                        "x": 397,
                        "y": 865
                      },
                      {
                        "x": 397,
                        "y": 911
                      },
                      {
                        "x": 358,
                        "y": 911
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 358,
                            "y": 865
                          },
                          {
                            "x": 369,
                            "y": 865
                          },
                          {
                            "x": 369,
                            "y": 911
                          },
                          {
                            "x": 358,
                            "y": 911
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 1
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 372,
                            "y": 865
                          },
                          {
                            "x": 397,
                            "y": 865
                          },
                          {
                            "x": 397,
                            "y": 911
                          },
                          {
                            "x": 372,
                            "y": 911
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 372,
                            "y": 865
                          },
                          {
                            "x": 397,
                            "y": 865
                          },
                          {
                            "x": 397,
                            "y": 911
                          },
                          {
                            "x": 372,
                            "y": 911
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 372,
                            "y": 865
                          },
                          {
                            "x": 397,
                            "y": 865
                          },
                          {
                            "x": 397,
                            "y": 911
                          },
                          {
                            "x": 372,
                            "y": 911
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 372,
                            "y": 865
                          },
                          {
                            "x": 397,
                            "y": 865
                          },
                          {
                            "x": 397,
                            "y": 911
                          },
                          {
                            "x": 372,
                            "y": 911
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 372,
                            "y": 865
                          },
                          {
                            "x": 397,
                            "y": 865
                          },
                          {
                            "x": 397,
                            "y": 911
                          },
                          {
                            "x": 372,
                            "y": 911
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 372,
                            "y": 865
                          },
                          {
                            "x": 397,
                            "y": 865
                          },
                          {
                            "x": 397,
                            "y": 911
                          },
                          {
                            "x": 372,
                            "y": 911
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.96
                    }
                  ],
                  "confidence": 0.96
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 407,
                        "y": 865
                      },
                      {
                        "x": 452,
                        "y": 865
                      },
                      {
                        "x": 452,
                        "y": 911
                      },
                      {
                        "x": 407,
                        "y": 911
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 407,
                            "y": 865
                          },
                          {
                            "x": 433,
                            "y": 865
                          },
                          {
                            "x": 433,
                            "y": 911
                          },
                          {
                            "x": 407,
                            "y": 911
                          }
                        ]
                      },
                      "text": "च",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 407,
                            "y": 865
                          },
                          {
                            "x": 433,
                            "y": 865
                          },
                          {
                            "x": 433,
                            "y": 911
                          },
                          {
                            "x": 407,
                            "y": 911
                          }
                        ]
                      },
                      "text": "ि",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 435,
                            "y": 865
                          },
                          {
                            "x": 452,
                            "y": 865
                          },
                          {
                            "x": 452,
                            "y": 911
                          },
                          {
                            "x": 435,
                            "y": 911
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.92
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 435,
                            "y": 865
                          },
                          {
                            "x": 452,
                            "y": 865
                          },
                          {
                            "x": 452,
                            "y": 911
                          },
                          {
                            "x": 435,
                            "y": 911
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.92
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 435,
                            "y": 865
                          },
                          {
                            "x": 452,
                            "y": 865
                          },
                          {
                            "x": 452,
                            "y": 911
                          },
                          {
                            "x": 435,
                            "y": 911
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.92
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 435,
                            "y": 865
                          },
                          {
                            "x": 452,
                            "y": 865
                          },
                          {
                            "x": 452,
                            "y": 911
                          },
                          {
                            "x": 435,
                            "y": 911
                          }
                        ]
                      },
                      "text": "े",
                      "confidence": 0.92
                    }
                  ],
                  "confidence": 0.92
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 461,
                        "y": 865
                      },
                      {
                        "x": 519,
                        "y": 865
                      },
                      {
                        "x": 519,
                        "y": 911
                      },
                      {
                        "x": 461,
                        "y": 911
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 461,
                            "y": 865
                          },
                          {
                            "x": 486,
                            "y": 865
                          },
                          {
                            "x": 486,
                            "y": 911
                          },
                          {
                            "x": 461,
                            "y": 911
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 1
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 461,
                            "y": 865
                          },
                          {
                            "x": 486,
                            "y": 865
                          },
                          {
                            "x": 486,
                            "y": 911
                          },
                          {
                            "x": 461,
                            "y": 911
                          }
                        ]
                      },
                      "text": "ि",
                      "confidence": 1
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 489,
                            "y": 865
                          },
                          {
                            "x": 519,
                            "y": 865
                          },
                          {
                            "x": 519,
                            "y": 911
                          },
                          {
                            "x": 489,
                            "y": 911
                          }
                        ]
                      },
                      "text": "ष",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 489,
                            "y": 865
                          },
                          {
                            "x": 519,
                            "y": 865
                          },
                          {
                            "x": 519,
                            "y": 911
                          },
                          {
                            "x": 489,
                            "y": 911
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 489,
                            "y": 865
                          },
                          {
                            "x": 519,
                            "y": 865
                          },
                          {
                            "x": 519,
                            "y": 911
                          },
                          {
                            "x": 489,
                            "y": 911
                          }
                        ]
                      },
                      "text": "ण",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 489,
                            "y": 865
                          },
                          {
                            "x": 519,
                            "y": 865
                          },
                          {
                            "x": 519,
                            "y": 911
                          },
                          {
                            "x": 489,
                            "y": 911
                          }
                        ]
                      },
                      "text": "ु",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 489,
                            "y": 865
                          },
                          {
                            "x": 519,
                            "y": 865
                          },
                          {
                            "x": 519,
                            "y": 911
                          },
                          {
                            "x": 489,
                            "y": 911
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.93
                    }
                  ],
                  "confidence": 0.95
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 525,
                        "y": 865
                      },
                      {
                        "x": 594,
                        "y": 865
                      },
                      {
                        "x": 594,
                        "y": 911
                      },
                      {
                        "x": 525,
                        "y": 911
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 525,
                            "y": 865
                          },
                          {
                            "x": 554,
                            "y": 865
                          },
                          {
                            "x": 554,
                            "y": 911
                          },
                          {
                            "x": 525,
                            "y": 911
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.89
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 525,
                            "y": 865
                          },
                          {
                            "x": 554,
                            "y": 865
                          },
                          {
                            "x": 554,
                            "y": 911
                          },
                          {
                            "x": 525,
                            "y": 911
                          }
                        ]
                      },
                      "text": "ि",
                      "confidence": 0.89
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 559,
                            "y": 865
                          },
                          {
                            "x": 581,
                            "y": 865
                          },
                          {
                            "x": 581,
                            "y": 911
                          },
                          {
                            "x": 559,
                            "y": 911
                          }
                        ]
                      },
                      "text": "ध",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 559,
                            "y": 865
                          },
                          {
                            "x": 581,
                            "y": 865
                          },
                          {
                            "x": 581,
                            "y": 911
                          },
                          {
                            "x": 559,
                            "y": 911
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 583,
                            "y": 865
                          },
                          {
                            "x": 594,
                            "y": 865
                          },
                          {
                            "x": 594,
                            "y": 911
                          },
                          {
                            "x": 583,
                            "y": 911
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.95
                    }
                  ],
                  "confidence": 0.92
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 610,
                        "y": 865
                      },
                      {
                        "x": 623,
                        "y": 865
                      },
                      {
                        "x": 623,
                        "y": 911
                      },
                      {
                        "x": 610,
                        "y": 911
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 610,
                            "y": 865
                          },
                          {
                            "x": 623,
                            "y": 865
                          },
                          {
                            "x": 623,
                            "y": 911
                          },
                          {
                            "x": 610,
                            "y": 911
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 610,
                            "y": 865
                          },
                          {
                            "x": 623,
                            "y": 865
                          },
                          {
                            "x": 623,
                            "y": 911
                          },
                          {
                            "x": 610,
                            "y": 911
                          }
                        ]
                      },
                      "text": "ै",
                      "confidence": 0.95
                    }
                  ],
                  "confidence": 0.95
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 639,
                        "y": 865
                      },
                      {
                        "x": 652,
                        "y": 865
                      },
                      {
                        "x": 652,
                        "y": 911
                      },
                      {
                        "x": 639,
                        "y": 911
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 639,
                            "y": 865
                          },
                          {
                            "x": 652,
                            "y": 865
                          },
                          {
                            "x": 652,
                            "y": 911
                          },
                          {
                            "x": 639,
                            "y": 911
                          }
                        ]
                      },
                      "text": "॥",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 667,
                        "y": 865
                      },
                      {
                        "x": 680,
                        "y": 865
                      },
                      {
                        "x": 680,
                        "y": 911
                      },
                      {
                        "x": 667,
                        "y": 911
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 667,
                            "y": 865
                          },
                          {
                            "x": 680,
                            "y": 865
                          },
                          {
                            "x": 680,
                            "y": 911
                          },
                          {
                            "x": 667,
                            "y": 911
                          }
                        ]
                      },
                      "text": "४",
                      "confidence": 0.97
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 690,
                        "y": 865
                      },
                      {
                        "x": 703,
                        "y": 865
                      },
                      {
                        "x": 703,
                        "y": 911
                      },
                      {
                        "x": 690,
                        "y": 911
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "EOL_SURE_SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 690,
                            "y": 865
                          },
                          {
                            "x": 703,
                            "y": 865
                          },
                          {
                            "x": 703,
                            "y": 911
                          },
                          {
                            "x": 690,
                            "y": 911
                          }
                        ]
                      },
                      "text": "॥",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 242,
                        "y": 919
                      },
                      {
                        "x": 349,
                        "y": 919
                      },
                      {
                        "x": 349,
                        "y": 969
                      },
                      {
                        "x": 242,
                        "y": 969
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 242,
                            "y": 919
                          },
                          {
                            "x": 255,
                            "y": 919
                          },
                          {
                            "x": 255,
                            "y": 969
                          },
                          {
                            "x": 242,
                            "y": 969
                          }
                        ]
                      },
                      "text": "अ",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 258,
                            "y": 919
                          },
                          {
                            "x": 282,
                            "y": 919
                          },
                          {
                            "x": 282,
                            "y": 969
                          },
                          {
                            "x": 258,
                            "y": 969
                          }
                        ]
                      },
                      "text": "ष",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 258,
                            "y": 919
                          },
                          {
                            "x": 282,
                            "y": 919
                          },
                          {
                            "x": 282,
                            "y": 969
                          },
                          {
                            "x": 258,
                            "y": 969
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 258,
                            "y": 919
                          },
                          {
                            "x": 282,
                            "y": 919
                          },
                          {
                            "x": 282,
                            "y": 969
                          },
                          {
                            "x": 258,
                            "y": 969
                          }
                        ]
                      },
                      "text": "ट",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 258,
                            "y": 919
                          },
                          {
                            "x": 282,
                            "y": 919
                          },
                          {
                            "x": 282,
                            "y": 969
                          },
                          {
                            "x": 258,
                            "y": 969
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 289,
                            "y": 919
                          },
                          {
                            "x": 301,
                            "y": 919
                          },
                          {
                            "x": 301,
                            "y": 969
                          },
                          {
                            "x": 289,
                            "y": 969
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 289,
                            "y": 919
                          },
                          {
                            "x": 301,
                            "y": 919
                          },
                          {
                            "x": 301,
                            "y": 969
                          },
                          {
                            "x": 289,
                            "y": 969
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 289,
                            "y": 919
                          },
                          {
                            "x": 301,
                            "y": 919
                          },
                          {
                            "x": 301,
                            "y": 969
                          },
                          {
                            "x": 289,
                            "y": 969
                          }
                        ]
                      },
                      "text": "ष",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 300,
                            "y": 919
                          },
                          {
                            "x": 312,
                            "y": 919
                          },
                          {
                            "x": 312,
                            "y": 969
                          },
                          {
                            "x": 300,
                            "y": 969
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 318,
                            "y": 919
                          },
                          {
                            "x": 349,
                            "y": 919
                          },
                          {
                            "x": 349,
                            "y": 969
                          },
                          {
                            "x": 318,
                            "y": 969
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 318,
                            "y": 919
                          },
                          {
                            "x": 349,
                            "y": 919
                          },
                          {
                            "x": 349,
                            "y": 969
                          },
                          {
                            "x": 318,
                            "y": 969
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 318,
                            "y": 919
                          },
                          {
                            "x": 349,
                            "y": 919
                          },
                          {
                            "x": 349,
                            "y": 969
                          },
                          {
                            "x": 318,
                            "y": 969
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 361,
                        "y": 919
                      },
                      {
                        "x": 429,
                        "y": 919
                      },
                      {
                        "x": 429,
                        "y": 969
                      },
                      {
                        "x": 361,
                        "y": 969
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 361,
                            "y": 919
                          },
                          {
                            "x": 373,
                            "y": 919
                          },
                          {
                            "x": 373,
                            "y": 969
                          },
                          {
                            "x": 361,
                            "y": 969
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 376,
                            "y": 919
                          },
                          {
                            "x": 398,
                            "y": 919
                          },
                          {
                            "x": 398,
                            "y": 969
                          },
                          {
                            "x": 376,
                            "y": 969
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 376,
                            "y": 919
                          },
                          {
                            "x": 398,
                            "y": 919
                          },
                          {
                            "x": 398,
                            "y": 969
                          },
                          {
                            "x": 376,
                            "y": 969
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 376,
                            "y": 919
                          },
                          {
                            "x": 398,
                            "y": 919
                          },
                          {
                            "x": 398,
                            "y": 969
                          },
                          {
                            "x": 376,
                            "y": 969
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 376,
                            "y": 919
                          },
                          {
                            "x": 398,
                            "y": 919
                          },
                          {
                            "x": 398,
                            "y": 969
                          },
                          {
                            "x": 376,
                            "y": 969
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 376,
                            "y": 919
                          },
                          {
                            "x": 398,
                            "y": 919
                          },
                          {
                            "x": 398,
                            "y": 969
                          },
                          {
                            "x": 376,
                            "y": 969
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 401,
                            "y": 919
                          },
                          {
                            "x": 429,
                            "y": 919
                          },
                          {
                            "x": 429,
                            "y": 969
                          },
                          {
                            "x": 401,
                            "y": 969
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 401,
                            "y": 919
                          },
                          {
                            "x": 429,
                            "y": 919
                          },
                          {
                            "x": 429,
                            "y": 969
                          },
                          {
                            "x": 401,
                            "y": 969
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 401,
                            "y": 919
                          },
                          {
                            "x": 429,
                            "y": 919
                          },
                          {
                            "x": 429,
                            "y": 969
                          },
                          {
                            "x": 401,
                            "y": 969
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 455,
                        "y": 919
                      },
                      {
                        "x": 589,
                        "y": 919
                      },
                      {
                        "x": 589,
                        "y": 969
                      },
                      {
                        "x": 455,
                        "y": 969
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 455,
                            "y": 919
                          },
                          {
                            "x": 463,
                            "y": 919
                          },
                          {
                            "x": 463,
                            "y": 969
                          },
                          {
                            "x": 455,
                            "y": 969
                          }
                        ]
                      },
                      "text": "ऋ",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 463,
                            "y": 919
                          },
                          {
                            "x": 485,
                            "y": 919
                          },
                          {
                            "x": 485,
                            "y": 969
                          },
                          {
                            "x": 463,
                            "y": 969
                          }
                        ]
                      },
                      "text": "ष",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 463,
                            "y": 919
                          },
                          {
                            "x": 485,
                            "y": 919
                          },
                          {
                            "x": 485,
                            "y": 969
                          },
                          {
                            "x": 463,
                            "y": 969
                          }
                        ]
                      },
                      "text": "ि",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 490,
                            "y": 919
                          },
                          {
                            "x": 508,
                            "y": 919
                          },
                          {
                            "x": 508,
                            "y": 969
                          },
                          {
                            "x": 490,
                            "y": 969
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.87
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 490,
                            "y": 919
                          },
                          {
                            "x": 508,
                            "y": 919
                          },
                          {
                            "x": 508,
                            "y": 969
                          },
                          {
                            "x": 490,
                            "y": 969
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.87
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 490,
                            "y": 919
                          },
                          {
                            "x": 508,
                            "y": 919
                          },
                          {
                            "x": 508,
                            "y": 969
                          },
                          {
                            "x": 490,
                            "y": 969
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.87
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 490,
                            "y": 919
                          },
                          {
                            "x": 508,
                            "y": 919
                          },
                          {
                            "x": 508,
                            "y": 969
                          },
                          {
                            "x": 490,
                            "y": 969
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.87
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 516,
                            "y": 919
                          },
                          {
                            "x": 534,
                            "y": 919
                          },
                          {
                            "x": 534,
                            "y": 969
                          },
                          {
                            "x": 516,
                            "y": 969
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 516,
                            "y": 919
                          },
                          {
                            "x": 534,
                            "y": 919
                          },
                          {
                            "x": 534,
                            "y": 969
                          },
                          {
                            "x": 516,
                            "y": 969
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 537,
                            "y": 919
                          },
                          {
                            "x": 553,
                            "y": 919
                          },
                          {
                            "x": 553,
                            "y": 969
                          },
                          {
                            "x": 537,
                            "y": 969
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 557,
                            "y": 919
                          },
                          {
                            "x": 589,
                            "y": 919
                          },
                          {
                            "x": 589,
                            "y": 969
                          },
                          {
                            "x": 557,
                            "y": 969
                          }
                        ]
                      },
                      "text": "ण",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 557,
                            "y": 919
                          },
                          {
                            "x": 589,
                            "y": 919
                          },
                          {
                            "x": 589,
                            "y": 969
                          },
                          {
                            "x": 557,
                            "y": 969
                          }
                        ]
                      },
                      "text": "ः",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.94
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 595,
                        "y": 919
                      },
                      {
                        "x": 660,
                        "y": 919
                      },
                      {
                        "x": 660,
                        "y": 969
                      },
                      {
                        "x": 595,
                        "y": 969
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 595,
                            "y": 919
                          },
                          {
                            "x": 623,
                            "y": 919
                          },
                          {
                            "x": 623,
                            "y": 969
                          },
                          {
                            "x": 595,
                            "y": 969
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 595,
                            "y": 919
                          },
                          {
                            "x": 623,
                            "y": 919
                          },
                          {
                            "x": 623,
                            "y": 969
                          },
                          {
                            "x": 595,
                            "y": 969
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 595,
                            "y": 919
                          },
                          {
                            "x": 623,
                            "y": 919
                          },
                          {
                            "x": 623,
                            "y": 969
                          },
                          {
                            "x": 595,
                            "y": 969
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 625,
                            "y": 919
                          },
                          {
                            "x": 639,
                            "y": 919
                          },
                          {
                            "x": 639,
                            "y": 969
                          },
                          {
                            "x": 625,
                            "y": 969
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 644,
                            "y": 919
                          },
                          {
                            "x": 660,
                            "y": 919
                          },
                          {
                            "x": 660,
                            "y": 969
                          },
                          {
                            "x": 644,
                            "y": 969
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 644,
                            "y": 919
                          },
                          {
                            "x": 660,
                            "y": 919
                          },
                          {
                            "x": 660,
                            "y": 969
                          },
                          {
                            "x": 644,
                            "y": 969
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 666,
                        "y": 919
                      },
                      {
                        "x": 680,
                        "y": 919
                      },
                      {
                        "x": 680,
                        "y": 969
                      },
                      {
                        "x": 666,
                        "y": 969
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "EOL_SURE_SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 666,
                            "y": 919
                          },
                          {
                            "x": 680,
                            "y": 919
                          },
                          {
                            "x": 680,
                            "y": 969
                          },
                          {
                            "x": 666,
                            "y": 969
                          }
                        ]
                      },
                      "text": "।",
                      "confidence": 0.96
                    }
                  ],
                  "confidence": 0.96
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 239,
                        "y": 969
                      },
                      {
                        "x": 309,
                        "y": 969
                      },
                      {
                        "x": 309,
                        "y": 1013
                      },
                      {
                        "x": 239,
                        "y": 1013
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 239,
                            "y": 969
                          },
                          {
                            "x": 253,
                            "y": 969
                          },
                          {
                            "x": 253,
                            "y": 1013
                          },
                          {
                            "x": 239,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "छ",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 256,
                            "y": 969
                          },
                          {
                            "x": 285,
                            "y": 969
                          },
                          {
                            "x": 285,
                            "y": 1013
                          },
                          {
                            "x": 256,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 256,
                            "y": 969
                          },
                          {
                            "x": 285,
                            "y": 969
                          },
                          {
                            "x": 285,
                            "y": 1013
                          },
                          {
                            "x": 256,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 256,
                            "y": 969
                          },
                          {
                            "x": 285,
                            "y": 969
                          },
                          {
                            "x": 285,
                            "y": 1013
                          },
                          {
                            "x": 256,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "द",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 291,
                            "y": 969
                          },
                          {
                            "x": 309,
                            "y": 969
                          },
                          {
                            "x": 309,
                            "y": 1013
                          },
                          {
                            "x": 291,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "श",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 291,
                            "y": 969
                          },
                          {
                            "x": 309,
                            "y": 969
                          },
                          {
                            "x": 309,
                            "y": 1013
                          },
                          {
                            "x": 291,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 291,
                            "y": 969
                          },
                          {
                            "x": 309,
                            "y": 969
                          },
                          {
                            "x": 309,
                            "y": 1013
                          },
                          {
                            "x": 291,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "च",
                      "confidence": 0.95
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 315,
                        "y": 969
                      },
                      {
                        "x": 356,
                        "y": 969
                      },
                      {
                        "x": 356,
                        "y": 1013
                      },
                      {
                        "x": 315,
                        "y": 1013
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 315,
                            "y": 969
                          },
                          {
                            "x": 329,
                            "y": 969
                          },
                          {
                            "x": 329,
                            "y": 1013
                          },
                          {
                            "x": 315,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "द",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 315,
                            "y": 969
                          },
                          {
                            "x": 329,
                            "y": 969
                          },
                          {
                            "x": 329,
                            "y": 1013
                          },
                          {
                            "x": 315,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "ै",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 333,
                            "y": 969
                          },
                          {
                            "x": 356,
                            "y": 969
                          },
                          {
                            "x": 356,
                            "y": 1013
                          },
                          {
                            "x": 333,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 333,
                            "y": 969
                          },
                          {
                            "x": 356,
                            "y": 969
                          },
                          {
                            "x": 356,
                            "y": 1013
                          },
                          {
                            "x": 333,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "ी",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 368,
                        "y": 969
                      },
                      {
                        "x": 431,
                        "y": 969
                      },
                      {
                        "x": 431,
                        "y": 1013
                      },
                      {
                        "x": 368,
                        "y": 1013
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 368,
                            "y": 969
                          },
                          {
                            "x": 390,
                            "y": 969
                          },
                          {
                            "x": 390,
                            "y": 1013
                          },
                          {
                            "x": 368,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "ग",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 368,
                            "y": 969
                          },
                          {
                            "x": 390,
                            "y": 969
                          },
                          {
                            "x": 390,
                            "y": 1013
                          },
                          {
                            "x": 368,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 396,
                            "y": 969
                          },
                          {
                            "x": 410,
                            "y": 969
                          },
                          {
                            "x": 410,
                            "y": 1013
                          },
                          {
                            "x": 396,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 411,
                            "y": 969
                          },
                          {
                            "x": 431,
                            "y": 969
                          },
                          {
                            "x": 431,
                            "y": 1013
                          },
                          {
                            "x": 411,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 411,
                            "y": 969
                          },
                          {
                            "x": 431,
                            "y": 969
                          },
                          {
                            "x": 431,
                            "y": 1013
                          },
                          {
                            "x": 411,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 411,
                            "y": 969
                          },
                          {
                            "x": 431,
                            "y": 969
                          },
                          {
                            "x": 431,
                            "y": 1013
                          },
                          {
                            "x": 411,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 411,
                            "y": 969
                          },
                          {
                            "x": 431,
                            "y": 969
                          },
                          {
                            "x": 431,
                            "y": 1013
                          },
                          {
                            "x": 411,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "ी",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 447,
                        "y": 969
                      },
                      {
                        "x": 534,
                        "y": 969
                      },
                      {
                        "x": 534,
                        "y": 1013
                      },
                      {
                        "x": 447,
                        "y": 1013
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 447,
                            "y": 969
                          },
                          {
                            "x": 458,
                            "y": 969
                          },
                          {
                            "x": 458,
                            "y": 1013
                          },
                          {
                            "x": 447,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "प",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 460,
                            "y": 969
                          },
                          {
                            "x": 472,
                            "y": 969
                          },
                          {
                            "x": 472,
                            "y": 1013
                          },
                          {
                            "x": 460,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 478,
                            "y": 969
                          },
                          {
                            "x": 499,
                            "y": 969
                          },
                          {
                            "x": 499,
                            "y": 1013
                          },
                          {
                            "x": 478,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 478,
                            "y": 969
                          },
                          {
                            "x": 499,
                            "y": 969
                          },
                          {
                            "x": 499,
                            "y": 1013
                          },
                          {
                            "x": 478,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 501,
                            "y": 969
                          },
                          {
                            "x": 534,
                            "y": 969
                          },
                          {
                            "x": 534,
                            "y": 1013
                          },
                          {
                            "x": 501,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 501,
                            "y": 969
                          },
                          {
                            "x": 534,
                            "y": 969
                          },
                          {
                            "x": 534,
                            "y": 1013
                          },
                          {
                            "x": 501,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 501,
                            "y": 969
                          },
                          {
                            "x": 534,
                            "y": 969
                          },
                          {
                            "x": 534,
                            "y": 1013
                          },
                          {
                            "x": 501,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 501,
                            "y": 969
                          },
                          {
                            "x": 534,
                            "y": 969
                          },
                          {
                            "x": 534,
                            "y": 1013
                          },
                          {
                            "x": 501,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 555,
                        "y": 969
                      },
                      {
                        "x": 567,
                        "y": 969
                      },
                      {
                        "x": 567,
                        "y": 1013
                      },
                      {
                        "x": 555,
                        "y": 1013
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 555,
                            "y": 969
                          },
                          {
                            "x": 567,
                            "y": 969
                          },
                          {
                            "x": 567,
                            "y": 1013
                          },
                          {
                            "x": 555,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "च",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 576,
                        "y": 969
                      },
                      {
                        "x": 635,
                        "y": 969
                      },
                      {
                        "x": 635,
                        "y": 1013
                      },
                      {
                        "x": 576,
                        "y": 1013
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 576,
                            "y": 969
                          },
                          {
                            "x": 590,
                            "y": 969
                          },
                          {
                            "x": 590,
                            "y": 1013
                          },
                          {
                            "x": 576,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "द",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 576,
                            "y": 969
                          },
                          {
                            "x": 590,
                            "y": 969
                          },
                          {
                            "x": 590,
                            "y": 1013
                          },
                          {
                            "x": 576,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "े",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 594,
                            "y": 969
                          },
                          {
                            "x": 608,
                            "y": 969
                          },
                          {
                            "x": 608,
                            "y": 1013
                          },
                          {
                            "x": 594,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 612,
                            "y": 969
                          },
                          {
                            "x": 635,
                            "y": 969
                          },
                          {
                            "x": 635,
                            "y": 1013
                          },
                          {
                            "x": 612,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 612,
                            "y": 969
                          },
                          {
                            "x": 635,
                            "y": 969
                          },
                          {
                            "x": 635,
                            "y": 1013
                          },
                          {
                            "x": 612,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 654,
                        "y": 969
                      },
                      {
                        "x": 666,
                        "y": 969
                      },
                      {
                        "x": 666,
                        "y": 1013
                      },
                      {
                        "x": 654,
                        "y": 1013
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 654,
                            "y": 969
                          },
                          {
                            "x": 666,
                            "y": 969
                          },
                          {
                            "x": 666,
                            "y": 1013
                          },
                          {
                            "x": 654,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "॥",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 676,
                        "y": 969
                      },
                      {
                        "x": 688,
                        "y": 969
                      },
                      {
                        "x": 688,
                        "y": 1013
                      },
                      {
                        "x": 676,
                        "y": 1013
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 676,
                            "y": 969
                          },
                          {
                            "x": 688,
                            "y": 969
                          },
                          {
                            "x": 688,
                            "y": 1013
                          },
                          {
                            "x": 676,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "५",
                      "confidence": 0.96
                    }
                  ],
                  "confidence": 0.96
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 703,
                        "y": 969
                      },
                      {
                        "x": 715,
                        "y": 969
                      },
                      {
                        "x": 715,
                        "y": 1013
                      },
                      {
                        "x": 703,
                        "y": 1013
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "EOL_SURE_SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 703,
                            "y": 969
                          },
                          {
                            "x": 715,
                            "y": 969
                          },
                          {
                            "x": 715,
                            "y": 1013
                          },
                          {
                            "x": 703,
                            "y": 1013
                          }
                        ]
                      },
                      "text": "॥",
                      "confidence": 0.97
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 239,
                        "y": 1025
                      },
                      {
                        "x": 320,
                        "y": 1025
                      },
                      {
                        "x": 320,
                        "y": 1069
                      },
                      {
                        "x": 239,
                        "y": 1069
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 239,
                            "y": 1025
                          },
                          {
                            "x": 257,
                            "y": 1025
                          },
                          {
                            "x": 257,
                            "y": 1069
                          },
                          {
                            "x": 239,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "श",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 239,
                            "y": 1025
                          },
                          {
                            "x": 257,
                            "y": 1025
                          },
                          {
                            "x": 257,
                            "y": 1069
                          },
                          {
                            "x": 239,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "ु",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 262,
                            "y": 1025
                          },
                          {
                            "x": 278,
                            "y": 1025
                          },
                          {
                            "x": 278,
                            "y": 1069
                          },
                          {
                            "x": 262,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 262,
                            "y": 1025
                          },
                          {
                            "x": 278,
                            "y": 1025
                          },
                          {
                            "x": 278,
                            "y": 1069
                          },
                          {
                            "x": 262,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 262,
                            "y": 1025
                          },
                          {
                            "x": 278,
                            "y": 1025
                          },
                          {
                            "x": 278,
                            "y": 1069
                          },
                          {
                            "x": 262,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "ल",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 280,
                            "y": 1025
                          },
                          {
                            "x": 296,
                            "y": 1025
                          },
                          {
                            "x": 296,
                            "y": 1069
                          },
                          {
                            "x": 280,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 302,
                            "y": 1025
                          },
                          {
                            "x": 320,
                            "y": 1025
                          },
                          {
                            "x": 320,
                            "y": 1069
                          },
                          {
                            "x": 302,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.8
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 302,
                            "y": 1025
                          },
                          {
                            "x": 320,
                            "y": 1025
                          },
                          {
                            "x": 320,
                            "y": 1069
                          },
                          {
                            "x": 302,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.8
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 302,
                            "y": 1025
                          },
                          {
                            "x": 320,
                            "y": 1025
                          },
                          {
                            "x": 320,
                            "y": 1069
                          },
                          {
                            "x": 302,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "ण",
                      "confidence": 0.8
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 302,
                            "y": 1025
                          },
                          {
                            "x": 320,
                            "y": 1025
                          },
                          {
                            "x": 320,
                            "y": 1069
                          },
                          {
                            "x": 302,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.8
                    }
                  ],
                  "confidence": 0.89
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 332,
                        "y": 1025
                      },
                      {
                        "x": 344,
                        "y": 1025
                      },
                      {
                        "x": 344,
                        "y": 1069
                      },
                      {
                        "x": 332,
                        "y": 1069
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 332,
                            "y": 1025
                          },
                          {
                            "x": 344,
                            "y": 1025
                          },
                          {
                            "x": 344,
                            "y": 1069
                          },
                          {
                            "x": 332,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "च",
                      "confidence": 0.94
                    }
                  ],
                  "confidence": 0.94
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 391,
                        "y": 1025
                      },
                      {
                        "x": 424,
                        "y": 1025
                      },
                      {
                        "x": 424,
                        "y": 1069
                      },
                      {
                        "x": 391,
                        "y": 1069
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 391,
                            "y": 1025
                          },
                          {
                            "x": 410,
                            "y": 1025
                          },
                          {
                            "x": 410,
                            "y": 1069
                          },
                          {
                            "x": 391,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.91
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 391,
                            "y": 1025
                          },
                          {
                            "x": 410,
                            "y": 1025
                          },
                          {
                            "x": 410,
                            "y": 1069
                          },
                          {
                            "x": 391,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.91
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 413,
                            "y": 1025
                          },
                          {
                            "x": 424,
                            "y": 1025
                          },
                          {
                            "x": 424,
                            "y": 1069
                          },
                          {
                            "x": 413,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.89
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 413,
                            "y": 1025
                          },
                          {
                            "x": 424,
                            "y": 1025
                          },
                          {
                            "x": 424,
                            "y": 1069
                          },
                          {
                            "x": 413,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.89
                    }
                  ],
                  "confidence": 0.9
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 439,
                        "y": 1025
                      },
                      {
                        "x": 491,
                        "y": 1025
                      },
                      {
                        "x": 491,
                        "y": 1069
                      },
                      {
                        "x": 439,
                        "y": 1069
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 439,
                            "y": 1025
                          },
                          {
                            "x": 453,
                            "y": 1025
                          },
                          {
                            "x": 453,
                            "y": 1069
                          },
                          {
                            "x": 439,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 457,
                            "y": 1025
                          },
                          {
                            "x": 479,
                            "y": 1025
                          },
                          {
                            "x": 479,
                            "y": 1069
                          },
                          {
                            "x": 457,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 457,
                            "y": 1025
                          },
                          {
                            "x": 479,
                            "y": 1025
                          },
                          {
                            "x": 479,
                            "y": 1069
                          },
                          {
                            "x": 457,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 481,
                            "y": 1025
                          },
                          {
                            "x": 491,
                            "y": 1025
                          },
                          {
                            "x": 491,
                            "y": 1069
                          },
                          {
                            "x": 481,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.92
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 481,
                            "y": 1025
                          },
                          {
                            "x": 491,
                            "y": 1025
                          },
                          {
                            "x": 491,
                            "y": 1069
                          },
                          {
                            "x": 481,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.92
                    }
                  ],
                  "confidence": 0.96
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 500,
                        "y": 1025
                      },
                      {
                        "x": 610,
                        "y": 1025
                      },
                      {
                        "x": 610,
                        "y": 1069
                      },
                      {
                        "x": 500,
                        "y": 1069
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 500,
                            "y": 1025
                          },
                          {
                            "x": 518,
                            "y": 1025
                          },
                          {
                            "x": 518,
                            "y": 1069
                          },
                          {
                            "x": 500,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 523,
                            "y": 1025
                          },
                          {
                            "x": 540,
                            "y": 1025
                          },
                          {
                            "x": 540,
                            "y": 1069
                          },
                          {
                            "x": 523,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 523,
                            "y": 1025
                          },
                          {
                            "x": 540,
                            "y": 1025
                          },
                          {
                            "x": 540,
                            "y": 1069
                          },
                          {
                            "x": 523,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 523,
                            "y": 1025
                          },
                          {
                            "x": 540,
                            "y": 1025
                          },
                          {
                            "x": 540,
                            "y": 1069
                          },
                          {
                            "x": 523,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 546,
                            "y": 1025
                          },
                          {
                            "x": 562,
                            "y": 1025
                          },
                          {
                            "x": 562,
                            "y": 1069
                          },
                          {
                            "x": 546,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 546,
                            "y": 1025
                          },
                          {
                            "x": 562,
                            "y": 1025
                          },
                          {
                            "x": 562,
                            "y": 1069
                          },
                          {
                            "x": 546,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "ु",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 564,
                            "y": 1025
                          },
                          {
                            "x": 592,
                            "y": 1025
                          },
                          {
                            "x": 592,
                            "y": 1069
                          },
                          {
                            "x": 564,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "च",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 564,
                            "y": 1025
                          },
                          {
                            "x": 592,
                            "y": 1025
                          },
                          {
                            "x": 592,
                            "y": 1069
                          },
                          {
                            "x": 564,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 564,
                            "y": 1025
                          },
                          {
                            "x": 592,
                            "y": 1025
                          },
                          {
                            "x": 592,
                            "y": 1069
                          },
                          {
                            "x": 564,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 596,
                            "y": 1025
                          },
                          {
                            "x": 610,
                            "y": 1025
                          },
                          {
                            "x": 610,
                            "y": 1069
                          },
                          {
                            "x": 596,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 596,
                            "y": 1025
                          },
                          {
                            "x": 610,
                            "y": 1025
                          },
                          {
                            "x": 610,
                            "y": 1069
                          },
                          {
                            "x": 596,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "े",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "hi"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 620,
                        "y": 1025
                      },
                      {
                        "x": 632,
                        "y": 1025
                      },
                      {
                        "x": 632,
                        "y": 1069
                      },
                      {
                        "x": 620,
                        "y": 1069
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "hi"
                          }
                        ],
                        "detectedBreak": {
                          "type": "EOL_SURE_SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 620,
                            "y": 1025
                          },
                          {
                            "x": 632,
                            "y": 1025
                          },
                          {
                            "x": 632,
                            "y": 1069
                          },
                          {
                            "x": 620,
                            "y": 1069
                          }
                        ]
                      },
                      "text": "।",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 238,
                        "y": 1071
                      },
                      {
                        "x": 301,
                        "y": 1071
                      },
                      {
                        "x": 301,
                        "y": 1112
                      },
                      {
                        "x": 238,
                        "y": 1112
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 238,
                            "y": 1071
                          },
                          {
                            "x": 263,
                            "y": 1071
                          },
                          {
                            "x": 263,
                            "y": 1112
                          },
                          {
                            "x": 238,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 238,
                            "y": 1071
                          },
                          {
                            "x": 263,
                            "y": 1071
                          },
                          {
                            "x": 263,
                            "y": 1112
                          },
                          {
                            "x": 238,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "ो",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 269,
                            "y": 1071
                          },
                          {
                            "x": 291,
                            "y": 1071
                          },
                          {
                            "x": 291,
                            "y": 1112
                          },
                          {
                            "x": 269,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 269,
                            "y": 1071
                          },
                          {
                            "x": 291,
                            "y": 1071
                          },
                          {
                            "x": 291,
                            "y": 1112
                          },
                          {
                            "x": 269,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 292,
                            "y": 1071
                          },
                          {
                            "x": 301,
                            "y": 1071
                          },
                          {
                            "x": 301,
                            "y": 1112
                          },
                          {
                            "x": 292,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 292,
                            "y": 1071
                          },
                          {
                            "x": 301,
                            "y": 1071
                          },
                          {
                            "x": 301,
                            "y": 1112
                          },
                          {
                            "x": 292,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.93
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 313,
                        "y": 1071
                      },
                      {
                        "x": 379,
                        "y": 1071
                      },
                      {
                        "x": 379,
                        "y": 1112
                      },
                      {
                        "x": 313,
                        "y": 1112
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 313,
                            "y": 1071
                          },
                          {
                            "x": 330,
                            "y": 1071
                          },
                          {
                            "x": 330,
                            "y": 1112
                          },
                          {
                            "x": 313,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 335,
                            "y": 1071
                          },
                          {
                            "x": 350,
                            "y": 1071
                          },
                          {
                            "x": 350,
                            "y": 1112
                          },
                          {
                            "x": 335,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 335,
                            "y": 1071
                          },
                          {
                            "x": 350,
                            "y": 1071
                          },
                          {
                            "x": 350,
                            "y": 1112
                          },
                          {
                            "x": 335,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 335,
                            "y": 1071
                          },
                          {
                            "x": 350,
                            "y": 1071
                          },
                          {
                            "x": 350,
                            "y": 1112
                          },
                          {
                            "x": 335,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "ण",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 353,
                            "y": 1071
                          },
                          {
                            "x": 379,
                            "y": 1071
                          },
                          {
                            "x": 379,
                            "y": 1112
                          },
                          {
                            "x": 353,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 353,
                            "y": 1071
                          },
                          {
                            "x": 379,
                            "y": 1071
                          },
                          {
                            "x": 379,
                            "y": 1112
                          },
                          {
                            "x": 353,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "ः",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.96
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 395,
                        "y": 1071
                      },
                      {
                        "x": 442,
                        "y": 1071
                      },
                      {
                        "x": 442,
                        "y": 1112
                      },
                      {
                        "x": 395,
                        "y": 1112
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 395,
                            "y": 1071
                          },
                          {
                            "x": 408,
                            "y": 1071
                          },
                          {
                            "x": 408,
                            "y": 1112
                          },
                          {
                            "x": 395,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 395,
                            "y": 1071
                          },
                          {
                            "x": 408,
                            "y": 1071
                          },
                          {
                            "x": 408,
                            "y": 1112
                          },
                          {
                            "x": 395,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "ृ",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 412,
                            "y": 1071
                          },
                          {
                            "x": 442,
                            "y": 1071
                          },
                          {
                            "x": 442,
                            "y": 1112
                          },
                          {
                            "x": 412,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "ष",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 412,
                            "y": 1071
                          },
                          {
                            "x": 442,
                            "y": 1071
                          },
                          {
                            "x": 442,
                            "y": 1112
                          },
                          {
                            "x": 412,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 412,
                            "y": 1071
                          },
                          {
                            "x": 442,
                            "y": 1071
                          },
                          {
                            "x": 442,
                            "y": 1112
                          },
                          {
                            "x": 412,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "ण",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 412,
                            "y": 1071
                          },
                          {
                            "x": 442,
                            "y": 1071
                          },
                          {
                            "x": 442,
                            "y": 1112
                          },
                          {
                            "x": 412,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.97
                    }
                  ],
                  "confidence": 0.96
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 454,
                        "y": 1071
                      },
                      {
                        "x": 516,
                        "y": 1071
                      },
                      {
                        "x": 516,
                        "y": 1112
                      },
                      {
                        "x": 454,
                        "y": 1112
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 454,
                            "y": 1071
                          },
                          {
                            "x": 476,
                            "y": 1071
                          },
                          {
                            "x": 476,
                            "y": 1112
                          },
                          {
                            "x": 454,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 454,
                            "y": 1071
                          },
                          {
                            "x": 476,
                            "y": 1071
                          },
                          {
                            "x": 476,
                            "y": 1112
                          },
                          {
                            "x": 454,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 480,
                            "y": 1071
                          },
                          {
                            "x": 504,
                            "y": 1071
                          },
                          {
                            "x": 504,
                            "y": 1112
                          },
                          {
                            "x": 480,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 480,
                            "y": 1071
                          },
                          {
                            "x": 504,
                            "y": 1071
                          },
                          {
                            "x": 504,
                            "y": 1112
                          },
                          {
                            "x": 480,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 506,
                            "y": 1071
                          },
                          {
                            "x": 516,
                            "y": 1071
                          },
                          {
                            "x": 516,
                            "y": 1112
                          },
                          {
                            "x": 506,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 506,
                            "y": 1071
                          },
                          {
                            "x": 516,
                            "y": 1071
                          },
                          {
                            "x": 516,
                            "y": 1112
                          },
                          {
                            "x": 506,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.94
                    }
                  ],
                  "confidence": 0.96
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 523,
                        "y": 1071
                      },
                      {
                        "x": 637,
                        "y": 1071
                      },
                      {
                        "x": 637,
                        "y": 1112
                      },
                      {
                        "x": 523,
                        "y": 1112
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 523,
                            "y": 1071
                          },
                          {
                            "x": 540,
                            "y": 1071
                          },
                          {
                            "x": 540,
                            "y": 1112
                          },
                          {
                            "x": 523,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 544,
                            "y": 1071
                          },
                          {
                            "x": 561,
                            "y": 1071
                          },
                          {
                            "x": 561,
                            "y": 1112
                          },
                          {
                            "x": 544,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 544,
                            "y": 1071
                          },
                          {
                            "x": 561,
                            "y": 1071
                          },
                          {
                            "x": 561,
                            "y": 1112
                          },
                          {
                            "x": 544,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 544,
                            "y": 1071
                          },
                          {
                            "x": 561,
                            "y": 1071
                          },
                          {
                            "x": 561,
                            "y": 1112
                          },
                          {
                            "x": 544,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 565,
                            "y": 1071
                          },
                          {
                            "x": 582,
                            "y": 1071
                          },
                          {
                            "x": 582,
                            "y": 1112
                          },
                          {
                            "x": 565,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 565,
                            "y": 1071
                          },
                          {
                            "x": 582,
                            "y": 1071
                          },
                          {
                            "x": 582,
                            "y": 1112
                          },
                          {
                            "x": 565,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "ु",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 586,
                            "y": 1071
                          },
                          {
                            "x": 615,
                            "y": 1071
                          },
                          {
                            "x": 615,
                            "y": 1112
                          },
                          {
                            "x": 586,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "च",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 586,
                            "y": 1071
                          },
                          {
                            "x": 615,
                            "y": 1071
                          },
                          {
                            "x": 615,
                            "y": 1112
                          },
                          {
                            "x": 586,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 586,
                            "y": 1071
                          },
                          {
                            "x": 615,
                            "y": 1071
                          },
                          {
                            "x": 615,
                            "y": 1112
                          },
                          {
                            "x": 586,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 620,
                            "y": 1071
                          },
                          {
                            "x": 637,
                            "y": 1071
                          },
                          {
                            "x": 637,
                            "y": 1112
                          },
                          {
                            "x": 620,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 620,
                            "y": 1071
                          },
                          {
                            "x": 637,
                            "y": 1071
                          },
                          {
                            "x": 637,
                            "y": 1112
                          },
                          {
                            "x": 620,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "े",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 652,
                        "y": 1071
                      },
                      {
                        "x": 663,
                        "y": 1071
                      },
                      {
                        "x": 663,
                        "y": 1112
                      },
                      {
                        "x": 652,
                        "y": 1112
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 652,
                            "y": 1071
                          },
                          {
                            "x": 663,
                            "y": 1071
                          },
                          {
                            "x": 663,
                            "y": 1112
                          },
                          {
                            "x": 652,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "॥",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 678,
                        "y": 1071
                      },
                      {
                        "x": 689,
                        "y": 1071
                      },
                      {
                        "x": 689,
                        "y": 1112
                      },
                      {
                        "x": 678,
                        "y": 1112
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 678,
                            "y": 1071
                          },
                          {
                            "x": 689,
                            "y": 1071
                          },
                          {
                            "x": 689,
                            "y": 1112
                          },
                          {
                            "x": 678,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "६",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 703,
                        "y": 1071
                      },
                      {
                        "x": 714,
                        "y": 1071
                      },
                      {
                        "x": 714,
                        "y": 1112
                      },
                      {
                        "x": 703,
                        "y": 1112
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "EOL_SURE_SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 703,
                            "y": 1071
                          },
                          {
                            "x": 714,
                            "y": 1071
                          },
                          {
                            "x": 714,
                            "y": 1112
                          },
                          {
                            "x": 703,
                            "y": 1112
                          }
                        ]
                      },
                      "text": "॥",
                      "confidence": 0.93
                    }
                  ],
                  "confidence": 0.93
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 241,
                        "y": 1129
                      },
                      {
                        "x": 296,
                        "y": 1129
                      },
                      {
                        "x": 296,
                        "y": 1175
                      },
                      {
                        "x": 241,
                        "y": 1175
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 241,
                            "y": 1129
                          },
                          {
                            "x": 256,
                            "y": 1129
                          },
                          {
                            "x": 256,
                            "y": 1175
                          },
                          {
                            "x": 241,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 241,
                            "y": 1129
                          },
                          {
                            "x": 256,
                            "y": 1129
                          },
                          {
                            "x": 256,
                            "y": 1175
                          },
                          {
                            "x": 241,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 261,
                            "y": 1129
                          },
                          {
                            "x": 284,
                            "y": 1129
                          },
                          {
                            "x": 284,
                            "y": 1175
                          },
                          {
                            "x": 261,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 261,
                            "y": 1129
                          },
                          {
                            "x": 284,
                            "y": 1129
                          },
                          {
                            "x": 284,
                            "y": 1175
                          },
                          {
                            "x": 261,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 285,
                            "y": 1129
                          },
                          {
                            "x": 296,
                            "y": 1129
                          },
                          {
                            "x": 296,
                            "y": 1175
                          },
                          {
                            "x": 285,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 285,
                            "y": 1129
                          },
                          {
                            "x": 296,
                            "y": 1129
                          },
                          {
                            "x": 296,
                            "y": 1175
                          },
                          {
                            "x": 285,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.94
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 311,
                        "y": 1129
                      },
                      {
                        "x": 396,
                        "y": 1129
                      },
                      {
                        "x": 396,
                        "y": 1175
                      },
                      {
                        "x": 311,
                        "y": 1175
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 311,
                            "y": 1129
                          },
                          {
                            "x": 326,
                            "y": 1129
                          },
                          {
                            "x": 326,
                            "y": 1175
                          },
                          {
                            "x": 311,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 311,
                            "y": 1129
                          },
                          {
                            "x": 326,
                            "y": 1129
                          },
                          {
                            "x": 326,
                            "y": 1175
                          },
                          {
                            "x": 311,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "ु",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 329,
                            "y": 1129
                          },
                          {
                            "x": 346,
                            "y": 1129
                          },
                          {
                            "x": 346,
                            "y": 1175
                          },
                          {
                            "x": 329,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "ङ",
                      "confidence": 0.84
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 329,
                            "y": 1129
                          },
                          {
                            "x": 346,
                            "y": 1129
                          },
                          {
                            "x": 346,
                            "y": 1175
                          },
                          {
                            "x": 329,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.84
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 329,
                            "y": 1129
                          },
                          {
                            "x": 346,
                            "y": 1129
                          },
                          {
                            "x": 346,
                            "y": 1175
                          },
                          {
                            "x": 329,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.84
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 329,
                            "y": 1129
                          },
                          {
                            "x": 346,
                            "y": 1129
                          },
                          {
                            "x": 346,
                            "y": 1175
                          },
                          {
                            "x": 329,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "ु",
                      "confidence": 0.84
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 353,
                            "y": 1129
                          },
                          {
                            "x": 379,
                            "y": 1129
                          },
                          {
                            "x": 379,
                            "y": 1175
                          },
                          {
                            "x": 353,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 353,
                            "y": 1129
                          },
                          {
                            "x": 379,
                            "y": 1129
                          },
                          {
                            "x": 379,
                            "y": 1175
                          },
                          {
                            "x": 353,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 382,
                            "y": 1129
                          },
                          {
                            "x": 396,
                            "y": 1129
                          },
                          {
                            "x": 396,
                            "y": 1175
                          },
                          {
                            "x": 382,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "भ",
                      "confidence": 0.73
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 382,
                            "y": 1129
                          },
                          {
                            "x": 396,
                            "y": 1129
                          },
                          {
                            "x": 396,
                            "y": 1175
                          },
                          {
                            "x": 382,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.73
                    }
                  ],
                  "confidence": 0.87
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 406,
                        "y": 1129
                      },
                      {
                        "x": 419,
                        "y": 1129
                      },
                      {
                        "x": 419,
                        "y": 1175
                      },
                      {
                        "x": 406,
                        "y": 1175
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 406,
                            "y": 1129
                          },
                          {
                            "x": 419,
                            "y": 1129
                          },
                          {
                            "x": 419,
                            "y": 1175
                          },
                          {
                            "x": 406,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.89
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 406,
                            "y": 1129
                          },
                          {
                            "x": 419,
                            "y": 1129
                          },
                          {
                            "x": 419,
                            "y": 1175
                          },
                          {
                            "x": 406,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "ु",
                      "confidence": 0.89
                    }
                  ],
                  "confidence": 0.89
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 433,
                        "y": 1129
                      },
                      {
                        "x": 489,
                        "y": 1129
                      },
                      {
                        "x": 489,
                        "y": 1175
                      },
                      {
                        "x": 433,
                        "y": 1175
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 433,
                            "y": 1129
                          },
                          {
                            "x": 448,
                            "y": 1129
                          },
                          {
                            "x": 448,
                            "y": 1175
                          },
                          {
                            "x": 433,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 453,
                            "y": 1129
                          },
                          {
                            "x": 476,
                            "y": 1129
                          },
                          {
                            "x": 476,
                            "y": 1175
                          },
                          {
                            "x": 453,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 453,
                            "y": 1129
                          },
                          {
                            "x": 476,
                            "y": 1129
                          },
                          {
                            "x": 476,
                            "y": 1175
                          },
                          {
                            "x": 453,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 478,
                            "y": 1129
                          },
                          {
                            "x": 489,
                            "y": 1129
                          },
                          {
                            "x": 489,
                            "y": 1175
                          },
                          {
                            "x": 478,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 478,
                            "y": 1129
                          },
                          {
                            "x": 489,
                            "y": 1129
                          },
                          {
                            "x": 489,
                            "y": 1175
                          },
                          {
                            "x": 478,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.94
                    }
                  ],
                  "confidence": 0.96
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 499,
                        "y": 1129
                      },
                      {
                        "x": 613,
                        "y": 1129
                      },
                      {
                        "x": 613,
                        "y": 1175
                      },
                      {
                        "x": 499,
                        "y": 1175
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 499,
                            "y": 1129
                          },
                          {
                            "x": 524,
                            "y": 1129
                          },
                          {
                            "x": 524,
                            "y": 1175
                          },
                          {
                            "x": 499,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "प",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 499,
                            "y": 1129
                          },
                          {
                            "x": 524,
                            "y": 1129
                          },
                          {
                            "x": 524,
                            "y": 1175
                          },
                          {
                            "x": 499,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "ी",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 528,
                            "y": 1129
                          },
                          {
                            "x": 543,
                            "y": 1129
                          },
                          {
                            "x": 543,
                            "y": 1175
                          },
                          {
                            "x": 528,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 546,
                            "y": 1129
                          },
                          {
                            "x": 561,
                            "y": 1129
                          },
                          {
                            "x": 561,
                            "y": 1175
                          },
                          {
                            "x": 546,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 546,
                            "y": 1129
                          },
                          {
                            "x": 561,
                            "y": 1129
                          },
                          {
                            "x": 561,
                            "y": 1175
                          },
                          {
                            "x": 546,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "ु",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 565,
                            "y": 1129
                          },
                          {
                            "x": 594,
                            "y": 1129
                          },
                          {
                            "x": 594,
                            "y": 1175
                          },
                          {
                            "x": 565,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "च",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 565,
                            "y": 1129
                          },
                          {
                            "x": 594,
                            "y": 1129
                          },
                          {
                            "x": 594,
                            "y": 1175
                          },
                          {
                            "x": 565,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 565,
                            "y": 1129
                          },
                          {
                            "x": 594,
                            "y": 1129
                          },
                          {
                            "x": 594,
                            "y": 1175
                          },
                          {
                            "x": 565,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 598,
                            "y": 1129
                          },
                          {
                            "x": 613,
                            "y": 1129
                          },
                          {
                            "x": 613,
                            "y": 1175
                          },
                          {
                            "x": 598,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 598,
                            "y": 1129
                          },
                          {
                            "x": 613,
                            "y": 1129
                          },
                          {
                            "x": 613,
                            "y": 1175
                          },
                          {
                            "x": 598,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "े",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 618,
                        "y": 1129
                      },
                      {
                        "x": 631,
                        "y": 1129
                      },
                      {
                        "x": 631,
                        "y": 1175
                      },
                      {
                        "x": 618,
                        "y": 1175
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "EOL_SURE_SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 618,
                            "y": 1129
                          },
                          {
                            "x": 631,
                            "y": 1129
                          },
                          {
                            "x": 631,
                            "y": 1175
                          },
                          {
                            "x": 618,
                            "y": 1175
                          }
                        ]
                      },
                      "text": "।",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 239,
                        "y": 1176
                      },
                      {
                        "x": 390,
                        "y": 1176
                      },
                      {
                        "x": 390,
                        "y": 1219
                      },
                      {
                        "x": 239,
                        "y": 1219
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 239,
                            "y": 1176
                          },
                          {
                            "x": 265,
                            "y": 1176
                          },
                          {
                            "x": 265,
                            "y": 1219
                          },
                          {
                            "x": 239,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "ण",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 239,
                            "y": 1176
                          },
                          {
                            "x": 265,
                            "y": 1176
                          },
                          {
                            "x": 265,
                            "y": 1219
                          },
                          {
                            "x": 239,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 271,
                            "y": 1176
                          },
                          {
                            "x": 294,
                            "y": 1176
                          },
                          {
                            "x": 294,
                            "y": 1219
                          },
                          {
                            "x": 271,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 271,
                            "y": 1176
                          },
                          {
                            "x": 294,
                            "y": 1176
                          },
                          {
                            "x": 294,
                            "y": 1219
                          },
                          {
                            "x": 271,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 294,
                            "y": 1176
                          },
                          {
                            "x": 306,
                            "y": 1176
                          },
                          {
                            "x": 306,
                            "y": 1219
                          },
                          {
                            "x": 294,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 310,
                            "y": 1176
                          },
                          {
                            "x": 325,
                            "y": 1176
                          },
                          {
                            "x": 325,
                            "y": 1219
                          },
                          {
                            "x": 310,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 331,
                            "y": 1176
                          },
                          {
                            "x": 347,
                            "y": 1176
                          },
                          {
                            "x": 347,
                            "y": 1219
                          },
                          {
                            "x": 331,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "ञ",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 331,
                            "y": 1176
                          },
                          {
                            "x": 347,
                            "y": 1176
                          },
                          {
                            "x": 347,
                            "y": 1219
                          },
                          {
                            "x": 331,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 331,
                            "y": 1176
                          },
                          {
                            "x": 347,
                            "y": 1176
                          },
                          {
                            "x": 347,
                            "y": 1219
                          },
                          {
                            "x": 331,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "ज",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 350,
                            "y": 1176
                          },
                          {
                            "x": 373,
                            "y": 1176
                          },
                          {
                            "x": 373,
                            "y": 1219
                          },
                          {
                            "x": 350,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 350,
                            "y": 1176
                          },
                          {
                            "x": 373,
                            "y": 1176
                          },
                          {
                            "x": 373,
                            "y": 1219
                          },
                          {
                            "x": 350,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 377,
                            "y": 1176
                          },
                          {
                            "x": 390,
                            "y": 1176
                          },
                          {
                            "x": 390,
                            "y": 1219
                          },
                          {
                            "x": 377,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "भ",
                      "confidence": 0.9
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 377,
                            "y": 1176
                          },
                          {
                            "x": 390,
                            "y": 1176
                          },
                          {
                            "x": 390,
                            "y": 1219
                          },
                          {
                            "x": 377,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.9
                    }
                  ],
                  "confidence": 0.96
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 404,
                        "y": 1176
                      },
                      {
                        "x": 416,
                        "y": 1176
                      },
                      {
                        "x": 416,
                        "y": 1219
                      },
                      {
                        "x": 404,
                        "y": 1219
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 404,
                            "y": 1176
                          },
                          {
                            "x": 416,
                            "y": 1176
                          },
                          {
                            "x": 416,
                            "y": 1219
                          },
                          {
                            "x": 404,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 404,
                            "y": 1176
                          },
                          {
                            "x": 416,
                            "y": 1176
                          },
                          {
                            "x": 416,
                            "y": 1219
                          },
                          {
                            "x": 404,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "ु",
                      "confidence": 0.94
                    }
                  ],
                  "confidence": 0.94
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 428,
                        "y": 1176
                      },
                      {
                        "x": 485,
                        "y": 1176
                      },
                      {
                        "x": 485,
                        "y": 1219
                      },
                      {
                        "x": 428,
                        "y": 1219
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 428,
                            "y": 1176
                          },
                          {
                            "x": 445,
                            "y": 1176
                          },
                          {
                            "x": 445,
                            "y": 1219
                          },
                          {
                            "x": 428,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 451,
                            "y": 1176
                          },
                          {
                            "x": 474,
                            "y": 1176
                          },
                          {
                            "x": 474,
                            "y": 1219
                          },
                          {
                            "x": 451,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 451,
                            "y": 1176
                          },
                          {
                            "x": 474,
                            "y": 1176
                          },
                          {
                            "x": 474,
                            "y": 1219
                          },
                          {
                            "x": 451,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 475,
                            "y": 1176
                          },
                          {
                            "x": 485,
                            "y": 1176
                          },
                          {
                            "x": 485,
                            "y": 1219
                          },
                          {
                            "x": 475,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 475,
                            "y": 1176
                          },
                          {
                            "x": 485,
                            "y": 1176
                          },
                          {
                            "x": 485,
                            "y": 1219
                          },
                          {
                            "x": 475,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.93
                    }
                  ],
                  "confidence": 0.96
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 502,
                        "y": 1176
                      },
                      {
                        "x": 608,
                        "y": 1176
                      },
                      {
                        "x": 608,
                        "y": 1219
                      },
                      {
                        "x": 502,
                        "y": 1219
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 502,
                            "y": 1176
                          },
                          {
                            "x": 512,
                            "y": 1176
                          },
                          {
                            "x": 512,
                            "y": 1219
                          },
                          {
                            "x": 502,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "ब",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 514,
                            "y": 1176
                          },
                          {
                            "x": 526,
                            "y": 1176
                          },
                          {
                            "x": 526,
                            "y": 1219
                          },
                          {
                            "x": 514,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "ह",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 514,
                            "y": 1176
                          },
                          {
                            "x": 526,
                            "y": 1176
                          },
                          {
                            "x": 526,
                            "y": 1219
                          },
                          {
                            "x": 514,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "ु",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 530,
                            "y": 1176
                          },
                          {
                            "x": 545,
                            "y": 1176
                          },
                          {
                            "x": 545,
                            "y": 1219
                          },
                          {
                            "x": 530,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 551,
                            "y": 1176
                          },
                          {
                            "x": 567,
                            "y": 1176
                          },
                          {
                            "x": 567,
                            "y": 1219
                          },
                          {
                            "x": 551,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 1
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 551,
                            "y": 1176
                          },
                          {
                            "x": 567,
                            "y": 1176
                          },
                          {
                            "x": 567,
                            "y": 1219
                          },
                          {
                            "x": 551,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 1
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 551,
                            "y": 1176
                          },
                          {
                            "x": 567,
                            "y": 1176
                          },
                          {
                            "x": 567,
                            "y": 1219
                          },
                          {
                            "x": 551,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "ण",
                      "confidence": 1
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 569,
                            "y": 1176
                          },
                          {
                            "x": 585,
                            "y": 1176
                          },
                          {
                            "x": 585,
                            "y": 1219
                          },
                          {
                            "x": 569,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 591,
                            "y": 1176
                          },
                          {
                            "x": 608,
                            "y": 1176
                          },
                          {
                            "x": 608,
                            "y": 1219
                          },
                          {
                            "x": 591,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 591,
                            "y": 1176
                          },
                          {
                            "x": 608,
                            "y": 1176
                          },
                          {
                            "x": 608,
                            "y": 1219
                          },
                          {
                            "x": 591,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 624,
                        "y": 1176
                      },
                      {
                        "x": 636,
                        "y": 1176
                      },
                      {
                        "x": 636,
                        "y": 1219
                      },
                      {
                        "x": 624,
                        "y": 1219
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 624,
                            "y": 1176
                          },
                          {
                            "x": 636,
                            "y": 1176
                          },
                          {
                            "x": 636,
                            "y": 1219
                          },
                          {
                            "x": 624,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "॥",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 650,
                        "y": 1176
                      },
                      {
                        "x": 662,
                        "y": 1176
                      },
                      {
                        "x": 662,
                        "y": 1219
                      },
                      {
                        "x": 650,
                        "y": 1219
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 650,
                            "y": 1176
                          },
                          {
                            "x": 662,
                            "y": 1176
                          },
                          {
                            "x": 662,
                            "y": 1219
                          },
                          {
                            "x": 650,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "७",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 672,
                        "y": 1176
                      },
                      {
                        "x": 684,
                        "y": 1176
                      },
                      {
                        "x": 684,
                        "y": 1219
                      },
                      {
                        "x": 672,
                        "y": 1219
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "EOL_SURE_SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 672,
                            "y": 1176
                          },
                          {
                            "x": 684,
                            "y": 1176
                          },
                          {
                            "x": 684,
                            "y": 1219
                          },
                          {
                            "x": 672,
                            "y": 1219
                          }
                        ]
                      },
                      "text": "॥",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 247,
                        "y": 1227
                      },
                      {
                        "x": 260,
                        "y": 1227
                      },
                      {
                        "x": 260,
                        "y": 1275
                      },
                      {
                        "x": 247,
                        "y": 1275
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 247,
                            "y": 1227
                          },
                          {
                            "x": 260,
                            "y": 1227
                          },
                          {
                            "x": 260,
                            "y": 1275
                          },
                          {
                            "x": 247,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "ॐ",
                      "confidence": 0.95
                    }
                  ],
                  "confidence": 0.95
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 275,
                        "y": 1227
                      },
                      {
                        "x": 315,
                        "y": 1227
                      },
                      {
                        "x": 315,
                        "y": 1275
                      },
                      {
                        "x": 275,
                        "y": 1275
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 275,
                            "y": 1227
                          },
                          {
                            "x": 291,
                            "y": 1227
                          },
                          {
                            "x": 291,
                            "y": 1275
                          },
                          {
                            "x": 275,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 295,
                            "y": 1227
                          },
                          {
                            "x": 315,
                            "y": 1227
                          },
                          {
                            "x": 315,
                            "y": 1275
                          },
                          {
                            "x": 295,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 295,
                            "y": 1227
                          },
                          {
                            "x": 315,
                            "y": 1227
                          },
                          {
                            "x": 315,
                            "y": 1275
                          },
                          {
                            "x": 295,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "ो",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 329,
                        "y": 1227
                      },
                      {
                        "x": 458,
                        "y": 1227
                      },
                      {
                        "x": 458,
                        "y": 1275
                      },
                      {
                        "x": 329,
                        "y": 1275
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 329,
                            "y": 1227
                          },
                          {
                            "x": 349,
                            "y": 1227
                          },
                          {
                            "x": 349,
                            "y": 1275
                          },
                          {
                            "x": 329,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 329,
                            "y": 1227
                          },
                          {
                            "x": 349,
                            "y": 1227
                          },
                          {
                            "x": 349,
                            "y": 1275
                          },
                          {
                            "x": 329,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 353,
                            "y": 1227
                          },
                          {
                            "x": 369,
                            "y": 1227
                          },
                          {
                            "x": 369,
                            "y": 1275
                          },
                          {
                            "x": 353,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 353,
                            "y": 1227
                          },
                          {
                            "x": 369,
                            "y": 1227
                          },
                          {
                            "x": 369,
                            "y": 1275
                          },
                          {
                            "x": 353,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 372,
                            "y": 1227
                          },
                          {
                            "x": 390,
                            "y": 1227
                          },
                          {
                            "x": 390,
                            "y": 1275
                          },
                          {
                            "x": 372,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 396,
                            "y": 1227
                          },
                          {
                            "x": 419,
                            "y": 1227
                          },
                          {
                            "x": 419,
                            "y": 1275
                          },
                          {
                            "x": 396,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "ण",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 396,
                            "y": 1227
                          },
                          {
                            "x": 419,
                            "y": 1227
                          },
                          {
                            "x": 419,
                            "y": 1275
                          },
                          {
                            "x": 396,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 424,
                            "y": 1227
                          },
                          {
                            "x": 436,
                            "y": 1227
                          },
                          {
                            "x": 436,
                            "y": 1275
                          },
                          {
                            "x": 424,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 424,
                            "y": 1227
                          },
                          {
                            "x": 436,
                            "y": 1227
                          },
                          {
                            "x": 436,
                            "y": 1275
                          },
                          {
                            "x": 424,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "े",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 436,
                            "y": 1227
                          },
                          {
                            "x": 458,
                            "y": 1227
                          },
                          {
                            "x": 458,
                            "y": 1275
                          },
                          {
                            "x": 436,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 436,
                            "y": 1227
                          },
                          {
                            "x": 458,
                            "y": 1227
                          },
                          {
                            "x": 458,
                            "y": 1275
                          },
                          {
                            "x": 436,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "ि",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 480,
                        "y": 1227
                      },
                      {
                        "x": 522,
                        "y": 1227
                      },
                      {
                        "x": 522,
                        "y": 1275
                      },
                      {
                        "x": 480,
                        "y": 1275
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 480,
                            "y": 1227
                          },
                          {
                            "x": 488,
                            "y": 1227
                          },
                          {
                            "x": 488,
                            "y": 1275
                          },
                          {
                            "x": 480,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 490,
                            "y": 1227
                          },
                          {
                            "x": 522,
                            "y": 1227
                          },
                          {
                            "x": 522,
                            "y": 1275
                          },
                          {
                            "x": 490,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.67
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 490,
                            "y": 1227
                          },
                          {
                            "x": 522,
                            "y": 1227
                          },
                          {
                            "x": 522,
                            "y": 1275
                          },
                          {
                            "x": 490,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.67
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 490,
                            "y": 1227
                          },
                          {
                            "x": 522,
                            "y": 1227
                          },
                          {
                            "x": 522,
                            "y": 1275
                          },
                          {
                            "x": 490,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.67
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 490,
                            "y": 1227
                          },
                          {
                            "x": 522,
                            "y": 1227
                          },
                          {
                            "x": 522,
                            "y": 1275
                          },
                          {
                            "x": 490,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.67
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 490,
                            "y": 1227
                          },
                          {
                            "x": 522,
                            "y": 1227
                          },
                          {
                            "x": 522,
                            "y": 1275
                          },
                          {
                            "x": 490,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.67
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 490,
                            "y": 1227
                          },
                          {
                            "x": 522,
                            "y": 1227
                          },
                          {
                            "x": 522,
                            "y": 1275
                          },
                          {
                            "x": 490,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "ः",
                      "confidence": 0.67
                    }
                  ],
                  "confidence": 0.71
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 542,
                        "y": 1227
                      },
                      {
                        "x": 675,
                        "y": 1227
                      },
                      {
                        "x": 675,
                        "y": 1275
                      },
                      {
                        "x": 542,
                        "y": 1275
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 542,
                            "y": 1227
                          },
                          {
                            "x": 553,
                            "y": 1227
                          },
                          {
                            "x": 553,
                            "y": 1275
                          },
                          {
                            "x": 542,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 553,
                            "y": 1227
                          },
                          {
                            "x": 571,
                            "y": 1227
                          },
                          {
                            "x": 571,
                            "y": 1275
                          },
                          {
                            "x": 553,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 553,
                            "y": 1227
                          },
                          {
                            "x": 571,
                            "y": 1227
                          },
                          {
                            "x": 571,
                            "y": 1275
                          },
                          {
                            "x": 553,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 553,
                            "y": 1227
                          },
                          {
                            "x": 571,
                            "y": 1227
                          },
                          {
                            "x": 571,
                            "y": 1275
                          },
                          {
                            "x": 553,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 553,
                            "y": 1227
                          },
                          {
                            "x": 571,
                            "y": 1227
                          },
                          {
                            "x": 571,
                            "y": 1275
                          },
                          {
                            "x": 553,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 582,
                            "y": 1227
                          },
                          {
                            "x": 602,
                            "y": 1227
                          },
                          {
                            "x": 602,
                            "y": 1275
                          },
                          {
                            "x": 582,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 582,
                            "y": 1227
                          },
                          {
                            "x": 602,
                            "y": 1227
                          },
                          {
                            "x": 602,
                            "y": 1275
                          },
                          {
                            "x": 582,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 582,
                            "y": 1227
                          },
                          {
                            "x": 602,
                            "y": 1227
                          },
                          {
                            "x": 602,
                            "y": 1275
                          },
                          {
                            "x": 582,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "थ",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 603,
                            "y": 1227
                          },
                          {
                            "x": 629,
                            "y": 1227
                          },
                          {
                            "x": 629,
                            "y": 1275
                          },
                          {
                            "x": 603,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 603,
                            "y": 1227
                          },
                          {
                            "x": 629,
                            "y": 1227
                          },
                          {
                            "x": 629,
                            "y": 1275
                          },
                          {
                            "x": 603,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 634,
                            "y": 1227
                          },
                          {
                            "x": 648,
                            "y": 1227
                          },
                          {
                            "x": 648,
                            "y": 1275
                          },
                          {
                            "x": 634,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "ध",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 649,
                            "y": 1227
                          },
                          {
                            "x": 675,
                            "y": 1227
                          },
                          {
                            "x": 675,
                            "y": 1275
                          },
                          {
                            "x": 649,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 649,
                            "y": 1227
                          },
                          {
                            "x": 675,
                            "y": 1227
                          },
                          {
                            "x": 675,
                            "y": 1275
                          },
                          {
                            "x": 649,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "ः",
                      "confidence": 0.96
                    }
                  ],
                  "confidence": 0.96
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 688,
                        "y": 1227
                      },
                      {
                        "x": 701,
                        "y": 1227
                      },
                      {
                        "x": 701,
                        "y": 1275
                      },
                      {
                        "x": 688,
                        "y": 1275
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "EOL_SURE_SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 688,
                            "y": 1227
                          },
                          {
                            "x": 701,
                            "y": 1227
                          },
                          {
                            "x": 701,
                            "y": 1275
                          },
                          {
                            "x": 688,
                            "y": 1275
                          }
                        ]
                      },
                      "text": "।",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 239,
                        "y": 1274
                      },
                      {
                        "x": 312,
                        "y": 1275
                      },
                      {
                        "x": 312,
                        "y": 1311
                      },
                      {
                        "x": 239,
                        "y": 1310
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 239,
                            "y": 1274
                          },
                          {
                            "x": 256,
                            "y": 1274
                          },
                          {
                            "x": 256,
                            "y": 1309
                          },
                          {
                            "x": 239,
                            "y": 1309
                          }
                        ]
                      },
                      "text": "भ",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 262,
                            "y": 1274
                          },
                          {
                            "x": 288,
                            "y": 1274
                          },
                          {
                            "x": 288,
                            "y": 1309
                          },
                          {
                            "x": 262,
                            "y": 1309
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 262,
                            "y": 1274
                          },
                          {
                            "x": 288,
                            "y": 1274
                          },
                          {
                            "x": 288,
                            "y": 1309
                          },
                          {
                            "x": 262,
                            "y": 1309
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 262,
                            "y": 1274
                          },
                          {
                            "x": 288,
                            "y": 1274
                          },
                          {
                            "x": 288,
                            "y": 1309
                          },
                          {
                            "x": 262,
                            "y": 1309
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 262,
                            "y": 1274
                          },
                          {
                            "x": 288,
                            "y": 1274
                          },
                          {
                            "x": 288,
                            "y": 1309
                          },
                          {
                            "x": 262,
                            "y": 1309
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 291,
                            "y": 1275
                          },
                          {
                            "x": 312,
                            "y": 1275
                          },
                          {
                            "x": 312,
                            "y": 1310
                          },
                          {
                            "x": 291,
                            "y": 1310
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 291,
                            "y": 1275
                          },
                          {
                            "x": 312,
                            "y": 1275
                          },
                          {
                            "x": 312,
                            "y": 1310
                          },
                          {
                            "x": 291,
                            "y": 1310
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 291,
                            "y": 1275
                          },
                          {
                            "x": 312,
                            "y": 1275
                          },
                          {
                            "x": 312,
                            "y": 1310
                          },
                          {
                            "x": 291,
                            "y": 1310
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 332,
                        "y": 1275
                      },
                      {
                        "x": 384,
                        "y": 1275
                      },
                      {
                        "x": 384,
                        "y": 1310
                      },
                      {
                        "x": 332,
                        "y": 1310
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 332,
                            "y": 1275
                          },
                          {
                            "x": 343,
                            "y": 1275
                          },
                          {
                            "x": 343,
                            "y": 1310
                          },
                          {
                            "x": 332,
                            "y": 1310
                          }
                        ]
                      },
                      "text": "ज",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 345,
                            "y": 1275
                          },
                          {
                            "x": 358,
                            "y": 1275
                          },
                          {
                            "x": 358,
                            "y": 1310
                          },
                          {
                            "x": 345,
                            "y": 1310
                          }
                        ]
                      },
                      "text": "प",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 363,
                            "y": 1275
                          },
                          {
                            "x": 384,
                            "y": 1275
                          },
                          {
                            "x": 384,
                            "y": 1310
                          },
                          {
                            "x": 363,
                            "y": 1310
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 1
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 363,
                            "y": 1275
                          },
                          {
                            "x": 384,
                            "y": 1275
                          },
                          {
                            "x": 384,
                            "y": 1310
                          },
                          {
                            "x": 363,
                            "y": 1310
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 1
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 363,
                            "y": 1275
                          },
                          {
                            "x": 384,
                            "y": 1275
                          },
                          {
                            "x": 384,
                            "y": 1310
                          },
                          {
                            "x": 363,
                            "y": 1310
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 1
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 395,
                        "y": 1276
                      },
                      {
                        "x": 438,
                        "y": 1276
                      },
                      {
                        "x": 438,
                        "y": 1311
                      },
                      {
                        "x": 395,
                        "y": 1311
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 395,
                            "y": 1276
                          },
                          {
                            "x": 420,
                            "y": 1276
                          },
                          {
                            "x": 420,
                            "y": 1311
                          },
                          {
                            "x": 395,
                            "y": 1311
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 395,
                            "y": 1276
                          },
                          {
                            "x": 420,
                            "y": 1276
                          },
                          {
                            "x": 420,
                            "y": 1311
                          },
                          {
                            "x": 395,
                            "y": 1311
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 424,
                            "y": 1276
                          },
                          {
                            "x": 438,
                            "y": 1276
                          },
                          {
                            "x": 438,
                            "y": 1311
                          },
                          {
                            "x": 424,
                            "y": 1311
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 1
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 449,
                        "y": 1276
                      },
                      {
                        "x": 628,
                        "y": 1278
                      },
                      {
                        "x": 628,
                        "y": 1314
                      },
                      {
                        "x": 449,
                        "y": 1312
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 449,
                            "y": 1276
                          },
                          {
                            "x": 474,
                            "y": 1276
                          },
                          {
                            "x": 474,
                            "y": 1311
                          },
                          {
                            "x": 449,
                            "y": 1311
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 1
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 449,
                            "y": 1276
                          },
                          {
                            "x": 474,
                            "y": 1276
                          },
                          {
                            "x": 474,
                            "y": 1311
                          },
                          {
                            "x": 449,
                            "y": 1311
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 1
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 449,
                            "y": 1276
                          },
                          {
                            "x": 474,
                            "y": 1276
                          },
                          {
                            "x": 474,
                            "y": 1311
                          },
                          {
                            "x": 449,
                            "y": 1311
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 1
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 478,
                            "y": 1276
                          },
                          {
                            "x": 493,
                            "y": 1276
                          },
                          {
                            "x": 493,
                            "y": 1311
                          },
                          {
                            "x": 478,
                            "y": 1311
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 478,
                            "y": 1276
                          },
                          {
                            "x": 493,
                            "y": 1276
                          },
                          {
                            "x": 493,
                            "y": 1311
                          },
                          {
                            "x": 478,
                            "y": 1311
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 478,
                            "y": 1276
                          },
                          {
                            "x": 493,
                            "y": 1276
                          },
                          {
                            "x": 493,
                            "y": 1311
                          },
                          {
                            "x": 478,
                            "y": 1311
                          }
                        ]
                      },
                      "text": "ग",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 498,
                            "y": 1277
                          },
                          {
                            "x": 522,
                            "y": 1277
                          },
                          {
                            "x": 522,
                            "y": 1312
                          },
                          {
                            "x": 498,
                            "y": 1312
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 498,
                            "y": 1277
                          },
                          {
                            "x": 522,
                            "y": 1277
                          },
                          {
                            "x": 522,
                            "y": 1312
                          },
                          {
                            "x": 498,
                            "y": 1312
                          }
                        ]
                      },
                      "text": "ो",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 528,
                            "y": 1277
                          },
                          {
                            "x": 544,
                            "y": 1277
                          },
                          {
                            "x": 544,
                            "y": 1312
                          },
                          {
                            "x": 528,
                            "y": 1312
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 528,
                            "y": 1277
                          },
                          {
                            "x": 544,
                            "y": 1277
                          },
                          {
                            "x": 544,
                            "y": 1312
                          },
                          {
                            "x": 528,
                            "y": 1312
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 528,
                            "y": 1277
                          },
                          {
                            "x": 544,
                            "y": 1277
                          },
                          {
                            "x": 544,
                            "y": 1312
                          },
                          {
                            "x": 528,
                            "y": 1312
                          }
                        ]
                      },
                      "text": "ष",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 545,
                            "y": 1277
                          },
                          {
                            "x": 562,
                            "y": 1277
                          },
                          {
                            "x": 562,
                            "y": 1312
                          },
                          {
                            "x": 545,
                            "y": 1312
                          }
                        ]
                      },
                      "text": "फ",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 570,
                            "y": 1277
                          },
                          {
                            "x": 587,
                            "y": 1277
                          },
                          {
                            "x": 587,
                            "y": 1312
                          },
                          {
                            "x": 570,
                            "y": 1312
                          }
                        ]
                      },
                      "text": "ल",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 590,
                            "y": 1277
                          },
                          {
                            "x": 603,
                            "y": 1277
                          },
                          {
                            "x": 603,
                            "y": 1312
                          },
                          {
                            "x": 590,
                            "y": 1312
                          }
                        ]
                      },
                      "text": "प",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 590,
                            "y": 1277
                          },
                          {
                            "x": 603,
                            "y": 1277
                          },
                          {
                            "x": 603,
                            "y": 1312
                          },
                          {
                            "x": 590,
                            "y": 1312
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 590,
                            "y": 1277
                          },
                          {
                            "x": 603,
                            "y": 1277
                          },
                          {
                            "x": 603,
                            "y": 1312
                          },
                          {
                            "x": 590,
                            "y": 1312
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 606,
                            "y": 1278
                          },
                          {
                            "x": 628,
                            "y": 1278
                          },
                          {
                            "x": 628,
                            "y": 1313
                          },
                          {
                            "x": 606,
                            "y": 1313
                          }
                        ]
                      },
                      "text": "द",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 606,
                            "y": 1278
                          },
                          {
                            "x": 628,
                            "y": 1278
                          },
                          {
                            "x": 628,
                            "y": 1313
                          },
                          {
                            "x": 606,
                            "y": 1313
                          }
                        ]
                      },
                      "text": "ः",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 639,
                        "y": 1278
                      },
                      {
                        "x": 648,
                        "y": 1278
                      },
                      {
                        "x": 648,
                        "y": 1313
                      },
                      {
                        "x": 639,
                        "y": 1313
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 639,
                            "y": 1278
                          },
                          {
                            "x": 648,
                            "y": 1278
                          },
                          {
                            "x": 648,
                            "y": 1313
                          },
                          {
                            "x": 639,
                            "y": 1313
                          }
                        ]
                      },
                      "text": "।",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 653,
                        "y": 1278
                      },
                      {
                        "x": 662,
                        "y": 1278
                      },
                      {
                        "x": 662,
                        "y": 1313
                      },
                      {
                        "x": 653,
                        "y": 1313
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "EOL_SURE_SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 653,
                            "y": 1278
                          },
                          {
                            "x": 662,
                            "y": 1278
                          },
                          {
                            "x": 662,
                            "y": 1313
                          },
                          {
                            "x": 653,
                            "y": 1313
                          }
                        ]
                      },
                      "text": "।",
                      "confidence": 0.29
                    }
                  ],
                  "confidence": 0.29
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 237,
                        "y": 1322
                      },
                      {
                        "x": 300,
                        "y": 1322
                      },
                      {
                        "x": 300,
                        "y": 1362
                      },
                      {
                        "x": 237,
                        "y": 1362
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 237,
                            "y": 1322
                          },
                          {
                            "x": 250,
                            "y": 1322
                          },
                          {
                            "x": 250,
                            "y": 1362
                          },
                          {
                            "x": 237,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 237,
                            "y": 1322
                          },
                          {
                            "x": 250,
                            "y": 1322
                          },
                          {
                            "x": 250,
                            "y": 1362
                          },
                          {
                            "x": 237,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "े",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 254,
                            "y": 1322
                          },
                          {
                            "x": 275,
                            "y": 1322
                          },
                          {
                            "x": 275,
                            "y": 1362
                          },
                          {
                            "x": 254,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "द",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 254,
                            "y": 1322
                          },
                          {
                            "x": 275,
                            "y": 1322
                          },
                          {
                            "x": 275,
                            "y": 1362
                          },
                          {
                            "x": 254,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 278,
                            "y": 1322
                          },
                          {
                            "x": 300,
                            "y": 1322
                          },
                          {
                            "x": 300,
                            "y": 1362
                          },
                          {
                            "x": 278,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 278,
                            "y": 1322
                          },
                          {
                            "x": 300,
                            "y": 1322
                          },
                          {
                            "x": 300,
                            "y": 1362
                          },
                          {
                            "x": 278,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 278,
                            "y": 1322
                          },
                          {
                            "x": 300,
                            "y": 1322
                          },
                          {
                            "x": 300,
                            "y": 1362
                          },
                          {
                            "x": 278,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 309,
                        "y": 1322
                      },
                      {
                        "x": 398,
                        "y": 1322
                      },
                      {
                        "x": 398,
                        "y": 1362
                      },
                      {
                        "x": 309,
                        "y": 1362
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 309,
                            "y": 1322
                          },
                          {
                            "x": 326,
                            "y": 1322
                          },
                          {
                            "x": 326,
                            "y": 1362
                          },
                          {
                            "x": 309,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "प",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 309,
                            "y": 1322
                          },
                          {
                            "x": 326,
                            "y": 1322
                          },
                          {
                            "x": 326,
                            "y": 1362
                          },
                          {
                            "x": 309,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 309,
                            "y": 1322
                          },
                          {
                            "x": 326,
                            "y": 1322
                          },
                          {
                            "x": 326,
                            "y": 1362
                          },
                          {
                            "x": 309,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 331,
                            "y": 1322
                          },
                          {
                            "x": 346,
                            "y": 1322
                          },
                          {
                            "x": 346,
                            "y": 1362
                          },
                          {
                            "x": 331,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "ण",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 347,
                            "y": 1322
                          },
                          {
                            "x": 362,
                            "y": 1322
                          },
                          {
                            "x": 362,
                            "y": 1362
                          },
                          {
                            "x": 347,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 347,
                            "y": 1322
                          },
                          {
                            "x": 362,
                            "y": 1322
                          },
                          {
                            "x": 362,
                            "y": 1362
                          },
                          {
                            "x": 347,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "े",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 368,
                            "y": 1322
                          },
                          {
                            "x": 383,
                            "y": 1322
                          },
                          {
                            "x": 383,
                            "y": 1362
                          },
                          {
                            "x": 368,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 368,
                            "y": 1322
                          },
                          {
                            "x": 383,
                            "y": 1322
                          },
                          {
                            "x": 383,
                            "y": 1362
                          },
                          {
                            "x": 368,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "ै",
                      "confidence": 0.93
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 385,
                            "y": 1322
                          },
                          {
                            "x": 398,
                            "y": 1322
                          },
                          {
                            "x": 398,
                            "y": 1362
                          },
                          {
                            "x": 385,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "ष",
                      "confidence": 0.95
                    }
                  ],
                  "confidence": 0.96
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 399,
                        "y": 1322
                      },
                      {
                        "x": 461,
                        "y": 1322
                      },
                      {
                        "x": 461,
                        "y": 1362
                      },
                      {
                        "x": 399,
                        "y": 1362
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 399,
                            "y": 1322
                          },
                          {
                            "x": 432,
                            "y": 1322
                          },
                          {
                            "x": 432,
                            "y": 1362
                          },
                          {
                            "x": 399,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 399,
                            "y": 1322
                          },
                          {
                            "x": 432,
                            "y": 1322
                          },
                          {
                            "x": 432,
                            "y": 1362
                          },
                          {
                            "x": 399,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "ि",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 436,
                            "y": 1322
                          },
                          {
                            "x": 461,
                            "y": 1322
                          },
                          {
                            "x": 461,
                            "y": 1362
                          },
                          {
                            "x": 436,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "द",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 436,
                            "y": 1322
                          },
                          {
                            "x": 461,
                            "y": 1322
                          },
                          {
                            "x": 461,
                            "y": 1362
                          },
                          {
                            "x": 436,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 436,
                            "y": 1322
                          },
                          {
                            "x": 461,
                            "y": 1322
                          },
                          {
                            "x": 461,
                            "y": 1362
                          },
                          {
                            "x": 436,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "ध",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 436,
                            "y": 1322
                          },
                          {
                            "x": 461,
                            "y": 1322
                          },
                          {
                            "x": 461,
                            "y": 1362
                          },
                          {
                            "x": 436,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "ो",
                      "confidence": 0.97
                    }
                  ],
                  "confidence": 0.96
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 477,
                        "y": 1322
                      },
                      {
                        "x": 523,
                        "y": 1322
                      },
                      {
                        "x": 523,
                        "y": 1362
                      },
                      {
                        "x": 477,
                        "y": 1362
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 477,
                            "y": 1322
                          },
                          {
                            "x": 486,
                            "y": 1322
                          },
                          {
                            "x": 486,
                            "y": 1362
                          },
                          {
                            "x": 477,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 489,
                            "y": 1322
                          },
                          {
                            "x": 523,
                            "y": 1322
                          },
                          {
                            "x": 523,
                            "y": 1362
                          },
                          {
                            "x": 489,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 489,
                            "y": 1322
                          },
                          {
                            "x": 523,
                            "y": 1322
                          },
                          {
                            "x": 523,
                            "y": 1362
                          },
                          {
                            "x": 489,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 489,
                            "y": 1322
                          },
                          {
                            "x": 523,
                            "y": 1322
                          },
                          {
                            "x": 523,
                            "y": 1362
                          },
                          {
                            "x": 489,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 489,
                            "y": 1322
                          },
                          {
                            "x": 523,
                            "y": 1322
                          },
                          {
                            "x": 523,
                            "y": 1362
                          },
                          {
                            "x": 489,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 489,
                            "y": 1322
                          },
                          {
                            "x": 523,
                            "y": 1322
                          },
                          {
                            "x": 523,
                            "y": 1362
                          },
                          {
                            "x": 489,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 489,
                            "y": 1322
                          },
                          {
                            "x": 523,
                            "y": 1322
                          },
                          {
                            "x": 523,
                            "y": 1362
                          },
                          {
                            "x": 489,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "ः",
                      "confidence": 0.97
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 535,
                        "y": 1322
                      },
                      {
                        "x": 625,
                        "y": 1322
                      },
                      {
                        "x": 625,
                        "y": 1362
                      },
                      {
                        "x": 535,
                        "y": 1362
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 535,
                            "y": 1322
                          },
                          {
                            "x": 551,
                            "y": 1322
                          },
                          {
                            "x": 551,
                            "y": 1362
                          },
                          {
                            "x": 535,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 556,
                            "y": 1322
                          },
                          {
                            "x": 579,
                            "y": 1322
                          },
                          {
                            "x": 579,
                            "y": 1362
                          },
                          {
                            "x": 556,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 556,
                            "y": 1322
                          },
                          {
                            "x": 579,
                            "y": 1322
                          },
                          {
                            "x": 579,
                            "y": 1362
                          },
                          {
                            "x": 556,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 581,
                            "y": 1322
                          },
                          {
                            "x": 596,
                            "y": 1322
                          },
                          {
                            "x": 596,
                            "y": 1362
                          },
                          {
                            "x": 581,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 600,
                            "y": 1322
                          },
                          {
                            "x": 625,
                            "y": 1322
                          },
                          {
                            "x": 625,
                            "y": 1362
                          },
                          {
                            "x": 600,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 600,
                            "y": 1322
                          },
                          {
                            "x": 625,
                            "y": 1322
                          },
                          {
                            "x": 625,
                            "y": 1362
                          },
                          {
                            "x": 600,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "ः",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 644,
                        "y": 1322
                      },
                      {
                        "x": 655,
                        "y": 1322
                      },
                      {
                        "x": 655,
                        "y": 1362
                      },
                      {
                        "x": 644,
                        "y": 1362
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 644,
                            "y": 1322
                          },
                          {
                            "x": 655,
                            "y": 1322
                          },
                          {
                            "x": 655,
                            "y": 1362
                          },
                          {
                            "x": 644,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "॥",
                      "confidence": 0.96
                    }
                  ],
                  "confidence": 0.96
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 669,
                        "y": 1322
                      },
                      {
                        "x": 680,
                        "y": 1322
                      },
                      {
                        "x": 680,
                        "y": 1362
                      },
                      {
                        "x": 669,
                        "y": 1362
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 669,
                            "y": 1322
                          },
                          {
                            "x": 680,
                            "y": 1322
                          },
                          {
                            "x": 680,
                            "y": 1362
                          },
                          {
                            "x": 669,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "८",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 693,
                        "y": 1322
                      },
                      {
                        "x": 704,
                        "y": 1322
                      },
                      {
                        "x": 704,
                        "y": 1362
                      },
                      {
                        "x": 693,
                        "y": 1362
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "EOL_SURE_SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 693,
                            "y": 1322
                          },
                          {
                            "x": 704,
                            "y": 1322
                          },
                          {
                            "x": 704,
                            "y": 1362
                          },
                          {
                            "x": 693,
                            "y": 1362
                          }
                        ]
                      },
                      "text": "॥",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 239,
                        "y": 1378
                      },
                      {
                        "x": 353,
                        "y": 1378
                      },
                      {
                        "x": 353,
                        "y": 1418
                      },
                      {
                        "x": 239,
                        "y": 1418
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 239,
                            "y": 1378
                          },
                          {
                            "x": 252,
                            "y": 1378
                          },
                          {
                            "x": 252,
                            "y": 1418
                          },
                          {
                            "x": 239,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 256,
                            "y": 1378
                          },
                          {
                            "x": 269,
                            "y": 1378
                          },
                          {
                            "x": 269,
                            "y": 1418
                          },
                          {
                            "x": 256,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 256,
                            "y": 1378
                          },
                          {
                            "x": 269,
                            "y": 1378
                          },
                          {
                            "x": 269,
                            "y": 1418
                          },
                          {
                            "x": 256,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 256,
                            "y": 1378
                          },
                          {
                            "x": 269,
                            "y": 1378
                          },
                          {
                            "x": 269,
                            "y": 1418
                          },
                          {
                            "x": 256,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 272,
                            "y": 1378
                          },
                          {
                            "x": 293,
                            "y": 1378
                          },
                          {
                            "x": 293,
                            "y": 1418
                          },
                          {
                            "x": 272,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "प",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 272,
                            "y": 1378
                          },
                          {
                            "x": 293,
                            "y": 1378
                          },
                          {
                            "x": 293,
                            "y": 1418
                          },
                          {
                            "x": 272,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.94
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 297,
                            "y": 1378
                          },
                          {
                            "x": 310,
                            "y": 1378
                          },
                          {
                            "x": 310,
                            "y": 1418
                          },
                          {
                            "x": 297,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "प",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 314,
                            "y": 1378
                          },
                          {
                            "x": 325,
                            "y": 1378
                          },
                          {
                            "x": 325,
                            "y": 1418
                          },
                          {
                            "x": 314,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "ह",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 327,
                            "y": 1378
                          },
                          {
                            "x": 353,
                            "y": 1378
                          },
                          {
                            "x": 353,
                            "y": 1418
                          },
                          {
                            "x": 327,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 327,
                            "y": 1378
                          },
                          {
                            "x": 353,
                            "y": 1378
                          },
                          {
                            "x": 353,
                            "y": 1418
                          },
                          {
                            "x": 327,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "ः",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.96
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 365,
                        "y": 1378
                      },
                      {
                        "x": 439,
                        "y": 1378
                      },
                      {
                        "x": 439,
                        "y": 1418
                      },
                      {
                        "x": 365,
                        "y": 1418
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 365,
                            "y": 1378
                          },
                          {
                            "x": 389,
                            "y": 1378
                          },
                          {
                            "x": 389,
                            "y": 1418
                          },
                          {
                            "x": 365,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "श",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 365,
                            "y": 1378
                          },
                          {
                            "x": 389,
                            "y": 1378
                          },
                          {
                            "x": 389,
                            "y": 1418
                          },
                          {
                            "x": 365,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 365,
                            "y": 1378
                          },
                          {
                            "x": 389,
                            "y": 1378
                          },
                          {
                            "x": 389,
                            "y": 1418
                          },
                          {
                            "x": 365,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 365,
                            "y": 1378
                          },
                          {
                            "x": 389,
                            "y": 1378
                          },
                          {
                            "x": 389,
                            "y": 1418
                          },
                          {
                            "x": 365,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "ी",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 393,
                            "y": 1378
                          },
                          {
                            "x": 417,
                            "y": 1378
                          },
                          {
                            "x": 417,
                            "y": 1418
                          },
                          {
                            "x": 393,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 393,
                            "y": 1378
                          },
                          {
                            "x": 417,
                            "y": 1378
                          },
                          {
                            "x": 417,
                            "y": 1418
                          },
                          {
                            "x": 393,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 422,
                            "y": 1378
                          },
                          {
                            "x": 439,
                            "y": 1378
                          },
                          {
                            "x": 439,
                            "y": 1418
                          },
                          {
                            "x": 422,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 422,
                            "y": 1378
                          },
                          {
                            "x": 439,
                            "y": 1378
                          },
                          {
                            "x": 439,
                            "y": 1418
                          },
                          {
                            "x": 422,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 449,
                        "y": 1378
                      },
                      {
                        "x": 539,
                        "y": 1378
                      },
                      {
                        "x": 539,
                        "y": 1418
                      },
                      {
                        "x": 449,
                        "y": 1418
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 449,
                            "y": 1378
                          },
                          {
                            "x": 462,
                            "y": 1378
                          },
                          {
                            "x": 462,
                            "y": 1418
                          },
                          {
                            "x": 449,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 464,
                            "y": 1378
                          },
                          {
                            "x": 478,
                            "y": 1378
                          },
                          {
                            "x": 478,
                            "y": 1418
                          },
                          {
                            "x": 464,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 464,
                            "y": 1378
                          },
                          {
                            "x": 478,
                            "y": 1378
                          },
                          {
                            "x": 478,
                            "y": 1418
                          },
                          {
                            "x": 464,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 464,
                            "y": 1378
                          },
                          {
                            "x": 478,
                            "y": 1378
                          },
                          {
                            "x": 478,
                            "y": 1418
                          },
                          {
                            "x": 464,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 484,
                            "y": 1378
                          },
                          {
                            "x": 499,
                            "y": 1378
                          },
                          {
                            "x": 499,
                            "y": 1418
                          },
                          {
                            "x": 484,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 502,
                            "y": 1378
                          },
                          {
                            "x": 523,
                            "y": 1378
                          },
                          {
                            "x": 523,
                            "y": 1418
                          },
                          {
                            "x": 502,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 502,
                            "y": 1378
                          },
                          {
                            "x": 523,
                            "y": 1378
                          },
                          {
                            "x": 523,
                            "y": 1418
                          },
                          {
                            "x": 502,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 502,
                            "y": 1378
                          },
                          {
                            "x": 523,
                            "y": 1378
                          },
                          {
                            "x": 523,
                            "y": 1418
                          },
                          {
                            "x": 502,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 502,
                            "y": 1378
                          },
                          {
                            "x": 523,
                            "y": 1378
                          },
                          {
                            "x": 523,
                            "y": 1418
                          },
                          {
                            "x": 502,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 502,
                            "y": 1378
                          },
                          {
                            "x": 523,
                            "y": 1378
                          },
                          {
                            "x": 523,
                            "y": 1418
                          },
                          {
                            "x": 502,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 502,
                            "y": 1378
                          },
                          {
                            "x": 523,
                            "y": 1378
                          },
                          {
                            "x": 523,
                            "y": 1418
                          },
                          {
                            "x": 502,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "े",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 526,
                            "y": 1378
                          },
                          {
                            "x": 539,
                            "y": 1378
                          },
                          {
                            "x": 539,
                            "y": 1418
                          },
                          {
                            "x": 526,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "ष",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 526,
                            "y": 1378
                          },
                          {
                            "x": 539,
                            "y": 1378
                          },
                          {
                            "x": 539,
                            "y": 1418
                          },
                          {
                            "x": 526,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "ु",
                      "confidence": 0.95
                    }
                  ],
                  "confidence": 0.96
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 553,
                        "y": 1378
                      },
                      {
                        "x": 631,
                        "y": 1378
                      },
                      {
                        "x": 631,
                        "y": 1418
                      },
                      {
                        "x": 553,
                        "y": 1418
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 553,
                            "y": 1378
                          },
                          {
                            "x": 578,
                            "y": 1378
                          },
                          {
                            "x": 578,
                            "y": 1418
                          },
                          {
                            "x": 553,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "च",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 553,
                            "y": 1378
                          },
                          {
                            "x": 578,
                            "y": 1378
                          },
                          {
                            "x": 578,
                            "y": 1418
                          },
                          {
                            "x": 553,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "ो",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 582,
                            "y": 1378
                          },
                          {
                            "x": 598,
                            "y": 1378
                          },
                          {
                            "x": 598,
                            "y": 1418
                          },
                          {
                            "x": 582,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 582,
                            "y": 1378
                          },
                          {
                            "x": 598,
                            "y": 1378
                          },
                          {
                            "x": 598,
                            "y": 1418
                          },
                          {
                            "x": 582,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 582,
                            "y": 1378
                          },
                          {
                            "x": 598,
                            "y": 1378
                          },
                          {
                            "x": 598,
                            "y": 1418
                          },
                          {
                            "x": 582,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 602,
                            "y": 1378
                          },
                          {
                            "x": 631,
                            "y": 1378
                          },
                          {
                            "x": 631,
                            "y": 1418
                          },
                          {
                            "x": 602,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 602,
                            "y": 1378
                          },
                          {
                            "x": 631,
                            "y": 1378
                          },
                          {
                            "x": 631,
                            "y": 1418
                          },
                          {
                            "x": 602,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "ः",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 638,
                        "y": 1378
                      },
                      {
                        "x": 649,
                        "y": 1378
                      },
                      {
                        "x": 649,
                        "y": 1418
                      },
                      {
                        "x": 638,
                        "y": 1418
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "EOL_SURE_SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 638,
                            "y": 1378
                          },
                          {
                            "x": 649,
                            "y": 1378
                          },
                          {
                            "x": 649,
                            "y": 1418
                          },
                          {
                            "x": 638,
                            "y": 1418
                          }
                        ]
                      },
                      "text": "।",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 236,
                        "y": 1423
                      },
                      {
                        "x": 340,
                        "y": 1423
                      },
                      {
                        "x": 340,
                        "y": 1466
                      },
                      {
                        "x": 236,
                        "y": 1466
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 236,
                            "y": 1423
                          },
                          {
                            "x": 250,
                            "y": 1423
                          },
                          {
                            "x": 250,
                            "y": 1466
                          },
                          {
                            "x": 236,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "ए",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 254,
                            "y": 1423
                          },
                          {
                            "x": 267,
                            "y": 1423
                          },
                          {
                            "x": 267,
                            "y": 1466
                          },
                          {
                            "x": 254,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 271,
                            "y": 1423
                          },
                          {
                            "x": 285,
                            "y": 1423
                          },
                          {
                            "x": 285,
                            "y": 1466
                          },
                          {
                            "x": 271,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 289,
                            "y": 1423
                          },
                          {
                            "x": 311,
                            "y": 1423
                          },
                          {
                            "x": 311,
                            "y": 1466
                          },
                          {
                            "x": 289,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "ष",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 289,
                            "y": 1423
                          },
                          {
                            "x": 311,
                            "y": 1423
                          },
                          {
                            "x": 311,
                            "y": 1466
                          },
                          {
                            "x": 289,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 289,
                            "y": 1423
                          },
                          {
                            "x": 311,
                            "y": 1423
                          },
                          {
                            "x": 311,
                            "y": 1466
                          },
                          {
                            "x": 289,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "ट",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 289,
                            "y": 1423
                          },
                          {
                            "x": 311,
                            "y": 1423
                          },
                          {
                            "x": 311,
                            "y": 1466
                          },
                          {
                            "x": 289,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 315,
                            "y": 1423
                          },
                          {
                            "x": 328,
                            "y": 1423
                          },
                          {
                            "x": 328,
                            "y": 1466
                          },
                          {
                            "x": 315,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "क",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 315,
                            "y": 1423
                          },
                          {
                            "x": 328,
                            "y": 1423
                          },
                          {
                            "x": 328,
                            "y": 1466
                          },
                          {
                            "x": 315,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 315,
                            "y": 1423
                          },
                          {
                            "x": 328,
                            "y": 1423
                          },
                          {
                            "x": 328,
                            "y": 1466
                          },
                          {
                            "x": 315,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "ष",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 330,
                            "y": 1423
                          },
                          {
                            "x": 340,
                            "y": 1423
                          },
                          {
                            "x": 340,
                            "y": 1466
                          },
                          {
                            "x": 330,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 330,
                            "y": 1423
                          },
                          {
                            "x": 340,
                            "y": 1423
                          },
                          {
                            "x": 340,
                            "y": 1466
                          },
                          {
                            "x": 330,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.96
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 360,
                        "y": 1423
                      },
                      {
                        "x": 393,
                        "y": 1423
                      },
                      {
                        "x": 393,
                        "y": 1466
                      },
                      {
                        "x": 360,
                        "y": 1466
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 360,
                            "y": 1423
                          },
                          {
                            "x": 371,
                            "y": 1423
                          },
                          {
                            "x": 371,
                            "y": 1466
                          },
                          {
                            "x": 360,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 374,
                            "y": 1423
                          },
                          {
                            "x": 393,
                            "y": 1423
                          },
                          {
                            "x": 393,
                            "y": 1466
                          },
                          {
                            "x": 374,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 374,
                            "y": 1423
                          },
                          {
                            "x": 393,
                            "y": 1423
                          },
                          {
                            "x": 393,
                            "y": 1466
                          },
                          {
                            "x": 374,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 374,
                            "y": 1423
                          },
                          {
                            "x": 393,
                            "y": 1423
                          },
                          {
                            "x": 393,
                            "y": 1466
                          },
                          {
                            "x": 374,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 374,
                            "y": 1423
                          },
                          {
                            "x": 393,
                            "y": 1423
                          },
                          {
                            "x": 393,
                            "y": 1466
                          },
                          {
                            "x": 374,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 374,
                            "y": 1423
                          },
                          {
                            "x": 393,
                            "y": 1423
                          },
                          {
                            "x": 393,
                            "y": 1466
                          },
                          {
                            "x": 374,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 374,
                            "y": 1423
                          },
                          {
                            "x": 393,
                            "y": 1423
                          },
                          {
                            "x": 393,
                            "y": 1466
                          },
                          {
                            "x": 374,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.96
                    }
                  ],
                  "confidence": 0.96
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 412,
                        "y": 1423
                      },
                      {
                        "x": 533,
                        "y": 1423
                      },
                      {
                        "x": 533,
                        "y": 1466
                      },
                      {
                        "x": 412,
                        "y": 1466
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 412,
                            "y": 1423
                          },
                          {
                            "x": 426,
                            "y": 1423
                          },
                          {
                            "x": 426,
                            "y": 1466
                          },
                          {
                            "x": 412,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "ज",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 429,
                            "y": 1423
                          },
                          {
                            "x": 444,
                            "y": 1423
                          },
                          {
                            "x": 444,
                            "y": 1466
                          },
                          {
                            "x": 429,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "प",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 450,
                            "y": 1423
                          },
                          {
                            "x": 472,
                            "y": 1423
                          },
                          {
                            "x": 472,
                            "y": 1466
                          },
                          {
                            "x": 450,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 450,
                            "y": 1423
                          },
                          {
                            "x": 472,
                            "y": 1423
                          },
                          {
                            "x": 472,
                            "y": 1466
                          },
                          {
                            "x": 450,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 450,
                            "y": 1423
                          },
                          {
                            "x": 472,
                            "y": 1423
                          },
                          {
                            "x": 472,
                            "y": 1466
                          },
                          {
                            "x": 450,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 450,
                            "y": 1423
                          },
                          {
                            "x": 472,
                            "y": 1423
                          },
                          {
                            "x": 472,
                            "y": 1466
                          },
                          {
                            "x": 450,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 477,
                            "y": 1423
                          },
                          {
                            "x": 493,
                            "y": 1423
                          },
                          {
                            "x": 493,
                            "y": 1466
                          },
                          {
                            "x": 477,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 477,
                            "y": 1423
                          },
                          {
                            "x": 493,
                            "y": 1423
                          },
                          {
                            "x": 493,
                            "y": 1466
                          },
                          {
                            "x": 477,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 495,
                            "y": 1423
                          },
                          {
                            "x": 510,
                            "y": 1423
                          },
                          {
                            "x": 510,
                            "y": 1466
                          },
                          {
                            "x": 495,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 516,
                            "y": 1423
                          },
                          {
                            "x": 533,
                            "y": 1423
                          },
                          {
                            "x": 533,
                            "y": 1466
                          },
                          {
                            "x": 516,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "ण",
                      "confidence": 0.95
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 516,
                            "y": 1423
                          },
                          {
                            "x": 533,
                            "y": 1423
                          },
                          {
                            "x": 533,
                            "y": 1466
                          },
                          {
                            "x": 516,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.95
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 545,
                        "y": 1423
                      },
                      {
                        "x": 608,
                        "y": 1423
                      },
                      {
                        "x": 608,
                        "y": 1466
                      },
                      {
                        "x": 545,
                        "y": 1466
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 545,
                            "y": 1423
                          },
                          {
                            "x": 569,
                            "y": 1423
                          },
                          {
                            "x": 569,
                            "y": 1466
                          },
                          {
                            "x": 545,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 545,
                            "y": 1423
                          },
                          {
                            "x": 569,
                            "y": 1423
                          },
                          {
                            "x": 569,
                            "y": 1466
                          },
                          {
                            "x": 545,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 545,
                            "y": 1423
                          },
                          {
                            "x": 569,
                            "y": 1423
                          },
                          {
                            "x": 569,
                            "y": 1466
                          },
                          {
                            "x": 545,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 570,
                            "y": 1423
                          },
                          {
                            "x": 584,
                            "y": 1423
                          },
                          {
                            "x": 584,
                            "y": 1466
                          },
                          {
                            "x": 570,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 570,
                            "y": 1423
                          },
                          {
                            "x": 584,
                            "y": 1423
                          },
                          {
                            "x": 584,
                            "y": 1466
                          },
                          {
                            "x": 570,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "े",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 591,
                            "y": 1423
                          },
                          {
                            "x": 608,
                            "y": 1423
                          },
                          {
                            "x": 608,
                            "y": 1466
                          },
                          {
                            "x": 591,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 591,
                            "y": 1423
                          },
                          {
                            "x": 608,
                            "y": 1423
                          },
                          {
                            "x": 608,
                            "y": 1466
                          },
                          {
                            "x": 591,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 624,
                        "y": 1423
                      },
                      {
                        "x": 636,
                        "y": 1423
                      },
                      {
                        "x": 636,
                        "y": 1466
                      },
                      {
                        "x": 624,
                        "y": 1466
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 624,
                            "y": 1423
                          },
                          {
                            "x": 636,
                            "y": 1423
                          },
                          {
                            "x": 636,
                            "y": 1466
                          },
                          {
                            "x": 624,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "॥",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 646,
                        "y": 1423
                      },
                      {
                        "x": 658,
                        "y": 1423
                      },
                      {
                        "x": 658,
                        "y": 1466
                      },
                      {
                        "x": 646,
                        "y": 1466
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 646,
                            "y": 1423
                          },
                          {
                            "x": 658,
                            "y": 1423
                          },
                          {
                            "x": 658,
                            "y": 1466
                          },
                          {
                            "x": 646,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "९",
                      "confidence": 0.96
                    }
                  ],
                  "confidence": 0.96
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "ne"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 672,
                        "y": 1423
                      },
                      {
                        "x": 684,
                        "y": 1423
                      },
                      {
                        "x": 684,
                        "y": 1466
                      },
                      {
                        "x": 672,
                        "y": 1466
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "ne"
                          }
                        ],
                        "detectedBreak": {
                          "type": "EOL_SURE_SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 672,
                            "y": 1423
                          },
                          {
                            "x": 684,
                            "y": 1423
                          },
                          {
                            "x": 684,
                            "y": 1466
                          },
                          {
                            "x": 672,
                            "y": 1466
                          }
                        ]
                      },
                      "text": "॥",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 242,
                        "y": 1479
                      },
                      {
                        "x": 356,
                        "y": 1479
                      },
                      {
                        "x": 356,
                        "y": 1520
                      },
                      {
                        "x": 242,
                        "y": 1520
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 242,
                            "y": 1479
                          },
                          {
                            "x": 255,
                            "y": 1479
                          },
                          {
                            "x": 255,
                            "y": 1520
                          },
                          {
                            "x": 242,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 242,
                            "y": 1479
                          },
                          {
                            "x": 255,
                            "y": 1479
                          },
                          {
                            "x": 255,
                            "y": 1520
                          },
                          {
                            "x": 242,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 259,
                            "y": 1479
                          },
                          {
                            "x": 293,
                            "y": 1479
                          },
                          {
                            "x": 293,
                            "y": 1520
                          },
                          {
                            "x": 259,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "ध",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 259,
                            "y": 1479
                          },
                          {
                            "x": 293,
                            "y": 1479
                          },
                          {
                            "x": 293,
                            "y": 1520
                          },
                          {
                            "x": 259,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 259,
                            "y": 1479
                          },
                          {
                            "x": 293,
                            "y": 1479
                          },
                          {
                            "x": 293,
                            "y": 1520
                          },
                          {
                            "x": 259,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 259,
                            "y": 1479
                          },
                          {
                            "x": 293,
                            "y": 1479
                          },
                          {
                            "x": 293,
                            "y": 1520
                          },
                          {
                            "x": 259,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 296,
                            "y": 1479
                          },
                          {
                            "x": 311,
                            "y": 1479
                          },
                          {
                            "x": 311,
                            "y": 1520
                          },
                          {
                            "x": 296,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 317,
                            "y": 1479
                          },
                          {
                            "x": 340,
                            "y": 1479
                          },
                          {
                            "x": 340,
                            "y": 1520
                          },
                          {
                            "x": 317,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 317,
                            "y": 1479
                          },
                          {
                            "x": 340,
                            "y": 1479
                          },
                          {
                            "x": 340,
                            "y": 1520
                          },
                          {
                            "x": 317,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 343,
                            "y": 1479
                          },
                          {
                            "x": 356,
                            "y": 1479
                          },
                          {
                            "x": 356,
                            "y": 1520
                          },
                          {
                            "x": 343,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "न",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 343,
                            "y": 1479
                          },
                          {
                            "x": 356,
                            "y": 1479
                          },
                          {
                            "x": 356,
                            "y": 1520
                          },
                          {
                            "x": 343,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "े",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 372,
                        "y": 1479
                      },
                      {
                        "x": 419,
                        "y": 1479
                      },
                      {
                        "x": 419,
                        "y": 1520
                      },
                      {
                        "x": 372,
                        "y": 1520
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 372,
                            "y": 1479
                          },
                          {
                            "x": 385,
                            "y": 1479
                          },
                          {
                            "x": 385,
                            "y": 1520
                          },
                          {
                            "x": 372,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 389,
                            "y": 1479
                          },
                          {
                            "x": 402,
                            "y": 1479
                          },
                          {
                            "x": 402,
                            "y": 1520
                          },
                          {
                            "x": 389,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 406,
                            "y": 1479
                          },
                          {
                            "x": 419,
                            "y": 1479
                          },
                          {
                            "x": 419,
                            "y": 1520
                          },
                          {
                            "x": 406,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.96
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 406,
                            "y": 1479
                          },
                          {
                            "x": 419,
                            "y": 1479
                          },
                          {
                            "x": 419,
                            "y": 1520
                          },
                          {
                            "x": 406,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "ं",
                      "confidence": 0.96
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 435,
                        "y": 1479
                      },
                      {
                        "x": 520,
                        "y": 1479
                      },
                      {
                        "x": 520,
                        "y": 1520
                      },
                      {
                        "x": 435,
                        "y": 1520
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 435,
                            "y": 1479
                          },
                          {
                            "x": 448,
                            "y": 1479
                          },
                          {
                            "x": 448,
                            "y": 1520
                          },
                          {
                            "x": 435,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "स",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 452,
                            "y": 1479
                          },
                          {
                            "x": 465,
                            "y": 1479
                          },
                          {
                            "x": 465,
                            "y": 1520
                          },
                          {
                            "x": 452,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 452,
                            "y": 1479
                          },
                          {
                            "x": 465,
                            "y": 1479
                          },
                          {
                            "x": 465,
                            "y": 1520
                          },
                          {
                            "x": 452,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 452,
                            "y": 1479
                          },
                          {
                            "x": 465,
                            "y": 1479
                          },
                          {
                            "x": 465,
                            "y": 1520
                          },
                          {
                            "x": 452,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "व",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 469,
                            "y": 1479
                          },
                          {
                            "x": 490,
                            "y": 1479
                          },
                          {
                            "x": 490,
                            "y": 1520
                          },
                          {
                            "x": 469,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "प",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 469,
                            "y": 1479
                          },
                          {
                            "x": 490,
                            "y": 1479
                          },
                          {
                            "x": 490,
                            "y": 1520
                          },
                          {
                            "x": 469,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "ा",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 494,
                            "y": 1479
                          },
                          {
                            "x": 520,
                            "y": 1479
                          },
                          {
                            "x": 520,
                            "y": 1520
                          },
                          {
                            "x": 494,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "प",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 494,
                            "y": 1479
                          },
                          {
                            "x": 520,
                            "y": 1479
                          },
                          {
                            "x": 520,
                            "y": 1520
                          },
                          {
                            "x": 494,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "ै",
                      "confidence": 0.97
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 494,
                            "y": 1479
                          },
                          {
                            "x": 520,
                            "y": 1479
                          },
                          {
                            "x": 520,
                            "y": 1520
                          },
                          {
                            "x": 494,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "ः",
                      "confidence": 0.97
                    }
                  ],
                  "confidence": 0.97
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 528,
                        "y": 1479
                      },
                      {
                        "x": 612,
                        "y": 1479
                      },
                      {
                        "x": 612,
                        "y": 1520
                      },
                      {
                        "x": 528,
                        "y": 1520
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 528,
                            "y": 1479
                          },
                          {
                            "x": 541,
                            "y": 1479
                          },
                          {
                            "x": 541,
                            "y": 1520
                          },
                          {
                            "x": 528,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "प",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 528,
                            "y": 1479
                          },
                          {
                            "x": 541,
                            "y": 1479
                          },
                          {
                            "x": 541,
                            "y": 1520
                          },
                          {
                            "x": 528,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 528,
                            "y": 1479
                          },
                          {
                            "x": 541,
                            "y": 1479
                          },
                          {
                            "x": 541,
                            "y": 1520
                          },
                          {
                            "x": 528,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "र",
                      "confidence": 0.99
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 542,
                            "y": 1479
                          },
                          {
                            "x": 559,
                            "y": 1479
                          },
                          {
                            "x": 559,
                            "y": 1520
                          },
                          {
                            "x": 542,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "म",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 542,
                            "y": 1479
                          },
                          {
                            "x": 559,
                            "y": 1479
                          },
                          {
                            "x": 559,
                            "y": 1520
                          },
                          {
                            "x": 542,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "ु",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 568,
                            "y": 1479
                          },
                          {
                            "x": 597,
                            "y": 1479
                          },
                          {
                            "x": 597,
                            "y": 1520
                          },
                          {
                            "x": 568,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "च",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 568,
                            "y": 1479
                          },
                          {
                            "x": 597,
                            "y": 1479
                          },
                          {
                            "x": 597,
                            "y": 1520
                          },
                          {
                            "x": 568,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "्",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 568,
                            "y": 1479
                          },
                          {
                            "x": 597,
                            "y": 1479
                          },
                          {
                            "x": 597,
                            "y": 1520
                          },
                          {
                            "x": 568,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "य",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ]
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 599,
                            "y": 1479
                          },
                          {
                            "x": 612,
                            "y": 1479
                          },
                          {
                            "x": 612,
                            "y": 1520
                          },
                          {
                            "x": 599,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "त",
                      "confidence": 0.98
                    },
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "SPACE"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 599,
                            "y": 1479
                          },
                          {
                            "x": 612,
                            "y": 1479
                          },
                          {
                            "x": 612,
                            "y": 1520
                          },
                          {
                            "x": 599,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "े",
                      "confidence": 0.98
                    }
                  ],
                  "confidence": 0.98
                },
                {
                  "property": {
                    "detectedLanguages": [
                      {
                        "languageCode": "mr"
                      }
                    ]
                  },
                  "boundingBox": {
                    "vertices": [
                      {
                        "x": 621,
                        "y": 1479
                      },
                      {
                        "x": 632,
                        "y": 1479
                      },
                      {
                        "x": 632,
                        "y": 1520
                      },
                      {
                        "x": 621,
                        "y": 1520
                      }
                    ]
                  },
                  "symbols": [
                    {
                      "property": {
                        "detectedLanguages": [
                          {
                            "languageCode": "mr"
                          }
                        ],
                        "detectedBreak": {
                          "type": "LINE_BREAK"
                        }
                      },
                      "boundingBox": {
                        "vertices": [
                          {
                            "x": 621,
                            "y": 1479
                          },
                          {
                            "x": 632,
                            "y": 1479
                          },
                          {
                            "x": 632,
                            "y": 1520
                          },
                          {
                            "x": 621,
                            "y": 1520
                          }
                        ]
                      },
                      "text": "।",
                      "confidence": 0.99
                    }
                  ],
                  "confidence": 0.99
                }
              ],
              "confidence": 0.96
            }
          ],
          "blockType": "TEXT",
          "confidence": 0.96
        }
      ]
    }
  ],
  "text": ".. OM namo nArAyaNAya aShTAkSharamAhAtmyaM ..\n० %20&lt;&gt;\n॥ ॐ नमो नारायणाय अष्टाक्षरमाहात्म्यं ॥\n2020-\n०%\nश्रीशुक उवाच -\nकिं जपन् मुच्यते तात सततं विष्णुतत्परः ।\nसंसारदुःखात् सर्वेषां हिताय वद मे पितः ॥ १॥\nव्यास उवाच -\nअष्टाक्षरं प्रवक्ष्यामि मन्त्राणां मन्त्रमुत्तमम् ।\nयं जपन् मुच्यते मर्यो जन्मसंसारबन्धनात् ॥ २॥\nहृत्पुण्डरीकमध्यस्थं शङ्खचक्रगदाधरम् ।\nएकाग्रमनसा ध्यात्वा विष्णुं कुर्याज्जपं द्विजः ॥ ३॥\nएकान्ते निर्जनस्थाने विष्णवग्रे वा जलान्तिके ।\nजपेदष्टाक्षरं मन्त्रं चित्ते विष्णुं निधाय वै ॥ ४॥\nअष्टाक्षरस्य मन्त्रस्य ऋषिर्नारायणः स्वयम् ।\nछन्दश्च दैवी गायत्री परमात्मा च देवता ॥ ५॥\nशुक्लवर्णं च कारं नकारं रक्तमुच्यते ।\nमोकारं वर्णतः कृष्णं नाकारं रक्तमुच्यते ॥ ६ ॥\nराकारं कुङ्कुमाभं तु यकारं पीतमुच्यते ।\nणाकारमञ्जनाभं तु यकारं बहुवर्णकम् ॥ ७॥\nॐ नमो नारायणायेति मन्त्रः सर्वार्थसाधकः ।\nभक्तानां जपतां तात स्वर्गमोक्षफलप्रदः ।।\nवेदानां प्रणवेनैष सिद्धो मन्त्रः सनातनः ॥ ८॥\nसर्वपापहरः श्रीमान् सर्वमन्त्रेषु चोत्तमः ।\nएनमष्टाक्षरं मन्त्रं जपन्नारायणं स्मरेत् ॥ ९॥\nसंध्यावसाने सततं सर्वपापैः प्रमुच्यते ।\n"
}

export default data;